var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/atoms/ItemAttributeBase/ItemAttributeBase.tsx
import { useTheme, lineClamp } from "@instacart/ids-core";
import { jsx } from "@emotion/react/jsx-runtime";
var containerStyles = /* @__PURE__ */ __name(({ theme }) => __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodySmall2), {
  color: theme.colors.systemGrayscale50
}), lineClamp(2)), "containerStyles");
function ItemAttributeBase({ children }) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx("div", { title: children, css: containerStyles({ theme }), children });
}
__name(ItemAttributeBase, "ItemAttributeBase");

// src/atoms/ItemAttribute/ItemAttribute.tsx
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
function ItemAttribute(props) {
  return /* @__PURE__ */ jsx2(ItemAttributeBase, __spreadValues({}, props));
}
__name(ItemAttribute, "ItemAttribute");

// src/atoms/ItemBase/ItemBase.tsx
import { forwardRef } from "react";
import { combineStyles as combineStyles4, CompositionValidator as CompositionValidator2 } from "@instacart/ids-core";

// src/atoms/ItemBase/validations.ts
import {
  CompositionOrderError as CompositionOrderError2,
  CompositionTooManyItemsError as CompositionTooManyItemsError2
} from "@instacart/ids-core";

// src/atoms/ItemPriceBase/ItemPriceBase.tsx
import { combineStyles, useTheme as useTheme2 } from "@instacart/ids-core";
import { jsx as jsx3 } from "@emotion/react/jsx-runtime";
var getStyles = /* @__PURE__ */ __name(({ theme }) => ({
  span: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), { color: theme.colors.systemGrayscale70 })
}), "getStyles");
function ItemPriceBase(props) {
  const { children, styles: styles25 } = props;
  const theme = useTheme2();
  const { span } = combineStyles(getStyles({ theme }), styles25);
  return /* @__PURE__ */ jsx3("span", { css: span, children });
}
__name(ItemPriceBase, "ItemPriceBase");

// src/atoms/ItemPriceSetBase/ItemPriceSetBase.tsx
import { combineStyles as combineStyles2, CompositionValidator } from "@instacart/ids-core";

// src/atoms/ItemPriceSetBase/validations.ts
import {
  CompositionOrderError,
  CompositionTooFewItemsError,
  CompositionTooManyItemsError
} from "@instacart/ids-core";

// src/atoms/ItemRegularPriceBase/ItemRegularPriceBase.tsx
import { useTheme as useTheme3 } from "@instacart/ids-core";
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
var getStyles2 = /* @__PURE__ */ __name(({ theme }) => ({
  span: __spreadProps(__spreadValues({}, theme.typography.bodySmall2), { color: theme.colors.systemGrayscale50 })
}), "getStyles");
function ItemRegularPriceBase(props) {
  const theme = useTheme3();
  const { span } = getStyles2({ theme });
  return /* @__PURE__ */ jsx4("span", { css: span, children: props.children });
}
__name(ItemRegularPriceBase, "ItemRegularPriceBase");

// src/atoms/ItemPriceSetBase/validations.ts
var validateItemPriceSet = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind, findAllByKind } = engine;
  const all = getAll();
  const firstItemPriceIndex = flatIndexOfByKind(ItemPriceBase);
  const firstItemRegularPriceIndex = flatIndexOfByKind(ItemRegularPriceBase);
  try {
    expect(findAllByKind(ItemPriceBase)).toHaveLength(1);
  } catch (e) {
    throw new CompositionTooFewItemsError(ItemPriceBase, "one and only one (required)");
  }
  if (firstItemRegularPriceIndex > -1) {
    if (firstItemPriceIndex > -1) {
      try {
        expect(firstItemPriceIndex).toBeLessThan(firstItemRegularPriceIndex);
      } catch (e) {
        throw new CompositionOrderError(all[firstItemRegularPriceIndex], all[firstItemPriceIndex]);
      }
    }
    try {
      expect(findAllByKind(ItemRegularPriceBase)).toHaveLength(1);
    } catch (e) {
      throw new CompositionTooManyItemsError(ItemRegularPriceBase, "one and only one (optional)");
    }
  }
}, "validateItemPriceSet");

// src/atoms/ItemPriceSetBase/ItemPriceSetBase.tsx
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
var getStyles3 = /* @__PURE__ */ __name(() => ({
  container: {}
}), "getStyles");
var validator = new CompositionValidator([validateItemPriceSet]);
function ItemPriceSetBase(props) {
  const _a = props, { children, styles: propStyles } = _a, rest = __objRest(_a, ["children", "styles"]);
  const styles25 = combineStyles2(getStyles3(), propStyles);
  validator.validate(children);
  return /* @__PURE__ */ jsx5("div", __spreadProps(__spreadValues({}, rest), { css: styles25.container, children }));
}
__name(ItemPriceSetBase, "ItemPriceSetBase");

// src/atoms/ItemNameBase/ItemNameBase.tsx
import { useTheme as useTheme4, lineClamp as lineClamp2, combineStyles as combineStyles3 } from "@instacart/ids-core";
import { jsx as jsx6 } from "@emotion/react/jsx-runtime";
var getStyles4 = /* @__PURE__ */ __name((theme) => ({
  name: __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    color: theme.colors.systemGrayscale70
  }), lineClamp2(3))
}), "getStyles");
function ItemNameBase(props) {
  const { children } = props;
  const theme = useTheme4();
  const { name } = combineStyles3(getStyles4(theme), props.styles);
  return /* @__PURE__ */ jsx6("div", { title: children, css: name, children });
}
__name(ItemNameBase, "ItemNameBase");

// src/atoms/ItemWeightBase/ItemWeightBase.tsx
import { useTheme as useTheme5 } from "@instacart/ids-core";
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var containerStyles2 = /* @__PURE__ */ __name(({ theme }) => __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
  color: theme.colors.systemGrayscale50
}), "containerStyles");
function ItemWeightBase({ children }) {
  const theme = useTheme5();
  return /* @__PURE__ */ jsx7("div", { title: children, css: containerStyles2({ theme }), children });
}
__name(ItemWeightBase, "ItemWeightBase");

// src/atoms/ItemBase/validations.ts
var validateItem = /* @__PURE__ */ __name((engine) => {
  var _a;
  const { expect, getAll, flatIndexOfByKind, findAllByKind, compareItemByKind } = engine;
  const all = getAll();
  const firstItemPriceIndex = flatIndexOfByKind(ItemPriceBase);
  const firstItemRegularPriceIndex = flatIndexOfByKind(ItemRegularPriceBase);
  const firstItemNameIndex = flatIndexOfByKind(ItemNameBase);
  const firstItemWeightIndex = flatIndexOfByKind(ItemWeightBase);
  const firstItemAttributeIndex = flatIndexOfByKind(ItemAttributeBase);
  const firstItemRegularPriceParent = (_a = all[firstItemRegularPriceIndex]) == null ? void 0 : _a.parent;
  if (firstItemRegularPriceIndex > -1 && (!firstItemRegularPriceParent || firstItemRegularPriceParent && compareItemByKind(firstItemRegularPriceParent, ItemPriceSetBase) === false)) {
    throw new CompositionTooManyItemsError2(
      ItemRegularPriceBase,
      "not allowed outside of ItemPriceSet"
    );
  }
  if (firstItemWeightIndex > -1) {
    if (firstItemNameIndex > -1) {
      try {
        expect(firstItemNameIndex).toBeLessThan(firstItemWeightIndex);
      } catch (e) {
        throw new CompositionOrderError2(all[firstItemWeightIndex], all[firstItemNameIndex]);
      }
    }
  }
  if (firstItemAttributeIndex > -1) {
    if (firstItemPriceIndex > -1) {
      try {
        expect(firstItemPriceIndex).toBeLessThan(firstItemAttributeIndex);
      } catch (e) {
        throw new CompositionOrderError2(all[firstItemAttributeIndex], all[firstItemPriceIndex]);
      }
    }
    if (firstItemNameIndex > -1) {
      try {
        expect(firstItemNameIndex).toBeLessThan(firstItemAttributeIndex);
      } catch (e) {
        throw new CompositionOrderError2(all[firstItemAttributeIndex], all[firstItemNameIndex]);
      }
    }
    if (firstItemWeightIndex > -1) {
      try {
        expect(firstItemWeightIndex).toBeLessThan(firstItemAttributeIndex);
      } catch (e) {
        throw new CompositionOrderError2(all[firstItemAttributeIndex], all[firstItemWeightIndex]);
      }
    }
  }
  if (firstItemAttributeIndex > -1) {
    expect(findAllByKind(ItemAttributeBase)).toHaveMaxLength(3);
  }
}, "validateItem");

// src/atoms/ItemBase/ItemBase.tsx
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var getStyles5 = /* @__PURE__ */ __name(() => ({
  container: {
    position: "relative"
  }
}), "getStyles");
var validator2 = new CompositionValidator2([validateItem]);
var ItemBase = forwardRef(/* @__PURE__ */ __name(function ItemBase2(props, ref) {
  const _a = props, { children, styles: propStyles } = _a, rest = __objRest(_a, ["children", "styles"]);
  const styles25 = combineStyles4(getStyles5(), propStyles);
  validator2.validate(children);
  return /* @__PURE__ */ jsx8("div", __spreadProps(__spreadValues({ ref }, rest), { css: styles25.container, role: "group", children }));
}, "ItemBase"));

// src/atoms/ItemDynamicLabelBase/ItemDynamicLabelBase.tsx
import { Children, cloneElement } from "react";
import {
  lineClamp as lineClamp3,
  spacing,
  useTheme as useTheme6,
  CompositionValidator as CompositionValidator3,
  combineStyles as combineStyles5
} from "@instacart/ids-core";
import { isElement } from "react-is";

// src/atoms/ItemDynamicLabelBase/validations.ts
import {
  CompositionOrderError as CompositionOrderError3,
  CompositionTooFewItemsError as CompositionTooFewItemsError2,
  CompositionTooManyItemsError as CompositionTooManyItemsError3,
  CompositionInvalidChildCount,
  CompositionEngineItemType
} from "@instacart/ids-core";
var { TextContent } = CompositionEngineItemType;
var validateDynamicLabelWithIcon = /* @__PURE__ */ __name((engine) => {
  const { getAllChildren, findAllChildrenByType, childIndexOfByItemType } = engine;
  const all = getAllChildren();
  if (all.length !== 2) {
    throw new CompositionInvalidChildCount(all.length, 2);
  }
  const findTextContentIndex = childIndexOfByItemType(TextContent);
  const allTextContent = findAllChildrenByType(TextContent);
  if (allTextContent.length > 1) {
    throw new CompositionTooManyItemsError3(TextContent);
  } else if (allTextContent.length < 1) {
    throw new CompositionTooFewItemsError2(TextContent);
  }
  if (findTextContentIndex === 0) {
    throw new CompositionOrderError3(all[1], all[0]);
  }
}, "validateDynamicLabelWithIcon");

// src/atoms/ItemDynamicLabelBase/ItemDynamicLabelBase.tsx
import { jsx as jsx9, jsxs } from "@emotion/react/jsx-runtime";
var baseStyles = /* @__PURE__ */ __name(({ theme, colorKey }) => ({
  container: {
    display: "flex",
    margin: `${spacing.s4}px 0px`,
    justifyContent: "flex-start",
    alignItems: "center"
  },
  label: __spreadValues(__spreadValues({
    color: theme.colors[colorKey]
  }, theme.typography.bodySmall1), lineClamp3(2)),
  icon: {
    flex: "0 0 20px",
    lineHeight: theme.typography.bodySmall1.lineHeight,
    // aligned to the bottom
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column"
  }
}), "baseStyles");
var iconSize = 16;
var validator3 = new CompositionValidator3([validateDynamicLabelWithIcon]);
function ItemDynamicLabelBase({
  children,
  color: colorKey = "systemGrayscale70",
  styles: styles25
}) {
  const theme = useTheme6();
  const {
    container: containerCss,
    label: labelCss,
    icon: iconCss
  } = combineStyles5(baseStyles({ theme, colorKey }), styles25);
  if (typeof children === "string" || typeof children === "number") {
    return /* @__PURE__ */ jsx9("div", { css: containerCss, children: /* @__PURE__ */ jsx9("div", { css: labelCss, children }) });
  }
  const tree = Children.toArray(children);
  validator3.validate(children);
  const label = tree[1];
  const icon = isElement(tree[0]) && cloneElement(tree[0], __spreadProps(__spreadValues({}, tree[0].props), { color: colorKey, size: iconSize }));
  return /* @__PURE__ */ jsxs("div", { css: containerCss, children: [
    /* @__PURE__ */ jsx9("div", { css: iconCss, children: icon }),
    /* @__PURE__ */ jsx9("div", { css: labelCss, children: label })
  ] });
}
__name(ItemDynamicLabelBase, "ItemDynamicLabelBase");

// src/atoms/ItemDynamicLabel/ItemDynamicLabel.tsx
import { jsx as jsx10 } from "@emotion/react/jsx-runtime";
function ItemDynamicLabel(props) {
  return /* @__PURE__ */ jsx10(ItemDynamicLabelBase, __spreadValues({}, props));
}
__name(ItemDynamicLabel, "ItemDynamicLabel");

// src/atoms/ItemImage/ItemImage.tsx
import { forwardRef as forwardRef3 } from "react";

// src/atoms/ItemImageBase/ItemImageBase.tsx
import { forwardRef as forwardRef2 } from "react";
import { combineStyles as combineStyles6, aspectRatio, useTheme as useTheme7 } from "@instacart/ids-core";
import { jsx as jsx11, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var getStyles6 = /* @__PURE__ */ __name((theme) => __spreadValues({
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r12
  }
}, aspectRatio(1, 1)), "getStyles");
var ItemImageBase = forwardRef2(
  /* @__PURE__ */ __name(function ItemImageBase2(props, ref) {
    const _a = props, { styles: styles25, src, alt, children } = _a, rest = __objRest(_a, ["styles", "src", "alt", "children"]);
    const theme = useTheme7();
    const { box, boxInside, img } = combineStyles6(getStyles6(theme), styles25);
    return /* @__PURE__ */ jsx11("div", { css: box, children: /* @__PURE__ */ jsxs2("div", { css: boxInside, children: [
      /* @__PURE__ */ jsx11("img", __spreadProps(__spreadValues({}, rest), { ref, css: img, src, alt })),
      children
    ] }) });
  }, "ItemImageBase")
);

// src/atoms/ItemImage/ItemImage.tsx
import { jsx as jsx12 } from "@emotion/react/jsx-runtime";
var ItemImage = forwardRef3(
  /* @__PURE__ */ __name(function ItemImage2(props, ref) {
    return /* @__PURE__ */ jsx12(ItemImageBase, __spreadValues({ ref }, props));
  }, "ItemImage")
);

// src/atoms/ItemLink/ItemLink.tsx
import { forwardRef as forwardRef5 } from "react";

// src/atoms/ItemLinkBase/ItemLinkBase.tsx
import { forwardRef as forwardRef4 } from "react";
import { useTheme as useTheme8, combineStyles as combineStyles7 } from "@instacart/ids-core";
import { jsx as jsx13 } from "@emotion/react/jsx-runtime";
var getStyles7 = /* @__PURE__ */ __name((theme) => ({
  a: {
    textDecoration: "none",
    // so we get one solid focus ring
    display: "block",
    // so the focus ring can use position: absolute
    position: "relative"
  },
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4
  }
}), "getStyles");
var ItemLinkBase = forwardRef4(
  /* @__PURE__ */ __name(function ItemLinkBase2(props, ref) {
    const _a = props, { children, styles: styles25 } = _a, rest = __objRest(_a, ["children", "styles"]);
    const theme = useTheme8();
    const { a, focusRing } = combineStyles7(getStyles7(theme), styles25);
    const aStyles = [
      a,
      {
        "&:hover": {
          // surpress the native underlines
          textDecoration: "none"
        },
        "&:focus": {
          // surpress the native focus ring
          outline: "none",
          // surpress the native underlines
          textDecoration: "none"
        },
        "&.focus-visible::after": focusRing
      }
    ];
    return /* @__PURE__ */ jsx13("a", __spreadProps(__spreadValues({ ref, css: aStyles }, rest), { children }));
  }, "ItemLinkBase")
);

// src/atoms/ItemLink/ItemLink.tsx
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
var ItemLink = forwardRef5(/* @__PURE__ */ __name(function ItemLink2(props, ref) {
  return /* @__PURE__ */ jsx14(ItemLinkBase, __spreadValues({ ref }, props));
}, "ItemLink"));

// src/atoms/ItemName/ItemName.tsx
import { jsx as jsx15 } from "@emotion/react/jsx-runtime";
function ItemName(props) {
  return /* @__PURE__ */ jsx15(ItemNameBase, __spreadValues({}, props));
}
__name(ItemName, "ItemName");

// src/atoms/ItemPrice/ItemPrice.tsx
import { jsx as jsx16 } from "@emotion/react/jsx-runtime";
function ItemPrice(props) {
  return /* @__PURE__ */ jsx16(ItemPriceBase, __spreadValues({}, props));
}
__name(ItemPrice, "ItemPrice");

// src/atoms/ItemPriceSet/ItemPriceSet.tsx
import { jsx as jsx17 } from "@emotion/react/jsx-runtime";
function ItemPriceSet(props) {
  return /* @__PURE__ */ jsx17(ItemPriceSetBase, __spreadValues({}, props));
}
__name(ItemPriceSet, "ItemPriceSet");

// src/atoms/ItemRegularPrice/ItemRegularPrice.tsx
import { jsx as jsx18 } from "@emotion/react/jsx-runtime";
function ItemRegularPrice(props) {
  return /* @__PURE__ */ jsx18(ItemRegularPriceBase, __spreadValues({}, props));
}
__name(ItemRegularPrice, "ItemRegularPrice");

// src/atoms/ItemSalePrice/ItemSalePrice.tsx
import { useTheme as useTheme9, spacing as spacing2 } from "@instacart/ids-core";
import { jsx as jsx19 } from "@emotion/react/jsx-runtime";
var { s4 } = spacing2;
var getStyles8 = /* @__PURE__ */ __name((theme) => {
  const {
    colors: { brandPromotionalRegular }
  } = theme;
  return {
    span: {
      color: brandPromotionalRegular,
      marginRight: s4
    }
  };
}, "getStyles");
function ItemSalePrice(props) {
  const theme = useTheme9();
  return /* @__PURE__ */ jsx19(ItemPriceBase, __spreadValues({ styles: getStyles8(theme) }, props));
}
__name(ItemSalePrice, "ItemSalePrice");

// src/atoms/ItemWeight/ItemWeight.tsx
import { jsx as jsx20 } from "@emotion/react/jsx-runtime";
function ItemWeight(props) {
  return /* @__PURE__ */ jsx20(ItemWeightBase, __spreadValues({}, props));
}
__name(ItemWeight, "ItemWeight");

// src/atoms/RetailerLogoIcon/RetailerLogoIcon.tsx
import { useTheme as useTheme10 } from "@instacart/ids-core";
import { jsx as jsx21 } from "@emotion/react/jsx-runtime";
function RetailerLogoIcon(_a) {
  var _b = _a, { size, alt } = _b, rest = __objRest(_b, ["size", "alt"]);
  const theme = useTheme10();
  return /* @__PURE__ */ jsx21(
    "img",
    __spreadProps(__spreadValues({
      css: {
        backgroundColor: theme.colors.systemGrayscale00,
        border: `1px solid ${theme.colors.systemGrayscale20}`,
        borderRadius: "50%",
        width: `${size}px`,
        height: `${size}px`
      }
    }, rest), {
      alt
    })
  );
}
__name(RetailerLogoIcon, "RetailerLogoIcon");

// src/atoms/ServiceMessageBase/ServiceMessageBase.tsx
import { forwardRef as forwardRef6 } from "react";
import { combineStyles as combineStyles8, useTheme as useTheme11, spacing as spacing3 } from "@instacart/ids-core";
import { jsx as jsx22 } from "@emotion/react/jsx-runtime";
var getStyles9 = /* @__PURE__ */ __name(({ theme }) => ({
  container: {
    alignItems: "center",
    backgroundColor: theme.colors.systemGrayscale10,
    boxSizing: "border-box",
    display: "flex",
    padding: `${spacing3.s8}px ${spacing3.s16}px`,
    position: "relative",
    width: "100%"
  }
}), "getStyles");
var ServiceMessageBase = forwardRef6(
  /* @__PURE__ */ __name(function ServiceMessageBase2(props, ref) {
    const theme = useTheme11();
    const _a = props, { children, styles: propStyles } = _a, rest = __objRest(_a, ["children", "styles"]);
    const { container } = combineStyles8(getStyles9({ theme }), propStyles);
    return /* @__PURE__ */ jsx22("div", __spreadProps(__spreadValues({ ref }, rest), { css: container, children }));
  }, "ServiceMessageBase")
);
ServiceMessageBase.displayName = "ServiceMessageBase";

// src/atoms/ServiceMessageButtonBase/ServiceMessageButtonBase.tsx
import { forwardRef as forwardRef7 } from "react";
import { ButtonBase, spacing as spacing4, useTheme as useTheme12 } from "@instacart/ids-core";
import { jsx as jsx23 } from "@emotion/react/jsx-runtime";
var ServiceMessageButtonBase = forwardRef7(/* @__PURE__ */ __name(function ServiceMessageButton(_a, ref) {
  var _b = _a, { icon: Icon, color, disabled, accessibleLabel, onClick } = _b, rest = __objRest(_b, ["icon", "color", "disabled", "accessibleLabel", "onClick"]);
  const theme = useTheme12();
  const styles25 = {
    button: {
      alignItems: "center",
      backgroundColor: "transparent",
      border: "none",
      color: theme.colors.systemGrayscale70,
      display: "flex",
      height: spacing4.s24,
      "&:focus": {
        outline: "none"
      }
    }
  };
  return /* @__PURE__ */ jsx23(
    ButtonBase,
    __spreadProps(__spreadValues({
      "aria-label": accessibleLabel,
      disabled,
      ref,
      styles: styles25,
      onClick
    }, rest), {
      children: /* @__PURE__ */ jsx23(Icon, { size: "24" })
    })
  );
}, "ServiceMessageButton"));
ServiceMessageButtonBase.displayName = "ServiceMessageButtonBase";

// src/atoms/ServiceMessageCloseButton/ServiceMessageCloseButton.tsx
import { CloseIcon } from "@instacart/ids-core";
import { jsx as jsx24 } from "@emotion/react/jsx-runtime";
function ServiceMessageCloseButton(props) {
  return /* @__PURE__ */ jsx24(ServiceMessageButtonBase, __spreadValues({ icon: CloseIcon }, props));
}
__name(ServiceMessageCloseButton, "ServiceMessageCloseButton");

// src/atoms/ServiceMessageDescriptionBase/ServiceMessageDescriptionBase.tsx
import { useTheme as useTheme13, combineStyles as combineStyles9, lineClamp as lineClamp4 } from "@instacart/ids-core";
import { jsx as jsx25 } from "@emotion/react/jsx-runtime";
var getStyles10 = /* @__PURE__ */ __name((theme) => ({
  container: __spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    color: theme.colors.systemGrayscale70
  }), lineClamp4(4))
}), "getStyles");
function ServiceMessageDescriptionBase({
  children,
  styles: propsStyles
}) {
  const theme = useTheme13();
  const { container } = combineStyles9(getStyles10(theme), propsStyles);
  return /* @__PURE__ */ jsx25("div", { css: container, children });
}
__name(ServiceMessageDescriptionBase, "ServiceMessageDescriptionBase");

// src/atoms/ServiceMessageInfoBase/ServiceMessageInfoBase.tsx
import { useTheme as useTheme14, lineClamp as lineClamp5 } from "@instacart/ids-core";
import { jsx as jsx26 } from "@emotion/react/jsx-runtime";
var getStyles11 = /* @__PURE__ */ __name(({ theme }) => ({
  paragraph: __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
    color: theme.colors.systemGrayscale70
  }), lineClamp5(2)), {
    margin: 0
  })
}), "getStyles");
function ServiceMessageInfoBase(props) {
  const theme = useTheme14();
  const { paragraph } = getStyles11({ theme });
  return /* @__PURE__ */ jsx26("p", { role: "region", "aria-live": "polite", css: paragraph, children: props.children });
}
__name(ServiceMessageInfoBase, "ServiceMessageInfoBase");
ServiceMessageInfoBase.displayName = "ServiceMessageInfoBase";

// src/atoms/ServiceMessageMoreButton/ServiceMessageMoreButton.tsx
import { ChevronRightIcon } from "@instacart/ids-core";
import { jsx as jsx27 } from "@emotion/react/jsx-runtime";
function ServiceMessageMoreButton(props) {
  return /* @__PURE__ */ jsx27(ServiceMessageButtonBase, __spreadValues({ icon: ChevronRightIcon }, props));
}
__name(ServiceMessageMoreButton, "ServiceMessageMoreButton");

// src/molecules/AddItem/AddItem.tsx
import { useOnClickOutside } from "@instacart/ids-core";
import { useEffect, useRef } from "react";

// src/molecules/AddItem/AddItemButton/AddItemButton.tsx
import { forwardRef as forwardRef9 } from "react";
import {
  elevation,
  responsive,
  useTheme as useTheme15,
  useIdsFeatureFlag
} from "@instacart/ids-core";

// src/molecules/AddItem/AddItemButton/AddItemButtonBase.tsx
import { forwardRef as forwardRef8 } from "react";
import { AddIcon, combineStyles as combineStyles10 } from "@instacart/ids-core";
import { jsx as jsx28 } from "@emotion/react/jsx-runtime";
var baseStyles2 = {
  button: {
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    touchAction: "manipulation",
    "&:disabled": {
      cursor: "default"
    }
  },
  icon: {
    position: "absolute"
    // svg corners push rounded corners in compact size
  },
  text: {},
  wrapper: {}
};
var iconColor = "systemGrayscale70";
var AddItemButtonBase = forwardRef8(
  /* @__PURE__ */ __name(function AddItemButtonBase2(_a, ref) {
    var _b = _a, { styles: styles25, value } = _b, rest = __objRest(_b, ["styles", "value"]);
    const {
      button: buttonCSS,
      text: textCSS,
      wrapper: wrapperCSS,
      icon: iconCSS
    } = combineStyles10(baseStyles2, styles25);
    return /* @__PURE__ */ jsx28("div", { css: wrapperCSS, children: /* @__PURE__ */ jsx28("button", __spreadProps(__spreadValues({}, rest), { ref, css: buttonCSS, children: !value && /* @__PURE__ */ jsx28(AddIcon, { css: iconCSS, size: 24, color: iconColor }) || /* @__PURE__ */ jsx28("span", { css: textCSS, children: value }) })) });
  }, "AddItemButtonBase")
);

// src/molecules/AddItem/AddItemButton/AddItemButton.tsx
import { jsx as jsx29 } from "@emotion/react/jsx-runtime";
var buttonSizeStyles = {
  buttonWrapper: {
    padding: 2
  },
  button: {
    border: 0,
    borderRadius: 20,
    height: 36,
    minWidth: 36,
    [responsive.down("c")]: {
      height: 32,
      minWidth: 32
    }
  }
};
var getStyles12 = /* @__PURE__ */ __name((theme, grayscale) => ({
  wrapper: __spreadValues(__spreadValues({
    display: "inline-block",
    backgroundColor: theme.colors.systemGrayscale00,
    borderRadius: 20,
    border: 0
  }, buttonSizeStyles.buttonWrapper), elevation.low.shadow),
  button: __spreadProps(__spreadValues({
    backgroundColor: theme.colors.systemGrayscale00,
    display: "flex",
    flexDirection: "row",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-evenly"
  }, buttonSizeStyles.button), {
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale10
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible::after": {
      borderRadius: 24,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: -6,
      bottom: -6,
      left: -6,
      right: -6
    },
    "&:active": {
      backgroundColor: theme.colors.systemGrayscale20
    }
  }),
  text: __spreadValues({
    color: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryRegular
  }, theme.typography.bodyMedium1)
}), "getStyles");
var AddItemButton = forwardRef9(
  /* @__PURE__ */ __name(function AddItemButton2(props, ref) {
    const theme = useTheme15();
    const grayscale = useIdsFeatureFlag("grayscale") !== "control";
    const styles25 = getStyles12(theme, grayscale);
    return /* @__PURE__ */ jsx29(AddItemButtonBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "AddItemButton")
);

// src/molecules/AddItem/AddItemExpanded/AddItemExpanded.tsx
import { elevation as elevation2, responsive as responsive3, useTheme as useTheme17 } from "@instacart/ids-core";

// src/molecules/AddItem/AddItemStepperBase/AddItemStepperBase.tsx
import { spacing as spacing5, useTheme as useTheme16, responsive as responsive2, combineStyles as combineStyles12 } from "@instacart/ids-core";

// src/molecules/StepperBase/StepperBase.tsx
import {
  AddIcon as AddIcon2,
  combineStyles as combineStyles11,
  SubtractIcon,
  TrashIcon,
  VisuallyHidden
} from "@instacart/ids-core";
import { jsx as jsx30, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var disabledColor = "systemGrayscale30";
var enabledColor = "systemGrayscale70";
var baseStyles3 = {
  decrementButton: {
    display: "flex",
    flexWrap: "nowrap",
    // For iOS Safari issue where there's unnecessary padding applied
    padding: 0,
    justifyContent: "center",
    alignItems: "center"
  },
  incrementButton: {
    display: "flex",
    flexWrap: "nowrap",
    // iOS Safari issue where there's unnecessary padding applied
    padding: 0,
    justifyContent: "center",
    alignItems: "center"
  },
  text: {
    userSelect: "none"
  },
  wrapper: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    alignItems: "center"
  }
};
function StepperBase({
  allowIncrement,
  allowDecrement,
  ariaIncrement,
  ariaDecrement,
  ariaValue,
  decrementType,
  disabled,
  onIncrement,
  onDecrement,
  styles: styles25,
  incrementButtonRef,
  value,
  valueText
}) {
  const {
    decrementButton: decrementCSS,
    incrementButton: incrementCSS,
    text: textCSS,
    wrapper: wrapperCSS
  } = combineStyles11(baseStyles3, styles25);
  const incrementDisabled = !allowIncrement || disabled;
  const decrementDisabled = !allowDecrement || disabled;
  return /* @__PURE__ */ jsxs3("span", { css: wrapperCSS, children: [
    /* @__PURE__ */ jsx30(
      "button",
      {
        "aria-label": ariaDecrement,
        css: decrementCSS,
        onClick: (e) => {
          e.preventDefault();
          onDecrement();
        },
        disabled: decrementDisabled,
        children: decrementType === "trash" ? /* @__PURE__ */ jsx30(TrashIcon, { size: 24, color: decrementDisabled ? disabledColor : enabledColor }) : /* @__PURE__ */ jsx30(SubtractIcon, { size: 24, color: decrementDisabled ? disabledColor : enabledColor })
      }
    ),
    /* @__PURE__ */ jsxs3("span", { "aria-live": "polite", "aria-atomic": true, css: textCSS, children: [
      /* @__PURE__ */ jsx30(VisuallyHidden, { children: ariaValue }),
      /* @__PURE__ */ jsx30("span", { children: valueText || value })
    ] }),
    /* @__PURE__ */ jsx30(
      "button",
      {
        "aria-label": ariaIncrement,
        css: incrementCSS,
        onClick: (e) => {
          e.preventDefault();
          onIncrement();
        },
        disabled: incrementDisabled,
        ref: incrementButtonRef,
        children: /* @__PURE__ */ jsx30(AddIcon2, { size: 24, color: incrementDisabled ? disabledColor : enabledColor })
      }
    )
  ] });
}
__name(StepperBase, "StepperBase");

// src/molecules/AddItem/AddItemStepperBase/AddItemStepperBase.tsx
import { jsx as jsx31 } from "@emotion/react/jsx-runtime";
var getBorderRadius = /* @__PURE__ */ __name((side, highRadius, lowRadius) => {
  const topLeft = `${side === "left" ? highRadius : lowRadius}px`;
  const topRight = `${side === "right" ? highRadius : lowRadius}px`;
  const bottom = `${lowRadius}px`;
  return `${topLeft} ${topRight} ${bottom} ${bottom}`;
}, "getBorderRadius");
var getButtonStyles = /* @__PURE__ */ __name((theme, side, disabled) => ({
  backgroundColor: theme.colors.systemGrayscale00,
  border: 0,
  position: "relative",
  height: spacing5.s32,
  width: spacing5.s32,
  // based on side
  [side]: 2,
  borderRadius: getBorderRadius(side, 16, theme.radius.r4),
  [responsive2.up("r")]: {
    height: 36,
    width: 36,
    borderRadius: getBorderRadius(side, 18, theme.radius.r4)
  },
  "&:focus": {
    outline: "none"
  },
  "&.focus-visible::after": {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4,
    // based on side
    borderRadius: getBorderRadius(side, 20, theme.radius.r4)
  },
  "&:hover": {
    backgroundColor: !disabled && theme.colors.systemGrayscale10 || void 0
  },
  "&:active": {
    backgroundColor: !disabled && theme.colors.systemGrayscale20 || void 0
  },
  "&:disabled": {}
}), "getButtonStyles");
var getStyles13 = /* @__PURE__ */ __name((theme, { allowIncrement, allowDecrement, disabled }) => ({
  decrementButton: __spreadValues({}, getButtonStyles(theme, "left", !allowDecrement || disabled)),
  incrementButton: __spreadValues({}, getButtonStyles(theme, "right", !allowIncrement || disabled)),
  text: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
    padding: `0 ${spacing5.s4}px`,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70
  }),
  wrapper: {
    minWidth: 136,
    minHeight: 36,
    [responsive2.up("r")]: {
      minWidth: 144,
      minHeight: spacing5.s40
    }
  }
}), "getStyles");
function AddItemStepperBase(props) {
  const theme = useTheme16();
  const baseStyles17 = getStyles13(theme, props);
  const styles25 = combineStyles12(baseStyles17, props.styles);
  return /* @__PURE__ */ jsx31(StepperBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(AddItemStepperBase, "AddItemStepperBase");

// src/molecules/AddItem/AddItemExpanded/AddItemExpanded.tsx
import { jsx as jsx32 } from "@emotion/react/jsx-runtime";
var getBorderRadius2 = /* @__PURE__ */ __name((side, highRadius, lowRadius) => {
  const left = `${side === "left" ? highRadius : lowRadius}px`;
  const right = `${side === "right" ? highRadius : lowRadius}px`;
  return `${left} ${right} ${right} ${left}`;
}, "getBorderRadius");
var getButtonStyles2 = /* @__PURE__ */ __name((side, theme) => ({
  borderRadius: getBorderRadius2(side, 16, theme.radius.r4),
  [responsive3.up("r")]: {
    borderRadius: getBorderRadius2(side, 18, theme.radius.r4)
  },
  "&.focus-visible::after": {
    // based on side
    borderRadius: getBorderRadius2(side, 20, theme.radius.r4)
  }
}), "getButtonStyles");
var getStyles14 = /* @__PURE__ */ __name((theme) => ({
  wrapper: __spreadValues({
    background: theme.colors.systemGrayscale00,
    borderRadius: 20
  }, elevation2.low.shadow),
  decrementButton: __spreadValues({}, getButtonStyles2("left", theme)),
  incrementButton: __spreadValues({}, getButtonStyles2("right", theme))
}), "getStyles");
function AddItemExpanded(props) {
  const theme = useTheme17();
  const styles25 = getStyles14(theme);
  return /* @__PURE__ */ jsx32(AddItemStepperBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(AddItemExpanded, "AddItemExpanded");

// src/molecules/AddItem/AddItemExpandedMessage/AddItemExpandedDisclaimer.tsx
import { spacing as spacing6, elevation as elevation3, responsive as responsive4, useTheme as useTheme18 } from "@instacart/ids-core";
import { jsx as jsx33, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
var styles = /* @__PURE__ */ __name((theme) => {
  return {
    wrapper: __spreadProps(__spreadValues({
      display: "inline-block",
      maxWidth: 136,
      // unlike other AddItemExpanded* this is fixed as we prefer text to wrap
      borderRadius: 18,
      background: theme.colors.systemGrayscale00
    }, elevation3.low.shadow), {
      [responsive4.up("r")]: {
        maxWidth: 144,
        // unlike other AddItemExpanded* this is fixed as we prefer text to wrap
        borderRadius: 20
      }
    }),
    disclaimer: __spreadValues({
      marginTop: 2,
      paddingLeft: spacing6.s8,
      paddingRight: spacing6.s8,
      paddingBottom: spacing6.s8,
      color: theme.colors.systemGrayscale70,
      cursor: "default",
      textAlign: "center"
    }, theme.typography.bodySmall2)
  };
}, "styles");
function AddItemExpandedDisclaimer(_a) {
  var _b = _a, {
    disclaimer
  } = _b, addItemProps = __objRest(_b, [
    "disclaimer"
  ]);
  const theme = useTheme18();
  const { wrapper: wrapperCss, disclaimer: disclaimerCss } = styles(theme);
  return /* @__PURE__ */ jsxs4("div", { css: wrapperCss, children: [
    /* @__PURE__ */ jsx33(AddItemStepperBase, __spreadValues({}, addItemProps)),
    /* @__PURE__ */ jsx33("div", { "aria-live": "polite", css: disclaimerCss, children: disclaimer })
  ] });
}
__name(AddItemExpandedDisclaimer, "AddItemExpandedDisclaimer");

// src/molecules/AddItem/AddItemExpandedUnit/AddItemExpandedUnit.tsx
import { elevation as elevation4, responsive as responsive5, useTheme as useTheme20 } from "@instacart/ids-core";

// src/molecules/RadioButtonGroup/RadioButtonGroupBase.tsx
import { Children as Children2, cloneElement as cloneElement2 } from "react";
import { combineStyles as combineStyles13 } from "@instacart/ids-core";
import { jsx as jsx34 } from "@emotion/react/jsx-runtime";
var baseStyles4 = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    whiteSpace: "nowrap"
  }
};
function RadioButtonGroupBase({
  name,
  accessibleLabel,
  disabled,
  onChange,
  styles: styles25,
  value,
  children
}) {
  const { wrapper: wrapperCSS } = combineStyles13(baseStyles4, styles25);
  return /* @__PURE__ */ jsx34(
    "div",
    {
      css: wrapperCSS,
      "aria-label": accessibleLabel,
      role: "radiogroup",
      onChange: (e) => {
        onChange(e.target.value);
      },
      children: children && Children2.map(children, (child) => {
        return cloneElement2(child, {
          name,
          selectedValue: value,
          groupDisabled: disabled
        });
      })
    }
  );
}
__name(RadioButtonGroupBase, "RadioButtonGroupBase");

// src/molecules/RadioButtonGroup/RadioButtonGroup.tsx
import { jsx as jsx35 } from "@emotion/react/jsx-runtime";
function RadioButtonGroup(props) {
  return /* @__PURE__ */ jsx35(RadioButtonGroupBase, __spreadValues({}, props));
}
__name(RadioButtonGroup, "RadioButtonGroup");

// src/molecules/RadioButtonGroup/RadioButtonGroupWrap.tsx
import { jsx as jsx36 } from "@emotion/react/jsx-runtime";
function RadioButtonGroupWrap(props) {
  return /* @__PURE__ */ jsx36(RadioButtonGroupBase, __spreadProps(__spreadValues({}, props), { styles: { wrapper: { flexWrap: "wrap" } } }));
}
__name(RadioButtonGroupWrap, "RadioButtonGroupWrap");

// src/molecules/RadioButtonGroup/RadioPillBase.tsx
import { A11Y, combineStyles as combineStyles14, spacing as spacing7 } from "@instacart/ids-core";
import { jsx as jsx37, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
var baseStyles5 = {
  input: __spreadProps(__spreadValues({}, A11Y.visuallyHidden), {
    // TODO: @aref-kashani when IDS pill designs are finalized, move this to a Pill implementation
    "+label": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: spacing7.s12,
      paddingRight: spacing7.s12
    }
  }),
  inputWrapper: {
    float: "left",
    marginRight: 8,
    marginTop: 4,
    marginBottom: 4,
    ":last-child": {
      marginRight: 0
    }
  }
};
function RadioPillBase({
  styles: styles25,
  value,
  selectedValue,
  disabled,
  groupDisabled,
  name,
  children
}) {
  const { inputWrapper: inputWrapperCSS, input: inputCSS } = combineStyles14(baseStyles5, styles25);
  return (
    // we don't care bout a11y because we're not doing any handling, just fixing weird browser behaviors
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ jsxs5(
      "span",
      {
        css: inputWrapperCSS,
        onClick: (e) => {
          e.stopPropagation();
        },
        children: [
          /* @__PURE__ */ jsx37(
            "input",
            {
              defaultChecked: value === selectedValue,
              "aria-checked": value === selectedValue,
              css: inputCSS,
              disabled: groupDisabled || disabled,
              id: value,
              name,
              type: "radio",
              value,
              tabIndex: value === selectedValue ? 0 : -1
            }
          ),
          /* @__PURE__ */ jsx37("label", { htmlFor: value, children })
        ]
      },
      value
    )
  );
}
__name(RadioPillBase, "RadioPillBase");

// src/molecules/RadioButtonGroup/RadioPill.tsx
import { useTheme as useTheme19, blendColors } from "@instacart/ids-core";
import { jsx as jsx38 } from "@emotion/react/jsx-runtime";
var BORDER_WIDTH = 2;
var getStyles15 = /* @__PURE__ */ __name((theme) => ({
  input: {
    // TODO: @aref-kashani when IDS pill designs are finalized, move this to a Pill implementation
    "+label": __spreadProps(__spreadValues({
      // We need a border box in all cases so the controls don't move, border is transparent in normal state
      boxSizing: "border-box",
      userSelect: "none",
      border: `${BORDER_WIDTH}px solid transparent`,
      minWidth: 58,
      height: 28,
      background: theme.colors.systemGrayscale10,
      borderRadius: 14,
      color: theme.colors.systemGrayscale70
    }, theme.typography.bodyMedium1), {
      cursor: "pointer"
    }),
    "&:enabled:not(:checked):hover+label": {
      background: blendColors(theme.colors.systemGrayscale10, theme.colors.systemGrayscale20, 51)
      // TODO: @aref-kashani follow up with Bruce
    },
    "&:checked+label": {
      background: theme.colors.systemGrayscale20,
      border: `${BORDER_WIDTH}px solid ${theme.colors.systemGrayscale70}`
    },
    "&.focus-visible+label::after": {
      borderRadius: 119,
      border: `${BORDER_WIDTH}px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      // Designs call for -4 but need to add border since border-box sizing
      top: -4 + -BORDER_WIDTH,
      bottom: -4 + -BORDER_WIDTH,
      left: -4 + -BORDER_WIDTH,
      right: -4 + -BORDER_WIDTH
    },
    "&:disabled+label": {
      color: theme.colors.systemGrayscale30,
      cursor: "default"
    },
    "&:disabled:checked+label": {
      border: `${BORDER_WIDTH}px solid ${theme.colors.systemGrayscale30}`,
      cursor: "default"
    }
    // TODO: @aref-kashani Designs call for active (pressed) style here, but per W3 standards active is only for buttons
    // follow up with design. If we need to implement this, we'll have to flow styles for keydown
    // and mouse click
    // '&:active+label': {
    //   boxSizing: 'border-box',
    //   border: `${border_width}px solid ${theme.systemGrayscale20}`,
    //   background: theme.systemGrayscale30,
    //   ...elevation.high.shadow,
    // },
  }
}), "getStyles");
function RadioPill(props) {
  const theme = useTheme19();
  const styles25 = getStyles15(theme);
  return /* @__PURE__ */ jsx38(RadioPillBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(RadioPill, "RadioPill");

// src/molecules/AddItem/AddItemExpandedUnit/AddItemExpandedUnit.tsx
import { jsx as jsx39, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
var styles2 = /* @__PURE__ */ __name((theme) => {
  return {
    wrapper: __spreadProps(__spreadValues({
      display: "inline-block",
      minWidth: 136,
      background: theme.colors.systemGrayscale00,
      borderRadius: 18
    }, elevation4.low.shadow), {
      [responsive5.up("r")]: {
        minWidth: 144,
        borderRadius: 20
      }
    }),
    modes: {
      marginTop: 2,
      paddingLeft: 8,
      paddingRight: 8,
      paddingBottom: 8
    }
  };
}, "styles");
var radioGroupStyles = { wrapper: { justifyContent: "space-between" } };
function AddItemExpandedUnit(_a) {
  var _b = _a, { modes } = _b, addItemProps = __objRest(_b, ["modes"]);
  const theme = useTheme20();
  const { wrapper: wrapperCss, modes: modesCss } = styles2(theme);
  return /* @__PURE__ */ jsxs6("div", { css: wrapperCss, children: [
    /* @__PURE__ */ jsx39(AddItemStepperBase, __spreadValues({}, addItemProps)),
    /* @__PURE__ */ jsx39("div", { style: modesCss, children: /* @__PURE__ */ jsx39(RadioButtonGroupBase, __spreadProps(__spreadValues({}, modes), { styles: radioGroupStyles, children: modes.options.map((opt) => /* @__PURE__ */ jsx39(RadioPill, { value: opt.id, children: opt.label }, opt.id)) })) })
  ] });
}
__name(AddItemExpandedUnit, "AddItemExpandedUnit");

// src/molecules/AddItem/AddItem.tsx
import { jsx as jsx40, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
function isExpandedMessage(props) {
  return !!props.disclaimer;
}
__name(isExpandedMessage, "isExpandedMessage");
function isExpandedUnit(props) {
  return props.modes !== void 0;
}
__name(isExpandedUnit, "isExpandedUnit");
var onMouseDown = /* @__PURE__ */ __name((event) => {
  event.preventDefault();
}, "onMouseDown");
var styles3 = {
  floatingInteractive: {
    position: "absolute",
    top: 0,
    right: 0
  },
  interactiveContainer: __spreadValues({
    position: "relative"
  }, buttonSizeStyles.buttonWrapper),
  interactivePlaceholder: __spreadValues({}, buttonSizeStyles.button)
};
function AddItem(_a) {
  var _b = _a, {
    accessibleLabel,
    isInteracting,
    setInteracting,
    buttonValueText
  } = _b, props = __objRest(_b, [
    "accessibleLabel",
    "isInteracting",
    "setInteracting",
    "buttonValueText"
  ]);
  const wrapperRef = useRef(null);
  const incrementButtonRef = useRef(null);
  useOnClickOutside(wrapperRef, () => {
    if (isInteracting) {
      setInteracting(false);
    }
  });
  useEffect(() => {
    var _a2;
    if (isInteracting) {
      (_a2 = incrementButtonRef.current) == null ? void 0 : _a2.focus();
    }
  }, [isInteracting, incrementButtonRef]);
  const expandedComponent = /* @__PURE__ */ __name(() => {
    if (isExpandedMessage(props)) {
      return /* @__PURE__ */ jsx40(AddItemExpandedDisclaimer, __spreadProps(__spreadValues({}, props), { incrementButtonRef }));
    }
    if (isExpandedUnit(props)) {
      return /* @__PURE__ */ jsx40(AddItemExpandedUnit, __spreadProps(__spreadValues({}, props), { incrementButtonRef }));
    }
    return /* @__PURE__ */ jsx40(AddItemExpanded, __spreadProps(__spreadValues({}, props), { incrementButtonRef }));
  }, "expandedComponent");
  return (
    // this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from becoming focused when child elements get clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ jsxs7("div", { ref: wrapperRef, onMouseDown, children: [
      !isInteracting && /* @__PURE__ */ jsx40(
        AddItemButton,
        {
          "aria-label": accessibleLabel,
          value: buttonValueText,
          onClick: (event) => {
            event.preventDefault();
            setInteracting(true);
          }
        }
      ),
      isInteracting && /* @__PURE__ */ jsxs7("div", { css: styles3.interactiveContainer, children: [
        /* @__PURE__ */ jsx40("div", { css: styles3.interactivePlaceholder }),
        /* @__PURE__ */ jsx40("div", { css: styles3.floatingInteractive, children: expandedComponent() })
      ] })
    ] })
  );
}
__name(AddItem, "AddItem");

// src/molecules/AvatarBase/AvatarBase.tsx
import { combineStyles as combineStyles15, useTheme as useTheme21, Image } from "@instacart/ids-core";
import { forwardRef as forwardRef10 } from "react";
import { jsx as jsx41 } from "@emotion/react/jsx-runtime";
var AVATAR_BORDER_PX = 1;
var getStyles16 = /* @__PURE__ */ __name(({
  theme,
  width,
  height,
  fillColor
}) => ({
  container: {
    boxSizing: "border-box",
    width,
    height,
    border: `${AVATAR_BORDER_PX}px solid rgba(0, 0, 0, 0.12)`,
    backgroundColor: fillColor != null ? fillColor : theme.colors.systemGrayscale00,
    overflow: "hidden"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }
}), "getStyles");
var AvatarBase = forwardRef10((props, ref) => {
  const theme = useTheme21();
  const { width, height } = props;
  const _a = props, { fillColor, styles: styles25 } = _a, rest = __objRest(_a, ["fillColor", "styles"]);
  const combinedStyles = combineStyles15(
    getStyles16({ theme, width, height: height != null ? height : width, fillColor }),
    styles25
  );
  return /* @__PURE__ */ jsx41("div", { css: combinedStyles.container, children: /* @__PURE__ */ jsx41(Image, __spreadProps(__spreadValues({}, rest), { css: combinedStyles.image, ref })) });
});
AvatarBase.displayName = "AvatarBase";

// src/molecules/AuthorAvatar/AuthorAvatarSmall.tsx
import { forwardRef as forwardRef12 } from "react";

// src/molecules/AuthorAvatar/AuthorAvatarBase.tsx
import { responsive as responsive6 } from "@instacart/ids-core";
import { forwardRef as forwardRef11 } from "react";
import { jsx as jsx42 } from "@emotion/react/jsx-runtime";
var getStyles17 = /* @__PURE__ */ __name((desktopWidth, mobileWidth) => {
  return {
    container: {
      height: mobileWidth,
      width: mobileWidth,
      [responsive6.DESKTOP_SIZE]: {
        height: desktopWidth,
        width: desktopWidth
      },
      borderRadius: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    image: {
      width: mobileWidth,
      height: mobileWidth,
      [responsive6.DESKTOP_SIZE]: {
        width: desktopWidth,
        height: desktopWidth
      }
    }
  };
}, "getStyles");
var AuthorAvatarBase = forwardRef11(
  /* @__PURE__ */ __name(function AuthorAvatarBase2(props, ref) {
    const styles25 = getStyles17(
      props.responsiveSizes.desktop.width,
      props.responsiveSizes.mobile.width
    );
    const _a = props, { responsiveSizes: responsiveSizes10, src, srcSet, templateUrl } = _a, rest = __objRest(_a, ["responsiveSizes", "src", "srcSet", "templateUrl"]);
    const imageProps = {
      src,
      srcSet,
      width: responsiveSizes10.desktop.width,
      height: responsiveSizes10.desktop.width,
      templateUrl
    };
    return /* @__PURE__ */ jsx42(AvatarBase, __spreadProps(__spreadValues(__spreadValues({}, rest), imageProps), { styles: styles25, ref }));
  }, "AuthorAvatarBase")
);
AuthorAvatarBase.displayName = "AuthorAvatarBase";

// src/molecules/AuthorAvatar/AuthorAvatarSmall.tsx
import { jsx as jsx43 } from "@emotion/react/jsx-runtime";
var responsiveSizes = {
  desktop: {
    width: 48
  },
  mobile: {
    width: 36
  }
};
var AuthorAvatarSmall = forwardRef12(
  (props, ref) => {
    return /* @__PURE__ */ jsx43(AuthorAvatarBase, __spreadProps(__spreadValues({ responsiveSizes }, props), { ref }));
  }
);
AuthorAvatarSmall.displayName = "AuthorAvatarSmall";

// src/molecules/AuthorAvatar/AuthorAvatarMedium.tsx
import { forwardRef as forwardRef13 } from "react";
import { jsx as jsx44 } from "@emotion/react/jsx-runtime";
var responsiveSizes2 = {
  desktop: {
    width: 72
  },
  mobile: {
    width: 48
  }
};
var AuthorAvatarMedium = forwardRef13(
  (props, ref) => {
    return /* @__PURE__ */ jsx44(AuthorAvatarBase, __spreadProps(__spreadValues({ responsiveSizes: responsiveSizes2 }, props), { ref }));
  }
);
AuthorAvatarMedium.displayName = "AuthorAvatarMedium";

// src/molecules/AuthorAvatar/AuthorAvatarLarge.tsx
import { forwardRef as forwardRef14 } from "react";
import { jsx as jsx45 } from "@emotion/react/jsx-runtime";
var responsiveSizes3 = {
  desktop: {
    width: 96
  },
  mobile: {
    width: 64
  }
};
var AuthorAvatarLarge = forwardRef14(
  (props, ref) => {
    return /* @__PURE__ */ jsx45(AuthorAvatarBase, __spreadProps(__spreadValues({ responsiveSizes: responsiveSizes3 }, props), { ref }));
  }
);
AuthorAvatarLarge.displayName = "AuthorAvatarLarge";

// src/molecules/AdvertiserAvatar/AdvertiserAvatarSmall.tsx
import { forwardRef as forwardRef16 } from "react";

// src/molecules/AdvertiserAvatar/AdvertiserAvatarBase.tsx
import { responsive as responsive7 } from "@instacart/ids-core";
import { forwardRef as forwardRef15 } from "react";
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
var PADDING_PX = 2;
var getStyles18 = /* @__PURE__ */ __name((desktopWidth, mobileWidth) => {
  return {
    container: {
      height: mobileWidth,
      width: mobileWidth,
      [responsive7.DESKTOP_SIZE]: {
        height: desktopWidth,
        width: desktopWidth
      },
      borderRadius: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    image: {
      width: mobileWidth - PADDING_PX * 2,
      height: mobileWidth - PADDING_PX * 2,
      [responsive7.DESKTOP_SIZE]: {
        width: desktopWidth - PADDING_PX * 2,
        height: desktopWidth - PADDING_PX * 2
      }
    }
  };
}, "getStyles");
var AdvertiserAvatarBase = forwardRef15(
  /* @__PURE__ */ __name(function AdvertiserAvatarBase2(props, ref) {
    const styles25 = getStyles18(
      props.responsiveSizes.desktop.width,
      props.responsiveSizes.mobile.width
    );
    const _a = props, { responsiveSizes: responsiveSizes10, src, srcSet, templateUrl } = _a, rest = __objRest(_a, ["responsiveSizes", "src", "srcSet", "templateUrl"]);
    const imageProps = {
      src,
      srcSet,
      width: responsiveSizes10.desktop.width,
      height: responsiveSizes10.desktop.width,
      templateUrl
    };
    return /* @__PURE__ */ jsx46(AvatarBase, __spreadProps(__spreadValues(__spreadValues({}, rest), imageProps), { styles: styles25, ref }));
  }, "AdvertiserAvatarBase")
);
AdvertiserAvatarBase.displayName = "AdvertiserAvatarBase";

// src/molecules/AdvertiserAvatar/AdvertiserAvatarSmall.tsx
import { jsx as jsx47 } from "@emotion/react/jsx-runtime";
var responsiveSizes4 = {
  desktop: {
    width: 48
  },
  mobile: {
    width: 36
  }
};
var AdvertiserAvatarSmall = forwardRef16(
  (props, ref) => {
    return /* @__PURE__ */ jsx47(AdvertiserAvatarBase, __spreadProps(__spreadValues({ responsiveSizes: responsiveSizes4 }, props), { ref }));
  }
);
AdvertiserAvatarSmall.displayName = "AdvertiserAvatarSmall";

// src/molecules/AdvertiserAvatar/AdvertiserAvatarMedium.tsx
import { forwardRef as forwardRef17 } from "react";
import { jsx as jsx48 } from "@emotion/react/jsx-runtime";
var responsiveSizes5 = {
  desktop: {
    width: 72
  },
  mobile: {
    width: 48
  }
};
var AdvertiserAvatarMedium = forwardRef17(
  (props, ref) => {
    return /* @__PURE__ */ jsx48(AdvertiserAvatarBase, __spreadProps(__spreadValues({ responsiveSizes: responsiveSizes5 }, props), { ref }));
  }
);
AdvertiserAvatarMedium.displayName = "AdvertiserAvatarMedium";

// src/molecules/AdvertiserAvatar/AdvertiserAvatarLarge.tsx
import { forwardRef as forwardRef18 } from "react";
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
var responsiveSizes6 = {
  desktop: {
    width: 96
  },
  mobile: {
    width: 64
  }
};
var AdvertiserAvatarLarge = forwardRef18(
  (props, ref) => {
    return /* @__PURE__ */ jsx49(AdvertiserAvatarBase, __spreadProps(__spreadValues({ responsiveSizes: responsiveSizes6 }, props), { ref }));
  }
);
AdvertiserAvatarLarge.displayName = "AdvertiserAvatarLarge";

// src/molecules/BasicIconInput/BasicIconInput.tsx
import { TextInputBase, useTheme as useTheme22 } from "@instacart/ids-core";
import { forwardRef as forwardRef19 } from "react";
import { jsx as jsx50 } from "@emotion/react/jsx-runtime";
var BasicIconInput = forwardRef19(
  /* @__PURE__ */ __name(function SingleLineTextInput(_a, ref) {
    var _b = _a, { icon, disabled } = _b, rest = __objRest(_b, ["icon", "disabled"]);
    const theme = useTheme22();
    return /* @__PURE__ */ jsx50(
      TextInputBase,
      __spreadProps(__spreadValues({
        styles: {
          leadingIcon: {
            "& > svg": { fill: disabled ? theme.colors.systemGrayscale30 : void 0 }
          }
        },
        leadingIcon: icon,
        disabled
      }, rest), {
        ref
      })
    );
  }, "SingleLineTextInput")
);

// src/molecules/ButtonCompactBase/ButtonCompactBase.tsx
import { forwardRef as forwardRef20 } from "react";
import { ButtonBase as ButtonBase2, combineStyles as combineStyles16 } from "@instacart/ids-core";
import { jsx as jsx51 } from "@emotion/react/jsx-runtime";
var baseStyles6 = /* @__PURE__ */ __name(() => ({
  button: {
    minWidth: 108
  },
  disabled: {},
  content: {},
  focusRing: {},
  hover: {},
  active: {},
  loading: {}
}), "baseStyles");
var ButtonCompactBase = forwardRef20(
  /* @__PURE__ */ __name(function ButtonCompactBase2(_a, ref) {
    var _b = _a, { styles: styles25 } = _b, props = __objRest(_b, ["styles"]);
    const combinedStyles = combineStyles16(baseStyles6(), styles25);
    return /* @__PURE__ */ jsx51(ButtonBase2, __spreadProps(__spreadValues({}, props), { styles: combinedStyles, ref }));
  }, "ButtonCompactBase")
);

// src/molecules/ButtonPill/ButtonPill.tsx
import { forwardRef as forwardRef22 } from "react";
import { useTheme as useTheme23, spacing as spacing9, useIsPantryEnabled } from "@instacart/ids-core";

// src/molecules/ButtonPillBase/ButtonPillBase.tsx
import { forwardRef as forwardRef21 } from "react";
import { combineStyles as combineStyles17 } from "@instacart/ids-core";
import { jsx as jsx52 } from "@emotion/react/jsx-runtime";
var baseStyles7 = {
  buttonWrapper: {
    position: "relative"
  },
  button: {}
};
var ButtonPillBase = forwardRef21(/* @__PURE__ */ __name(function ButtonPill(_a, ref) {
  var _b = _a, { children, active, disabled, onClick, styles: styles25 } = _b, rest = __objRest(_b, ["children", "active", "disabled", "onClick", "styles"]);
  const { buttonWrapper: buttonWrapperCSS, button: buttonCSS } = combineStyles17(baseStyles7, styles25);
  return /* @__PURE__ */ jsx52("span", { css: buttonWrapperCSS, ref, children: /* @__PURE__ */ jsx52("button", __spreadProps(__spreadValues({ onClick, disabled, css: buttonCSS, "aria-pressed": active }, rest), { children })) });
}, "ButtonPill"));

// src/molecules/ButtonPill/getSharedPillStyles.tsx
import { blendColors as blendColors2, spacing as spacing8 } from "@instacart/ids-core";
function getSharedPillStyles(theme, isPantryEnabled) {
  return __spreadProps(__spreadValues({
    textDecoration: "none",
    boxSizing: "border-box",
    userSelect: "none",
    border: `${BORDER_WIDTH2}px solid transparent`,
    minWidth: 58,
    height: isPantryEnabled ? spacing8.s32 : 28,
    background: isPantryEnabled ? theme.colors.systemGrayscale20 : theme.colors.systemGrayscale10,
    borderRadius: isPantryEnabled ? 18 : 14,
    color: isPantryEnabled ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale70
  }, theme.typography.bodyMedium1), {
    cursor: "pointer",
    margin: spacing8.s4,
    whiteSpace: "nowrap",
    "&.focus-visible::after": {
      borderRadius: isPantryEnabled ? 18 : 119,
      border: `${BORDER_WIDTH2}px solid ${isPantryEnabled ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: -5,
      bottom: -5,
      left: -5,
      right: -5
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    },
    "&:hover": {
      background: isPantryEnabled ? blendColors2(theme.colors.systemGrayscale20, theme.colors.systemGrayscale30, 51) : blendColors2(theme.colors.systemGrayscale10, theme.colors.systemGrayscale20, 51)
    },
    "&:active": {
      background: isPantryEnabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale20
    }
  });
}
__name(getSharedPillStyles, "getSharedPillStyles");

// src/molecules/ButtonPill/ButtonPill.tsx
import { jsx as jsx53 } from "@emotion/react/jsx-runtime";
var BORDER_WIDTH2 = 2;
var getStyles19 = /* @__PURE__ */ __name((theme, isSelected, isPantryEnabled) => ({
  button: __spreadValues(__spreadProps(__spreadValues({}, getSharedPillStyles(theme, isPantryEnabled)), {
    position: "relative",
    padding: `0px ${isPantryEnabled ? spacing9.s16 : spacing9.s12}px`,
    "&:disabled": __spreadValues({
      cursor: "default",
      background: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30
    }, isSelected && {
      borderColor: theme.colors.systemGrayscale30
    })
  }), isSelected && __spreadValues({
    background: isPantryEnabled ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale20,
    border: `${BORDER_WIDTH2}px solid ${isPantryEnabled ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale70}`,
    color: isPantryEnabled ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale70
  }, isPantryEnabled && {
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale60,
      borderColor: theme.colors.systemGrayscale60
    },
    "&:active": {
      backgroundColor: theme.colors.systemGrayscale70,
      borderColor: theme.colors.systemGrayscale70
    }
  }))
}), "getStyles");
var ButtonPill2 = forwardRef22(/* @__PURE__ */ __name(function ButtonPill3(_a, ref) {
  var _b = _a, { children, active, disabled, onClick } = _b, rest = __objRest(_b, ["children", "active", "disabled", "onClick"]);
  const theme = useTheme23();
  const isPantryEnabled = useIsPantryEnabled();
  const styles25 = getStyles19(theme, active, isPantryEnabled);
  return /* @__PURE__ */ jsx53(
    ButtonPillBase,
    __spreadProps(__spreadValues({}, rest), {
      disabled,
      styles: styles25,
      onClick,
      active,
      ref,
      children
    })
  );
}, "ButtonPill"));

// src/molecules/ButtonSmallBase/ButtonSmallBase.tsx
import { forwardRef as forwardRef23 } from "react";
import { ButtonBase as ButtonBase3, combineStyles as combineStyles18, useTheme as useTheme24 } from "@instacart/ids-core";
import { jsx as jsx54 } from "@emotion/react/jsx-runtime";
var baseStyles8 = /* @__PURE__ */ __name((theme) => ({
  button: {
    borderRadius: theme.radius.r8,
    height: 40,
    minWidth: 166
  },
  disabled: {},
  content: __spreadValues({}, theme.typography.bodyMedium1),
  focusRing: {
    borderRadius: theme.radius.r8
  },
  hover: {},
  active: {},
  loading: {}
}), "baseStyles");
var ButtonSmallBase = forwardRef23(
  /* @__PURE__ */ __name(function ButtonSmallBase2(_a, ref) {
    var _b = _a, { styles: styles25 } = _b, props = __objRest(_b, ["styles"]);
    const theme = useTheme24();
    const combinedStyles = combineStyles18(baseStyles8(theme), styles25);
    return /* @__PURE__ */ jsx54(ButtonBase3, __spreadProps(__spreadValues({}, props), { styles: combinedStyles, ref }));
  }, "ButtonSmallBase")
);

// src/molecules/CartButton/CartButton.tsx
import { forwardRef as forwardRef25 } from "react";
import { spacing as spacing11, useTheme as useTheme26, useIdsFeatureFlag as useIdsFeatureFlag3 } from "@instacart/ids-core";

// src/molecules/CartButtonBase/CartButtonBase.tsx
import { forwardRef as forwardRef24 } from "react";
import { CartIcon, combineStyles as combineStyles19 } from "@instacart/ids-core";
import { jsx as jsx55, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
var baseStyles9 = {
  button: {
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    touchAction: "manipulation",
    "&:disabled": {
      cursor: "default"
    }
  },
  text: {}
};
var CartButtonBase = forwardRef24(
  /* @__PURE__ */ __name(function CartButtonBase2(_a, ref) {
    var _b = _a, { styles: styles25, itemCount } = _b, rest = __objRest(_b, ["styles", "itemCount"]);
    const { button: buttonCSS, text: textCSS } = combineStyles19(baseStyles9, styles25);
    return /* @__PURE__ */ jsxs8("button", __spreadProps(__spreadValues({}, rest), { ref, css: buttonCSS, children: [
      /* @__PURE__ */ jsx55(CartIcon, { size: 24, color: itemCount === 0 ? "systemGrayscale70" : "systemGrayscale00" }),
      /* @__PURE__ */ jsx55("span", { css: textCSS, children: itemCount })
    ] }));
  }, "CartButtonBase")
);

// src/utils/useSharedButtonStyles.ts
import {
  blendColors as blendColors3,
  extractDWebTypographyStyles,
  responsive as responsive8,
  spacing as spacing10,
  useIdsFeatureFlag as useIdsFeatureFlag2,
  useTheme as useTheme25
} from "@instacart/ids-core";
import { useMemo } from "react";
var Size = /* @__PURE__ */ ((Size2) => {
  Size2[Size2["Regular"] = 0] = "Regular";
  Size2[Size2["Small"] = 1] = "Small";
  Size2[Size2["Compact"] = 2] = "Compact";
  return Size2;
})(Size || {});
function colorOrBlendedColor(color, theme) {
  if (typeof color === "string") {
    return theme.colors[color];
  }
  return blendColors3(theme.colors[color[0]], theme.colors[color[1]], 51);
}
__name(colorOrBlendedColor, "colorOrBlendedColor");
var COMPACT_HEIGHT_PX = 32;
var SMALL_HEIGHT_PX = 40;
var HEIGHT_PX = 56;
var PANTRY_HEIGHT_PX = 54;
var FOCUS_RING_OFFSET_PX = 4;
function useSharedButtonStyles({
  primaryColor,
  activeColor,
  hoverColor,
  textColor,
  borderColor,
  size = 0 /* Regular */
}) {
  const theme = useTheme25();
  const isPantryEnabled = useIdsFeatureFlag2("pantryButtons") === "variant";
  const isCoreXTypographyEnabled = useIdsFeatureFlag2("coreXTypography") === "variant";
  return useMemo(() => {
    const height = (() => {
      switch (size) {
        case 2 /* Compact */:
          return COMPACT_HEIGHT_PX;
        case 1 /* Small */:
          return SMALL_HEIGHT_PX;
        case 0 /* Regular */:
          return isPantryEnabled ? PANTRY_HEIGHT_PX : HEIGHT_PX;
      }
    })();
    const borderRadius = (() => {
      if (isPantryEnabled)
        return height / 2;
      return size === 0 /* Regular */ ? theme.radius.r12 : theme.radius.r8;
    })();
    const typography = (() => {
      if (isPantryEnabled) {
        if (isCoreXTypographyEnabled) {
          switch (size) {
            case 2 /* Compact */:
              return theme.typography.bodyEmphasized;
            case 1 /* Small */:
              return __spreadProps(__spreadValues({}, theme.typography.subtitle), {
                [responsive8.DESKTOP_SIZE]: extractDWebTypographyStyles(
                  theme.typography.bodyEmphasized
                )
              });
            case 0 /* Regular */:
              return __spreadProps(__spreadValues({}, theme.typography.title), {
                [responsive8.DESKTOP_SIZE]: extractDWebTypographyStyles(theme.typography.subtitle)
              });
          }
        }
        switch (size) {
          case 2 /* Compact */:
            return theme.typography.subtitleSmall;
          case 1 /* Small */:
            return theme.typography.subtitleMedium;
          case 0 /* Regular */:
            return theme.typography.subtitleLarge;
        }
      }
      switch (size) {
        case 2 /* Compact */:
          return theme.typography.bodySmall1;
        case 1 /* Small */:
          return theme.typography.bodyMedium1;
        case 0 /* Regular */:
          return theme.typography.bodyLarge1;
      }
    })();
    return {
      button: __spreadValues({
        backgroundColor: theme.colors[primaryColor],
        color: theme.colors[textColor],
        borderRadius,
        height,
        width: "100%",
        paddingLeft: spacing10.s16,
        paddingRight: spacing10.s16
      }, borderColor ? {
        border: `1px solid ${theme.colors[borderColor]}`
      } : {}),
      content: __spreadProps(__spreadValues({}, typography), {
        marginLeft: spacing10.s8,
        marginRight: spacing10.s8
      }),
      focusRing: {
        borderRadius: borderRadius + FOCUS_RING_OFFSET_PX
      },
      hover: {
        backgroundColor: colorOrBlendedColor(hoverColor, theme)
      },
      active: {
        backgroundColor: colorOrBlendedColor(activeColor, theme)
      },
      disabled: {
        backgroundColor: theme.colors.systemGrayscale10,
        color: theme.colors.systemGrayscale30
      },
      loading: {
        backgroundColor: colorOrBlendedColor(activeColor, theme)
      }
    };
  }, [
    activeColor,
    borderColor,
    hoverColor,
    isCoreXTypographyEnabled,
    isPantryEnabled,
    primaryColor,
    size,
    textColor,
    theme
  ]);
}
__name(useSharedButtonStyles, "useSharedButtonStyles");

// src/molecules/CartButton/CartButton.tsx
import { jsx as jsx56 } from "@emotion/react/jsx-runtime";
var CartButton = forwardRef25(/* @__PURE__ */ __name(function CartButton2(_a, ref) {
  var _b = _a, { itemCount } = _b, rest = __objRest(_b, ["itemCount"]);
  const theme = useTheme26();
  const isCoreXTypographyEnabled = useIdsFeatureFlag3("coreXTypography") === "variant";
  const sharedStyles = useSharedButtonStyles({
    activeColor: itemCount === 0 ? "systemGrayscale20" : "brandPrimaryDark",
    hoverColor: [
      itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
      itemCount === 0 ? "systemGrayscale20" : "brandPrimaryDark"
    ],
    primaryColor: itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
    textColor: itemCount === 0 ? "systemGrayscale70" : "systemGrayscale00",
    size: 1 /* Small */
  });
  const styles25 = {
    button: [
      sharedStyles.button,
      __spreadProps(__spreadValues({}, !isCoreXTypographyEnabled && theme.typography.bodyMedium1), {
        width: "auto",
        borderRadius: theme.radius.r24,
        display: "flex",
        flexDirection: "row",
        border: 0,
        paddingLeft: spacing11.s8,
        paddingRight: spacing11.s8,
        paddingTop: spacing11.s4,
        paddingBottom: spacing11.s4,
        position: "relative",
        height: spacing11.s32,
        minWidth: 57,
        justifyContent: "space-evenly",
        "@media(min-width: 1024px)": {
          height: spacing11.s40,
          minWidth: 65,
          padding: `${spacing11.s8}px ${spacing11.s12}px`
        },
        "&:focus": {
          outline: "none"
        },
        "&.focus-visible::after": {
          borderRadius: theme.radius.r24,
          border: `2px solid ${theme.colors.systemGrayscale70}`,
          content: '""',
          display: "block",
          position: "absolute",
          top: -4,
          bottom: -4,
          left: -4,
          right: -4
        },
        "&:hover": sharedStyles.hover,
        "&:active": sharedStyles.active,
        "&:disabled": sharedStyles.disabled
      })
    ],
    text: {
      padding: `0 ${spacing11.s4}px`
    }
  };
  return /* @__PURE__ */ jsx56(CartButtonBase, __spreadProps(__spreadValues({}, rest), { itemCount, styles: styles25, ref }));
}, "CartButton"));

// src/molecules/CategoryTabs/index.ts
import { useTabState } from "reakit";

// src/molecules/CategoryTabs/CategoryTabs.tsx
import { useMemo as useMemo2 } from "react";

// src/molecules/CategoryTabs/CategoryTabContext.ts
import { createContext } from "react";
var CategoryTabContextNonTabStateReturnValuesKeys = /* @__PURE__ */ ((CategoryTabContextNonTabStateReturnValuesKeys2) => {
  CategoryTabContextNonTabStateReturnValuesKeys2["alignment"] = "alignment";
  CategoryTabContextNonTabStateReturnValuesKeys2["inverseColorPalette"] = "inverseColorPalette";
  return CategoryTabContextNonTabStateReturnValuesKeys2;
})(CategoryTabContextNonTabStateReturnValuesKeys || {});
var CategoryTabContext = createContext({
  alignment: "spaceBetween",
  inverseColorPalette: false
});

// src/molecules/CategoryTabs/CategoryTabs.tsx
import { jsx as jsx57 } from "@emotion/react/jsx-runtime";
function CategoryTabs({
  alignment,
  children,
  tabState,
  inverseColorPalette = false
}) {
  const value = useMemo2(
    () => __spreadProps(__spreadValues({}, tabState), {
      alignment,
      orientation: "horizontal",
      manual: true,
      inverseColorPalette
    }),
    [tabState, inverseColorPalette, alignment]
  );
  return /* @__PURE__ */ jsx57(CategoryTabContext.Provider, { value, children });
}
__name(CategoryTabs, "CategoryTabs");

// src/molecules/CategoryTabs/CategoryTabList.tsx
import { useContext as useContext2, useRef as useRef2, useState, useEffect as useEffect2, useCallback } from "react";
import { TabList as BaseTabList } from "reakit";
import {
  useTheme as useTheme28,
  combineStyles as combineStyles20,
  spacing as spacing12,
  useScrollButtonVisibilityHandler,
  responsive as responsive10
} from "@instacart/ids-core";

// src/molecules/CategoryTabs/shared.ts
import { useIdsFeatureFlag as useIdsFeatureFlag4 } from "@instacart/ids-core";
var useTabMinHeight = /* @__PURE__ */ __name(() => {
  const coreXTypographyEnabled = useIdsFeatureFlag4("coreXTypography") === "variant";
  return coreXTypographyEnabled ? 68 : 58;
}, "useTabMinHeight");
var TAB_MIN_WIDTH = 64;
var ICON_SIZE = 24;

// src/molecules/CategoryTabs/PageButton.tsx
import {
  ChevronLeftIcon,
  ChevronRightIcon as ChevronRightIcon2,
  addAlphaToHex,
  responsive as responsive9,
  useTheme as useTheme27
} from "@instacart/ids-core";
import { useContext } from "react";
import { Fragment, jsx as jsx58, jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
var PAGE_BUTTON_HOVER_COLOR = "#EFE9E1";
function PageButton({
  alignment,
  onClick,
  backgroundColor
}) {
  const theme = useTheme27();
  const tab = useContext(CategoryTabContext);
  const horizontalPositioning = {
    left: alignment === "left" ? 0 : "auto",
    right: alignment === "right" ? 0 : "auto"
  };
  const Icon = alignment === "left" ? ChevronLeftIcon : ChevronRightIcon2;
  const gradientAngle = alignment === "left" ? 90 : 270;
  const hideOnMweb = {
    [`${responsive9.down("c")} and (pointer: none)`]: {
      display: "none"
    },
    [`${responsive9.down("c")} and (pointer: coarse)`]: {
      display: "none"
    }
  };
  const foregroundColorKey = tab.inverseColorPalette ? "systemGrayscale00" : "systemGrayscale80";
  const buttonBorderColor = tab.inverseColorPalette ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale30;
  const hoverColor = tab.inverseColorPalette ? theme.colors.systemGrayscale30 : PAGE_BUTTON_HOVER_COLOR;
  return /* @__PURE__ */ jsxs9(Fragment, { children: [
    /* @__PURE__ */ jsx58(
      "div",
      {
        css: __spreadValues(__spreadProps(__spreadValues({
          position: "absolute",
          top: 0,
          bottom: 0
        }, horizontalPositioning), {
          width: 102,
          zIndex: 1,
          backgroundImage: `linear-gradient(${gradientAngle}deg, ${theme.colors[backgroundColor]} 50%, ${addAlphaToHex(theme.colors[backgroundColor], 0)} 100%)`,
          pointerEvents: "none"
        }), hideOnMweb)
      }
    ),
    /* @__PURE__ */ jsx58(
      "div",
      {
        css: __spreadValues(__spreadProps(__spreadValues({
          // This prevents the faded portion of the tab from being clickable
          position: "absolute",
          top: 0,
          bottom: 0
        }, horizontalPositioning), {
          width: 58,
          zIndex: 1,
          backgroundColor: "transparent"
        }), hideOnMweb)
      }
    ),
    /* @__PURE__ */ jsx58(
      "button",
      {
        "aria-hidden": true,
        tabIndex: -1,
        css: __spreadValues(__spreadProps(__spreadValues({
          position: "absolute",
          top: 0,
          bottom: 0
        }, horizontalPositioning), {
          zIndex: 1,
          width: 36,
          height: 36,
          '[data-collapsed="true"] > &': {
            width: 32,
            height: 32
          },
          borderRadius: "100%",
          marginTop: "auto",
          marginBottom: "auto",
          backgroundColor: theme.colors[backgroundColor],
          border: `1px solid ${buttonBorderColor}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "background-color 50ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out",
          "&:hover": {
            backgroundColor: hoverColor
          }
        }), hideOnMweb),
        type: "button",
        onClick,
        children: /* @__PURE__ */ jsx58(Icon, { size: 18, color: foregroundColorKey })
      }
    )
  ] });
}
__name(PageButton, "PageButton");

// src/internal/omit.ts
function omit(keys, obj) {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (!keys.includes(key)) {
        return __spreadProps(__spreadValues({}, acc), {
          [key]: value
        });
      }
      return acc;
    },
    {}
  );
}
__name(omit, "omit");

// src/molecules/CategoryTabs/omitNonTabProps.ts
function omitNonTabProps(tab) {
  return omit(Object.values(CategoryTabContextNonTabStateReturnValuesKeys), tab);
}
__name(omitNonTabProps, "omitNonTabProps");

// src/molecules/CategoryTabs/CategoryTabList.tsx
import { jsx as jsx59, jsxs as jsxs10 } from "@emotion/react/jsx-runtime";
var getStyles20 = /* @__PURE__ */ __name((theme, {
  alignment,
  backgroundColor,
  tabMinHeight,
  collapsed
}) => ({
  container: {
    position: "relative",
    backgroundColor: theme.colors[backgroundColor],
    paddingTop: spacing12.s4,
    paddingLeft: 0,
    paddingRight: 0,
    [`${responsive10.down("c")} and (pointer: none)`]: {
      paddingLeft: 0,
      paddingRight: 0
    },
    [`${responsive10.down("c")} and (pointer: coarse)`]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  tabList: {
    overflowY: "hidden",
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0
    },
    display: "flex",
    justifyContent: alignment === "spaceBetween" ? "space-between" : "flex-start",
    gap: alignment === "left" ? spacing12.s8 : void 0,
    maxHeight: collapsed ? tabMinHeight - ICON_SIZE : tabMinHeight,
    transition: "max-height 200ms ease-in-out",
    boxSizing: "content-box"
  }
}), "getStyles");
function CategoryTabList(_a) {
  var _b = _a, {
    styles: styles25,
    collapsed,
    children,
    accessibleLabel,
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "styles",
    "collapsed",
    "children",
    "accessibleLabel",
    "backgroundColor"
  ]);
  var _a2;
  const theme = useTheme28();
  const tab = useContext2(CategoryTabContext);
  const tabMinHeight = useTabMinHeight();
  const combinedStyles = combineStyles20(
    getStyles20(theme, { backgroundColor, collapsed, tabMinHeight, alignment: tab.alignment }),
    styles25
  );
  const currentItem = (_a2 = tab.items) == null ? void 0 : _a2.find(({ id }) => id === tab.selectedId);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);
  const tabListRef = useRef2(null);
  useScrollButtonVisibilityHandler({
    setShowNextButton,
    setShowPreviousButton,
    listRef: tabListRef,
    children
  });
  useScrollItemToCenterOnFocus({ containerRef: tabListRef });
  useScrollFadedItemIntoViewOnSelect(currentItem == null ? void 0 : currentItem.ref, tabListRef);
  const onPageLeftClick = useCallback(() => {
    var _a3, _b2, _c;
    (_c = tabListRef.current) == null ? void 0 : _c.scrollBy({
      left: -1 * ((_b2 = (_a3 = tabListRef.current) == null ? void 0 : _a3.clientWidth) != null ? _b2 : 0) - TAB_MIN_WIDTH * 3,
      behavior: "smooth"
    });
  }, []);
  const onPageRightClick = useCallback(() => {
    var _a3, _b2, _c;
    (_c = tabListRef.current) == null ? void 0 : _c.scrollBy({
      left: ((_b2 = (_a3 = tabListRef.current) == null ? void 0 : _a3.clientWidth) != null ? _b2 : 0) - TAB_MIN_WIDTH * 3,
      behavior: "smooth"
    });
  }, []);
  return /* @__PURE__ */ jsxs10("div", { "data-collapsed": collapsed, css: combinedStyles.container, children: [
    showPreviousButton && /* @__PURE__ */ jsx59(PageButton, { backgroundColor, alignment: "left", onClick: onPageLeftClick }),
    /* @__PURE__ */ jsx59(
      BaseTabList,
      __spreadProps(__spreadValues(__spreadValues({
        ref: tabListRef,
        css: combinedStyles.tabList,
        "aria-label": accessibleLabel
      }, omitNonTabProps(tab)), rest), {
        children
      })
    ),
    showNextButton && /* @__PURE__ */ jsx59(
      PageButton,
      {
        backgroundColor,
        alignment: "right",
        onClick: onPageRightClick
      }
    )
  ] });
}
__name(CategoryTabList, "CategoryTabList");
function useScrollFadedItemIntoViewOnSelect(currentItemRef, tabListRef) {
  useEffect2(() => {
    const currentItemElement = currentItemRef == null ? void 0 : currentItemRef.current;
    const tabListElement = tabListRef == null ? void 0 : tabListRef.current;
    if (!currentItemElement || !tabListElement) {
      return;
    }
    const offsetFromLeftEdge = currentItemElement.getBoundingClientRect().left - tabListElement.getBoundingClientRect().left;
    const offsetFromRightEdge = tabListElement.getBoundingClientRect().right - currentItemElement.getBoundingClientRect().right;
    const FADE_OFFSET_FROM_EDGE = 86;
    const PEAK_ADJACENT_TAB = TAB_MIN_WIDTH / 2;
    let scrollAmount = 0;
    if (offsetFromLeftEdge <= FADE_OFFSET_FROM_EDGE) {
      scrollAmount = -1 * (FADE_OFFSET_FROM_EDGE - offsetFromLeftEdge + PEAK_ADJACENT_TAB);
    } else if (offsetFromRightEdge <= FADE_OFFSET_FROM_EDGE) {
      scrollAmount = FADE_OFFSET_FROM_EDGE - offsetFromRightEdge + PEAK_ADJACENT_TAB;
    } else {
      return;
    }
    tabListElement.scrollBy({
      left: scrollAmount,
      behavior: "smooth"
    });
  }, [currentItemRef, tabListRef]);
}
__name(useScrollFadedItemIntoViewOnSelect, "useScrollFadedItemIntoViewOnSelect");
function useScrollItemToCenterOnFocus({ containerRef }) {
  useEffect2(() => {
    if (!containerRef.current) {
      return;
    }
    const tabListElement = containerRef.current;
    tabListElement.addEventListener("keydown", onTabFocused);
    function onTabFocused(e) {
      if (!tabListElement || !["ArrowLeft", "ArrowRight"].includes(e.key)) {
        return;
      }
      const eventTarget = e.target;
      const currentItemElement = e.key === "ArrowRight" ? eventTarget.nextElementSibling : eventTarget.previousElementSibling;
      if (!currentItemElement) {
        return;
      }
      tabListElement.scrollTo({
        left: currentItemElement.offsetLeft - tabListElement.clientWidth / 2 + currentItemElement.clientWidth / 2
      });
    }
    __name(onTabFocused, "onTabFocused");
    return () => {
      tabListElement.removeEventListener("keydown", onTabFocused);
    };
  }, [containerRef]);
}
__name(useScrollItemToCenterOnFocus, "useScrollItemToCenterOnFocus");

// src/molecules/CategoryTabs/CategoryTab.tsx
import { useContext as useContext3 } from "react";
import { Tab as BaseTab } from "reakit";
import {
  useTheme as useTheme29,
  spacing as spacing13,
  responsive as responsive11,
  useIdsFeatureFlag as useIdsFeatureFlag5
} from "@instacart/ids-core";
import { jsx as jsx60, jsxs as jsxs11 } from "@emotion/react/jsx-runtime";
var PADDING_X_SIDE = 8;
var TEXT_MAX_WIDTH = 128;
function CategoryTab(_a) {
  var _b = _a, {
    children,
    icon: Icon,
    selectedIcon: SelectedIcon
  } = _b, rest = __objRest(_b, [
    "children",
    "icon",
    "selectedIcon"
  ]);
  const theme = useTheme29();
  const tab = useContext3(CategoryTabContext);
  const foregroundColorKey = tab.inverseColorPalette ? "systemGrayscale00" : "systemGrayscale80";
  const foregroundColor = theme.colors[foregroundColorKey];
  const coreXTypographyEnabled = useIdsFeatureFlag5("coreXTypography") === "variant";
  const tabMinHeight = useTabMinHeight();
  const selectedUnderlineCss = {
    borderRadius: 1,
    content: '""',
    display: "block",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 2,
    background: foregroundColor
  };
  return /* @__PURE__ */ jsxs11(
    BaseTab,
    __spreadProps(__spreadValues(__spreadValues({}, omitNonTabProps(tab)), rest), {
      type: "button",
      css: {
        flexShrink: 0,
        minHeight: tabMinHeight - ICON_SIZE,
        cursor: "pointer",
        backgroundColor: "transparent",
        position: "relative",
        borderRadius: theme.radius.r8,
        maxWidth: TEXT_MAX_WIDTH + PADDING_X_SIDE * 2,
        paddingTop: spacing13.s4,
        paddingRight: PADDING_X_SIDE,
        paddingBottom: coreXTypographyEnabled ? 12 : 10,
        paddingLeft: PADDING_X_SIDE,
        color: foregroundColor,
        border: "0",
        minWidth: TAB_MIN_WIDTH + spacing13.s16 - 4,
        [responsive11.up("r")]: {
          minWidth: TAB_MIN_WIDTH + spacing13.s32 - 4
        },
        // Prevent sticky hover on touch devices
        "@media(hover: hover) and (pointer: fine)": {
          "&:hover::before": selectedUnderlineCss
        },
        '&[aria-selected="true"]::before': selectedUnderlineCss,
        "&:focus": {
          outline: "none"
        },
        // Add a border to indicate focus
        "&.focus-visible::after": {
          borderRadius: `${theme.radius.r12}px ${theme.radius.r12}px 0 0`,
          content: '""',
          display: "block",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 4,
          left: 0,
          border: `solid 2px ${foregroundColor}`
        },
        "& span": {
          display: "block",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden"
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      },
      children: [
        /* @__PURE__ */ jsxs11(
          "span",
          {
            css: {
              position: "relative",
              maxHeight: ICON_SIZE,
              minHeight: 0,
              marginBottom: coreXTypographyEnabled ? spacing13.s8 : spacing13.s4,
              flexShrink: 1,
              minWidth: TAB_MIN_WIDTH
            },
            children: [
              /* @__PURE__ */ jsx60(
                Icon,
                {
                  css: {
                    opacity: 1,
                    '[aria-selected="true"] > span > &, button:active &': {
                      opacity: 0
                    },
                    transition: "opacity 200ms ease-in-out"
                  },
                  size: ICON_SIZE,
                  "aria-hidden": true,
                  color: foregroundColorKey
                }
              ),
              /* @__PURE__ */ jsx60(
                SelectedIcon,
                {
                  css: {
                    position: "absolute",
                    transition: "opacity 200ms ease-in-out",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    marginLeft: "auto",
                    marginRight: "auto",
                    opacity: 0,
                    '[aria-selected="true"] > span > &, button:active &': {
                      opacity: 1
                    }
                  },
                  size: ICON_SIZE,
                  "aria-hidden": true,
                  color: foregroundColorKey
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx60(
          "span",
          {
            css: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
              '[data-collapsed="true"] &': {
                padding: `${spacing13.s4}px 0`
              },
              flexShrink: 0,
              minWidth: TAB_MIN_WIDTH,
              maxWidth: TEXT_MAX_WIDTH
            }),
            children
          }
        )
      ]
    })
  );
}
__name(CategoryTab, "CategoryTab");

// src/molecules/CategoryTabs/CategoryTabPanel.tsx
import { useContext as useContext4 } from "react";
import { TabPanel as BaseTabPanel } from "reakit";
import { useTheme as useTheme30 } from "@instacart/ids-core";
import { jsx as jsx61 } from "@emotion/react/jsx-runtime";
function CategoryTabPanel(props) {
  const tab = useContext4(CategoryTabContext);
  const theme = useTheme30();
  const foregroundColor = tab.inverseColorPalette ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale80;
  return /* @__PURE__ */ jsx61(
    BaseTabPanel,
    __spreadProps(__spreadValues(__spreadValues({}, omitNonTabProps(tab)), props), {
      css: {
        position: "relative",
        "&:focus": {
          outline: "none"
        },
        "&.focus-visible::after": {
          borderRadius: theme.radius.r12,
          content: '""',
          display: "block",
          position: "absolute",
          top: -4,
          right: -4,
          bottom: -4,
          left: -4,
          border: `solid 2px ${foregroundColor}`
        }
      }
    })
  );
}
__name(CategoryTabPanel, "CategoryTabPanel");

// src/molecules/CouponClipButton/CouponClipButton.tsx
import { forwardRef as forwardRef26 } from "react";
import {
  ButtonBase as ButtonBase5,
  responsive as responsive12,
  spacing as spacing14,
  useTheme as useTheme31
} from "@instacart/ids-core";
import { jsx as jsx62 } from "@emotion/react/jsx-runtime";
var CouponClipButton = forwardRef26(
  /* @__PURE__ */ __name(function CouponClipButton2(_a, ref) {
    var _b = _a, { children, applied } = _b, rest = __objRest(_b, ["children", "applied"]);
    const theme = useTheme31();
    const styles25 = {
      button: {
        backgroundColor: theme.colors.brandPromotionalLight,
        color: theme.colors.brandPromotionalRegular,
        height: 32,
        width: "100%",
        borderRadius: theme.radius.r8
      },
      content: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
        marginLeft: spacing14.s12,
        marginRight: spacing14.s12,
        [responsive12.up("r")]: __spreadValues({}, theme.typography.bodyMedium1)
      }),
      focusRing: {
        borderRadius: theme.radius.r12
      },
      hover: {
        color: theme.colors.brandPromotionalDark
      },
      active: {
        backgroundColor: theme.colors.brandPromotionalLight,
        color: theme.colors.brandPromotionalDark
      },
      disabled: {
        // button is disabled when coupon is applied
        backgroundColor: theme.colors.systemGrayscale00,
        color: theme.colors.brandPromotionalDark
      },
      loading: {
        backgroundColor: theme.colors.brandPromotionalLight,
        color: theme.colors.brandPromotionalDark
      }
    };
    return /* @__PURE__ */ jsx62(ButtonBase5, __spreadProps(__spreadValues({}, rest), { styles: styles25, ref, disabled: applied, children }));
  }, "CouponClipButton")
);

// src/molecules/Divider/Divider.tsx
import { DividerBase, spacing as spacing15 } from "@instacart/ids-core";
import { jsx as jsx63 } from "@emotion/react/jsx-runtime";
function Divider(props) {
  return /* @__PURE__ */ jsx63(
    DividerBase,
    __spreadProps(__spreadValues({}, props), {
      styles: { divider: { marginTop: spacing15.s16, marginBottom: spacing15.s16 } }
    })
  );
}
__name(Divider, "Divider");

// src/molecules/GroupCartButton/GroupCartButton.tsx
import { forwardRef as forwardRef28 } from "react";
import { spacing as spacing16, useTheme as useTheme32, useIdsFeatureFlag as useIdsFeatureFlag6 } from "@instacart/ids-core";

// src/molecules/GroupCartButtonBase/GroupCartButtonBase.tsx
import { forwardRef as forwardRef27 } from "react";
import { GroupIcon, CartIcon as CartIcon2, combineStyles as combineStyles21 } from "@instacart/ids-core";
import { jsx as jsx64, jsxs as jsxs12 } from "@emotion/react/jsx-runtime";
var baseStyles10 = {
  button: {
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    touchAction: "manipulation",
    "&:disabled": {
      cursor: "default"
    }
  },
  text: {}
};
var GroupCartButtonBase = forwardRef27(
  /* @__PURE__ */ __name(function GroupCartButtonBase2(_a, ref) {
    var _b = _a, { styles: styles25, itemCount } = _b, rest = __objRest(_b, ["styles", "itemCount"]);
    const { button: buttonCSS, text: textCSS } = combineStyles21(baseStyles10, styles25);
    return /* @__PURE__ */ jsxs12("button", __spreadProps(__spreadValues({}, rest), { ref, css: buttonCSS, children: [
      /* @__PURE__ */ jsx64(GroupIcon, { size: 24, color: itemCount === 0 ? "systemGrayscale70" : "systemGrayscale00" }),
      /* @__PURE__ */ jsx64(CartIcon2, { size: 24, color: itemCount === 0 ? "systemGrayscale70" : "systemGrayscale00" }),
      /* @__PURE__ */ jsx64("span", { css: textCSS, children: itemCount })
    ] }));
  }, "GroupCartButtonBase")
);

// src/molecules/GroupCartButton/GroupCartButton.tsx
import { jsx as jsx65 } from "@emotion/react/jsx-runtime";
var GroupCartButton = forwardRef28(
  /* @__PURE__ */ __name(function GroupCartButton2(_a, ref) {
    var _b = _a, { itemCount } = _b, rest = __objRest(_b, ["itemCount"]);
    const theme = useTheme32();
    const isCoreXTypographyEnabled = useIdsFeatureFlag6("coreXTypography") === "variant";
    const sharedStyles = useSharedButtonStyles({
      activeColor: itemCount === 0 ? "systemGrayscale20" : "brandPrimaryDark",
      hoverColor: [
        itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
        itemCount === 0 ? "systemGrayscale20" : "brandPrimaryDark"
      ],
      primaryColor: itemCount === 0 ? "systemGrayscale10" : "brandPrimaryRegular",
      textColor: itemCount === 0 ? "systemGrayscale70" : "systemGrayscale00",
      size: 1 /* Small */
    });
    const styles25 = {
      button: [
        sharedStyles.button,
        __spreadProps(__spreadValues({}, !isCoreXTypographyEnabled && theme.typography.bodyMedium1), {
          width: "auto",
          borderRadius: theme.radius.r24,
          display: "flex",
          flexDirection: "row",
          border: 0,
          paddingLeft: spacing16.s8,
          paddingRight: spacing16.s8,
          paddingTop: spacing16.s4,
          paddingBottom: spacing16.s4,
          position: "relative",
          height: spacing16.s32,
          minWidth: 57,
          justifyContent: "space-evenly",
          "@media(min-width: 1024px)": {
            height: spacing16.s40,
            minWidth: 65,
            padding: `${spacing16.s8}px ${spacing16.s12}px`
          },
          "&:focus": {
            outline: "none"
          },
          "&.focus-visible::after": {
            borderRadius: theme.radius.r24,
            border: `2px solid ${theme.colors.systemGrayscale70}`,
            content: '""',
            display: "block",
            position: "absolute",
            top: -4,
            bottom: -4,
            left: -4,
            right: -4
          },
          "&:hover": sharedStyles.hover,
          "&:active": sharedStyles.active,
          "&:disabled": sharedStyles.disabled
        })
      ],
      text: {
        padding: `0 ${spacing16.s4}px`
      }
    };
    return /* @__PURE__ */ jsx65(GroupCartButtonBase, __spreadProps(__spreadValues({}, rest), { itemCount, styles: styles25, ref }));
  }, "GroupCartButton")
);

// src/molecules/DetrimentalButton/DetrimentalButton.tsx
import { forwardRef as forwardRef29 } from "react";
import { ButtonBase as ButtonBase6 } from "@instacart/ids-core";
import { jsx as jsx66 } from "@emotion/react/jsx-runtime";
var DetrimentalButton = forwardRef29(
  /* @__PURE__ */ __name(function DetrimentalButton2(_a, ref) {
    var rest = __objRest(_a, []);
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemDetrimentalRegular",
      activeColor: "systemDetrimentalDark",
      hoverColor: ["systemDetrimentalRegular", "systemDetrimentalDark"],
      textColor: "systemGrayscale00"
    });
    return /* @__PURE__ */ jsx66(ButtonBase6, __spreadProps(__spreadValues({}, rest), { styles: styles25, ref }));
  }, "DetrimentalButton")
);

// src/molecules/DetrimentalButtonCompact/DetrimentalButtonCompact.tsx
import { forwardRef as forwardRef30 } from "react";
import { jsx as jsx67 } from "@emotion/react/jsx-runtime";
var DetrimentalButtonCompact = forwardRef30(/* @__PURE__ */ __name(function DetrimentalButtonCompact2(props, ref) {
  const styles25 = useSharedButtonStyles({
    primaryColor: "systemDetrimentalRegular",
    activeColor: "systemDetrimentalDark",
    hoverColor: ["systemDetrimentalRegular", "systemDetrimentalDark"],
    textColor: "systemGrayscale00",
    size: 2 /* Compact */
  });
  return /* @__PURE__ */ jsx67(ButtonCompactBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
}, "DetrimentalButtonCompact"));

// src/molecules/DetrimentalButtonSmall/DetrimentalButtonSmall.tsx
import { forwardRef as forwardRef31 } from "react";
import { jsx as jsx68 } from "@emotion/react/jsx-runtime";
var DetrimentalButtonSmall = forwardRef31(
  /* @__PURE__ */ __name(function DetrimentalButtonSmall2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemDetrimentalRegular",
      activeColor: "systemDetrimentalDark",
      hoverColor: ["systemDetrimentalRegular", "systemDetrimentalDark"],
      textColor: "systemGrayscale00",
      size: 1 /* Small */
    });
    return /* @__PURE__ */ jsx68(ButtonSmallBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "DetrimentalButtonSmall")
);

// src/molecules/IconButton/IconButton.tsx
import { forwardRef as forwardRef32 } from "react";
import { ButtonBase as ButtonBase7, useTheme as useTheme33 } from "@instacart/ids-core";
import { jsx as jsx69 } from "@emotion/react/jsx-runtime";
var IconButton = forwardRef32(/* @__PURE__ */ __name(function IconButton2(_a, ref) {
  var _b = _a, { icon: Icon, color, disabled, accessibleLabel } = _b, rest = __objRest(_b, ["icon", "color", "disabled", "accessibleLabel"]);
  const theme = useTheme33();
  const styles25 = {
    button: {
      backgroundColor: "transparent",
      borderRadius: theme.radius.r8,
      height: 40,
      width: 40,
      border: "none",
      position: "relative",
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible::after": {
        borderRadius: theme.radius.r12,
        border: `2px solid ${theme.colors.systemGrayscale70}`,
        content: '""',
        display: "block",
        position: "absolute",
        top: -4,
        bottom: -4,
        left: -4,
        right: -4
      },
      "&:hover": {
        backgroundColor: theme.colors.systemGrayscale10
      },
      "&:active": {
        backgroundColor: theme.colors.systemGrayscale20
      },
      "&:disabled": {
        backgroundColor: "transparent",
        color: theme.colors.systemGrayscale30
      }
    },
    content: {
      lineHeight: 1
    }
  };
  return /* @__PURE__ */ jsx69(
    ButtonBase7,
    __spreadProps(__spreadValues({
      "aria-label": accessibleLabel,
      styles: styles25,
      disabled
    }, rest), {
      ref,
      children: /* @__PURE__ */ jsx69(Icon, { size: 24, color: disabled ? "systemGrayscale30" : color })
    })
  );
}, "IconButton"));
IconButton.displayName = "IconButton";

// src/molecules/InstacartPlusButton/InstacartPlusButton.tsx
import { forwardRef as forwardRef33 } from "react";
import { ButtonBase as ButtonBase8 } from "@instacart/ids-core";
import { jsx as jsx70 } from "@emotion/react/jsx-runtime";
var InstacartPlusButton = forwardRef33(
  /* @__PURE__ */ __name(function InstacartPlusButton2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "plusRegular",
      activeColor: "plusDark",
      hoverColor: ["plusRegular", "plusDark"],
      textColor: "systemGrayscale00"
    });
    return /* @__PURE__ */ jsx70(ButtonBase8, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "InstacartPlusButton")
);

// src/molecules/InstacartPlusButtonCompact/InstacartPlusButtonCompact.tsx
import { forwardRef as forwardRef34 } from "react";
import { jsx as jsx71 } from "@emotion/react/jsx-runtime";
var InstacartPlusButtonCompact = forwardRef34(/* @__PURE__ */ __name(function InstacartPlusButtonCompact2(props, ref) {
  const styles25 = useSharedButtonStyles({
    primaryColor: "plusRegular",
    activeColor: "plusDark",
    hoverColor: ["plusRegular", "plusDark"],
    textColor: "systemGrayscale00",
    size: 2 /* Compact */
  });
  return /* @__PURE__ */ jsx71(ButtonCompactBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
}, "InstacartPlusButtonCompact"));

// src/molecules/InstacartPlusButtonSmall/InstacartPlusButtonSmall.tsx
import { forwardRef as forwardRef35 } from "react";
import { jsx as jsx72 } from "@emotion/react/jsx-runtime";
var InstacartPlusButtonSmall = forwardRef35(/* @__PURE__ */ __name(function InstacartPlusButtonSmall2(props, ref) {
  const styles25 = useSharedButtonStyles({
    primaryColor: "plusRegular",
    activeColor: "plusDark",
    hoverColor: ["plusRegular", "plusDark"],
    textColor: "systemGrayscale00",
    size: 1 /* Small */
  });
  return /* @__PURE__ */ jsx72(ButtonSmallBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
}, "InstacartPlusButtonSmall"));

// src/molecules/InlineTextButton/InlineTextButton.tsx
import {
  ButtonBase as ButtonBase9,
  ChevronDownIcon,
  ChevronRightIcon as ChevronRightIcon3,
  spacing as spacing17,
  useTheme as useTheme34
} from "@instacart/ids-core";
import { cloneElement as cloneElement3, forwardRef as forwardRef36 } from "react";
import { isElement as isElement2 } from "react-is";
import { jsx as jsx73, jsxs as jsxs13 } from "@emotion/react/jsx-runtime";
var getStyles21 = /* @__PURE__ */ __name((theme, colorStyle) => ({
  button: {
    backgroundColor: "transparent"
  },
  focusRing: {
    borderRadius: 16,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  content: __spreadProps(__spreadValues({
    padding: `${spacing17.s4}px ${spacing17.s12}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 2
  }, theme.typography.bodySmall1), {
    color: colorStyle ? theme.colors[colorStyle] : theme.colors.systemGrayscale70
  })
}), "getStyles");
var InlineTextButton = forwardRef36(
  (props, ref) => {
    const theme = useTheme34();
    const _a = props, { leadingIcon: LeadingIcon, children, colorStyle } = _a, rest = __objRest(_a, ["leadingIcon", "children", "colorStyle"]);
    const styles25 = getStyles21(theme, colorStyle);
    const TrailingIcon = LeadingIcon ? ChevronDownIcon : ChevronRightIcon3;
    return /* @__PURE__ */ jsxs13(ButtonBase9, __spreadProps(__spreadValues({ styles: styles25 }, rest), { ref, children: [
      LeadingIcon && (isElement2(LeadingIcon) ? renderIconElement(LeadingIcon) : /* @__PURE__ */ jsx73(LeadingIcon, { "aria-hidden": true, size: 14 })),
      /* @__PURE__ */ jsx73("span", { children }),
      /* @__PURE__ */ jsx73(TrailingIcon, { size: 14, "aria-hidden": true })
    ] }));
  }
);
function renderIconElement(element) {
  return cloneElement3(element, { "aria-hidden": true, size: 14 });
}
__name(renderIconElement, "renderIconElement");
InlineTextButton.displayName = "InlineTextButton";

// src/molecules/ItemB/ItemB.tsx
import { useTheme as useTheme35, CompositionValidator as CompositionValidator6 } from "@instacart/ids-core";
import { forwardRef as forwardRef37 } from "react";

// src/molecules/ItemB/itemBValidations.ts
import {
  CompositionOrderError as CompositionOrderError4,
  CompositionTooFewItemsError as CompositionTooFewItemsError3,
  CompositionTooManyItemsError as CompositionTooManyItemsError5
} from "@instacart/ids-core";

// src/molecules/ItemB/Top.tsx
import { spacing as spacing18, CompositionValidator as CompositionValidator4 } from "@instacart/ids-core";

// src/molecules/ItemB/topBottomValidations.ts
import { CompositionTooManyItemsError as CompositionTooManyItemsError4 } from "@instacart/ids-core";
var validateTop = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, compareItemByKind } = engine;
  const allChildren = getAllChildren();
  expect(allChildren).toHaveLength(1);
  expect(compareItemByKind(allChildren[0], ItemImageBase)).toEqual(true);
}, "validateTop");
var validateBottom = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind } = engine;
  expect(findAllByKind(ItemImageBase)).toHaveLength(0);
  try {
    expect(findAllByKind(ItemDynamicLabelBase).length).toBeLessThan(3);
  } catch (e) {
    throw new CompositionTooManyItemsError4(ItemDynamicLabelBase);
  }
}, "validateBottom");

// src/molecules/ItemB/Top.tsx
import { jsx as jsx74 } from "@emotion/react/jsx-runtime";
var styles4 = {
  marginBottom: spacing18.s8
};
var validator4 = new CompositionValidator4([validateTop]);
function Top(props) {
  const { children } = props;
  validator4.validate(children);
  return /* @__PURE__ */ jsx74("div", { css: styles4, children });
}
__name(Top, "Top");

// src/molecules/ItemB/Bottom.tsx
import { CompositionValidator as CompositionValidator5 } from "@instacart/ids-core";
import { jsx as jsx75 } from "@emotion/react/jsx-runtime";
var validator5 = new CompositionValidator5([validateBottom]);
function Bottom(props) {
  const { children } = props;
  validator5.validate(children);
  return /* @__PURE__ */ jsx75("div", { children });
}
__name(Bottom, "Bottom");

// src/molecules/ItemB/itemBValidations.ts
var validateItem2 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind, compareItemByKind } = engine;
  const all = getAll();
  const topIndex = flatIndexOfByKind(Top);
  const bottomIndex = flatIndexOfByKind(Bottom);
  const foundTops = all.filter((item) => compareItemByKind(item, Top));
  try {
    expect(foundTops).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundTops.length < 1) {
      throw new CompositionTooFewItemsError3(Top, addtl);
    } else {
      throw new CompositionTooManyItemsError5(Bottom, addtl);
    }
  }
  const foundBottoms = all.filter((item) => compareItemByKind(item, Bottom));
  expect(foundBottoms).toHaveLength(1);
  try {
    expect(topIndex).toBeLessThan(bottomIndex);
  } catch (e) {
    throw new CompositionOrderError4(all[topIndex], all[bottomIndex]);
  }
  const itemPriceIndex = flatIndexOfByKind(ItemPrice);
  const itemNameIndex = flatIndexOfByKind(ItemName);
  if (itemPriceIndex > -1 && itemNameIndex > -1) {
    try {
      expect(itemPriceIndex).toBeLessThan(itemNameIndex);
    } catch (e) {
      throw new CompositionOrderError4(all[itemPriceIndex], all[itemNameIndex]);
    }
  }
}, "validateItem");

// src/molecules/ItemB/ItemB.tsx
import { jsx as jsx76 } from "@emotion/react/jsx-runtime";
var validator6 = new CompositionValidator6([validateItem2]);
var ItemB = forwardRef37(/* @__PURE__ */ __name(function ItemB2(props, ref) {
  const { children, styles: containerStyles3 } = props;
  const theme = useTheme35();
  validator6.validate(children);
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      // TODO: spec says r16 but it doesn't exist in ids-core
      // TODO: verify with design if this should be on the container, figma is not consistent
      //       it's definately on the focus ring
      borderRadius: theme.radius.r12
    })
  };
  return /* @__PURE__ */ jsx76(ItemBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
}, "ItemB"));

// src/molecules/ItemB/ItemBLink.tsx
import { useTheme as useTheme36 } from "@instacart/ids-core";
import { forwardRef as forwardRef38 } from "react";
import { jsx as jsx77 } from "@emotion/react/jsx-runtime";
var ItemBLink = forwardRef38(
  /* @__PURE__ */ __name(function ItemBLink2(props, ref) {
    const theme = useTheme36();
    const styles25 = {
      a: __spreadValues({}, props.styles),
      focusRing: {
        // TODO: find a way to tie `a` borderRadius to the focusRing automagically
        borderRadius: theme.radius.r12
      }
    };
    return /* @__PURE__ */ jsx77(ItemLinkBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
  }, "ItemBLink")
);

// src/molecules/ItemB/ItemBButton.tsx
import { useTheme as useTheme38 } from "@instacart/ids-core";

// src/atoms/ItemButtonBase/ItemButtonBase.tsx
import { useTheme as useTheme37, combineStyles as combineStyles22 } from "@instacart/ids-core";
import { jsx as jsx78 } from "@emotion/react/jsx-runtime";
var getStyles22 = /* @__PURE__ */ __name((theme) => ({
  a: {
    textDecoration: "none",
    // so we get one solid focus ring
    display: "block",
    // so the focus ring can use position: absolute
    position: "relative"
  },
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4
  }
}), "getStyles");
function ItemButtonBase(props) {
  const _a = props, { children, styles: styles25 } = _a, rest = __objRest(_a, ["children", "styles"]);
  const theme = useTheme37();
  const { a, focusRing } = combineStyles22(getStyles22(theme), styles25);
  const aStyles = [
    a,
    {
      "&:hover": {
        // surpress the native underlines
        textDecoration: "none"
      },
      "&:focus": {
        // surpress the native focus ring
        outline: "none",
        // surpress the native underlines
        textDecoration: "none"
      },
      "&.focus-visible::after": focusRing
    }
  ];
  return /* @__PURE__ */ jsx78("a", __spreadProps(__spreadValues({ role: "button", css: aStyles }, rest), { children }));
}
__name(ItemButtonBase, "ItemButtonBase");

// src/molecules/ItemB/ItemBButton.tsx
import { jsx as jsx79 } from "@emotion/react/jsx-runtime";
function ItemBButton(props) {
  const theme = useTheme38();
  const styles25 = {
    a: __spreadValues({}, props.styles),
    focusRing: {
      // TODO: find a way to tie `button` borderRadius to the focusRing automagically
      borderRadius: theme.radius.r12
    }
  };
  return /* @__PURE__ */ jsx79(ItemButtonBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(ItemBButton, "ItemBButton");

// src/molecules/ItemB/ItemBAddItem.tsx
import { spacing as spacing19 } from "@instacart/ids-core";
import { jsx as jsx80 } from "@emotion/react/jsx-runtime";
var { s4: s42 } = spacing19;
var styles5 = {
  position: "absolute",
  top: s42,
  right: s42,
  // make sure this is above the item itself for clicking
  zIndex: 2,
  // because ItemBLink sets it's own pointer, we need to override here
  cursor: "auto"
};
function ItemBAddItem(props) {
  return (
    // this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ jsx80(
      "div",
      {
        css: styles5,
        onClick: (e) => {
          e.preventDefault();
        },
        children: /* @__PURE__ */ jsx80(AddItem, __spreadValues({}, props))
      }
    )
  );
}
__name(ItemBAddItem, "ItemBAddItem");

// src/molecules/ItemB/ItemBCouponClipButton.tsx
import { spacing as spacing20 } from "@instacart/ids-core";
import { jsx as jsx81 } from "@emotion/react/jsx-runtime";
var { s4: s43 } = spacing20;
var styles6 = {
  paddingTop: s43,
  // because ItemBLink sets it's own pointer, we need to override here
  cursor: "auto"
};
function ItemBCouponClipButton(props) {
  return (
    // this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ jsx81(
      "div",
      {
        css: styles6,
        onClick: (e) => {
          e.preventDefault();
        },
        children: /* @__PURE__ */ jsx81(CouponClipButton, __spreadValues({}, props))
      }
    )
  );
}
__name(ItemBCouponClipButton, "ItemBCouponClipButton");

// src/molecules/ItemB/index.ts
var ItemB3 = {
  AddItem: ItemBAddItem,
  Bottom,
  CouponClipButton: ItemBCouponClipButton,
  Item: ItemB,
  ItemAttribute,
  ItemDynamicLabel,
  ItemImage,
  ItemImageBase,
  ItemLink: ItemBLink,
  ItemButton: ItemBButton,
  ItemName,
  ItemPrice,
  ItemPriceSet,
  ItemRegularPrice,
  ItemWeight,
  Top
};

// src/molecules/ItemA/index.ts
var ItemA = ItemB3;

// src/molecules/ItemC/ItemC.tsx
import { CompositionValidator as CompositionValidator9, useTheme as useTheme39, spacing as spacing22 } from "@instacart/ids-core";
import { forwardRef as forwardRef39 } from "react";

// src/molecules/ItemC/itemCValidations.ts
import {
  CompositionOrderError as CompositionOrderError5,
  CompositionTooFewItemsError as CompositionTooFewItemsError4,
  CompositionTooManyItemsError as CompositionTooManyItemsError7
} from "@instacart/ids-core";

// src/molecules/ItemC/Left.tsx
import { spacing as spacing21, CompositionValidator as CompositionValidator7 } from "@instacart/ids-core";

// src/molecules/ItemC/leftRightValidations.ts
import { CompositionTooManyItemsError as CompositionTooManyItemsError6 } from "@instacart/ids-core";
var validateLeft = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, compareItemByKind } = engine;
  const all = getAll();
  expect(all).toHaveLength(1);
  expect(compareItemByKind(all[0], ItemImageBase)).toEqual(true);
}, "validateLeft");
var validateRight = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind } = engine;
  expect(findAllByKind(ItemImageBase)).toHaveLength(0);
  try {
    expect(findAllByKind(ItemDynamicLabel).length).toBeLessThan(2);
  } catch (e) {
    throw new CompositionTooManyItemsError6(ItemDynamicLabel);
  }
}, "validateRight");

// src/molecules/ItemC/Left.tsx
import { jsx as jsx82 } from "@emotion/react/jsx-runtime";
var styles7 = {
  marginRight: spacing21.s12,
  flex: "0 0 96px"
};
var validator7 = new CompositionValidator7([validateLeft]);
function Left(props) {
  const { children } = props;
  validator7.validate(children);
  return /* @__PURE__ */ jsx82("div", { css: styles7, children });
}
__name(Left, "Left");

// src/molecules/ItemC/Right.tsx
import { CompositionValidator as CompositionValidator8 } from "@instacart/ids-core";
import { jsx as jsx83 } from "@emotion/react/jsx-runtime";
var styles8 = {
  flex: "1 1 auto"
};
var validator8 = new CompositionValidator8([validateRight]);
function Right(props) {
  const { children } = props;
  validator8.validate(children);
  return /* @__PURE__ */ jsx83("div", { css: styles8, children });
}
__name(Right, "Right");

// src/molecules/ItemC/itemCValidations.ts
var validateItem3 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind, compareItemByKind } = engine;
  const all = getAll();
  const LeftIndex = flatIndexOfByKind(Left);
  const RightIndex = flatIndexOfByKind(Right);
  const foundLefts = all.filter((item) => compareItemByKind(item, Left));
  try {
    expect(foundLefts).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundLefts.length < 1) {
      throw new CompositionTooFewItemsError4(Left, addtl);
    } else {
      throw new CompositionTooManyItemsError7(Left, addtl);
    }
  }
  const foundRights = all.filter((item) => compareItemByKind(item, Right));
  expect(foundRights).toHaveLength(1);
  try {
    expect(LeftIndex).toBeLessThan(RightIndex);
  } catch (e) {
    throw new CompositionOrderError5(all[LeftIndex], all[RightIndex]);
  }
  const itemPriceIndex = flatIndexOfByKind(ItemPrice);
  const itemWeightIndex = flatIndexOfByKind(ItemWeight);
  if (itemPriceIndex > -1 && itemWeightIndex > -1) {
    try {
      expect(itemPriceIndex).toBeLessThan(itemWeightIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[itemPriceIndex], all[itemWeightIndex]);
    }
  }
}, "validateItem");

// src/molecules/ItemC/ItemC.tsx
import { jsx as jsx84 } from "@emotion/react/jsx-runtime";
var { s12, s16 } = spacing22;
var validator9 = new CompositionValidator9([validateItem3]);
var ItemC = forwardRef39(/* @__PURE__ */ __name(function ItemC2(props, ref) {
  const { children, styles: containerStyles3 } = props;
  const theme = useTheme39();
  validator9.validate(children);
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      padding: `${s12}px ${s16}px`,
      // TODO: spec says r16 but it doesn't exist in ids-core
      // TODO: verify with design if this should be on the container, figma is not consistent
      //       it's definately on the focus ring
      borderRadius: theme.radius.r12,
      display: "flex",
      flexFlow: "row nowrap"
    })
  };
  return /* @__PURE__ */ jsx84(ItemBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
}, "ItemC"));

// src/molecules/ItemC/ItemCLink.tsx
import { useTheme as useTheme40 } from "@instacart/ids-core";
import { forwardRef as forwardRef40 } from "react";
import { jsx as jsx85 } from "@emotion/react/jsx-runtime";
var ItemCLink = forwardRef40(
  /* @__PURE__ */ __name(function ItemCLink2(props, ref) {
    const theme = useTheme40();
    const styles25 = {
      a: __spreadProps(__spreadValues({}, props.styles), {
        // make the `a` not disrupt parent display
        display: "inherit",
        // fill out the width to not disrupt parent display
        width: "100%"
      }),
      focusRing: {
        // TODO: find a way to tie `a` borderRadius to the focusRing automagically
        borderRadius: theme.radius.r12
      }
    };
    return /* @__PURE__ */ jsx85(ItemLinkBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
  }, "ItemCLink")
);

// src/molecules/ItemC/ItemCAddItem.tsx
import { spacing as spacing23 } from "@instacart/ids-core";
import { jsx as jsx86 } from "@emotion/react/jsx-runtime";
var { s4: s44 } = spacing23;
var styles9 = {
  paddingLeft: s44,
  // because ItemCLink sets it's own pointer, we need to override here
  cursor: "auto"
};
function ItemCAddItem(props) {
  return (
    // this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ jsx86(
      "div",
      {
        css: styles9,
        onClick: (e) => {
          e.preventDefault();
        },
        children: /* @__PURE__ */ jsx86(AddItem, __spreadValues({}, props))
      }
    )
  );
}
__name(ItemCAddItem, "ItemCAddItem");

// src/molecules/ItemC/ItemCCouponClipButton.tsx
import { spacing as spacing24 } from "@instacart/ids-core";
import { jsx as jsx87 } from "@emotion/react/jsx-runtime";
var { s4: s45 } = spacing24;
var styles10 = {
  paddingTop: s45,
  // because ItemCLink sets it's own pointer, we need to override here
  cursor: "auto"
};
function ItemCCouponClipButton(props) {
  return (
    // this isn't to handle user interaction, so we don't need a11y
    // it's to prevent a parent item from taking the default action when an element in the
    // addItem popover is clicked
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ jsx87(
      "div",
      {
        css: styles10,
        onClick: (e) => {
          e.preventDefault();
        },
        children: /* @__PURE__ */ jsx87(CouponClipButton, __spreadValues({}, props))
      }
    )
  );
}
__name(ItemCCouponClipButton, "ItemCCouponClipButton");

// src/molecules/ItemC/index.ts
var ItemC3 = {
  AddItem: ItemCAddItem,
  CouponClipButton: ItemCCouponClipButton,
  Item: ItemC,
  ItemAttribute,
  ItemDynamicLabel,
  ItemImage,
  ItemLink: ItemCLink,
  ItemName,
  ItemPrice,
  ItemPriceSet,
  ItemRegularPrice,
  ItemWeight,
  Left,
  Right
};

// src/molecules/ItemD/ItemD.tsx
import { CompositionValidator as CompositionValidator13, useTheme as useTheme42, responsive as responsive15 } from "@instacart/ids-core";
import { forwardRef as forwardRef42 } from "react";

// src/molecules/ItemD/ItemDValidations.ts
import { createElement } from "react";
import {
  CompositionOrderError as CompositionOrderError6,
  CompositionTooFewItemsError as CompositionTooFewItemsError5,
  CompositionTooManyItemsError as CompositionTooManyItemsError8
} from "@instacart/ids-core";

// src/molecules/ItemD/Left.tsx
import { spacing as spacing26, CompositionValidator as CompositionValidator10, responsive as responsive13 } from "@instacart/ids-core";

// src/molecules/ItemD/ItemModifierButton.tsx
import { forwardRef as forwardRef41 } from "react";
import {
  blendColors as blendColors4,
  ButtonBase as ButtonBase10,
  spacing as spacing25,
  useTheme as useTheme41
} from "@instacart/ids-core";
import { jsx as jsx88 } from "@emotion/react/jsx-runtime";
var ItemModifierButton = forwardRef41(
  /* @__PURE__ */ __name(function ItemModifierButton2(_a, ref) {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    const theme = useTheme41();
    const styles25 = {
      button: {
        backgroundColor: theme.colors.systemGrayscale10,
        color: theme.colors.systemGrayscale70,
        height: spacing25.s32,
        // @note: inferred from mock, needs ux review
        minWidth: 87,
        borderRadius: theme.radius.r8
      },
      content: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
        margin: `${spacing25.s4}px ${spacing25.s12}px`
      }),
      hover: {
        backgroundColor: blendColors4(
          theme.colors.systemGrayscale10,
          theme.colors.systemGrayscale20,
          50
        )
      },
      focusRing: {
        borderRadius: theme.radius.r12
      }
    };
    return /* @__PURE__ */ jsx88(ButtonBase10, __spreadProps(__spreadValues({}, rest), { styles: styles25, ref, children }));
  }, "ItemModifierButton")
);
ItemModifierButton.displayName = "ItemModifierButton";

// src/molecules/ItemD/leftMiddleRightValidations.ts
var validateLeft2 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, compareItemByKind } = engine;
  const all = getAllChildren();
  expect(all).toHaveLength(1);
  expect(compareItemByKind(all[0], ItemImage)).toEqual(true);
}, "validateLeft");
var validateMiddle = /* @__PURE__ */ __name((engine) => {
  const { expect, compareItemByKind, getAll, getAllChildren } = engine;
  const children = getAllChildren();
  expect(children).toHaveLength(2);
  const all = getAll();
  const itemNames = all.filter((item) => compareItemByKind(item, ItemName));
  const itemWeights = all.filter((item) => compareItemByKind(item, ItemWeight));
  const itemModifierBtns = all.filter((item) => compareItemByKind(item, ItemModifierButton));
  expect(itemNames.length).toEqual(1);
  expect(itemWeights.length).toEqual(1);
  expect(itemModifierBtns.length).toEqual(2);
}, "validateMiddle");
var validateMiddleTop = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, compareItemByKind } = engine;
  const all = getAllChildren();
  expect(all).toHaveLength(2);
  expect(compareItemByKind(all[0], ItemName)).toEqual(true);
  expect(compareItemByKind(all[1], ItemWeight)).toEqual(true);
}, "validateMiddleTop");
var validateMiddleBottom = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, compareItemByKind } = engine;
  const all = getAllChildren();
  expect(all).toHaveLength(2);
  expect(compareItemByKind(all[0], ItemModifierButton)).toEqual(true);
  expect(compareItemByKind(all[1], ItemModifierButton)).toEqual(true);
}, "validateMiddleBottom");
var validateRight2 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, compareItemByKind } = engine;
  const all = getAllChildren();
  expect(all).toHaveLength(2);
  expect(compareItemByKind(all[1], ItemPrice)).toEqual(true);
}, "validateRight");

// src/molecules/ItemD/Left.tsx
import { jsx as jsx89 } from "@emotion/react/jsx-runtime";
var styles11 = {
  flex: `0 0 ${spacing26.s40}px`,
  margin: `${spacing26.s12}px 0 ${spacing26.s12}px ${spacing26.s16}px`,
  [responsive13.up("r")]: {
    marginLeft: 0
  }
};
var validator10 = new CompositionValidator10([validateLeft2]);
function Left2(props) {
  const { children } = props;
  validator10.validate(children);
  return /* @__PURE__ */ jsx89("div", { css: styles11, children });
}
__name(Left2, "Left");

// src/molecules/ItemD/Middle.tsx
import { spacing as spacing27, CompositionValidator as CompositionValidator11 } from "@instacart/ids-core";
import { jsx as jsx90 } from "@emotion/react/jsx-runtime";
var styles12 = {
  cursor: "default",
  flex: "1 1 auto",
  margin: `${spacing27.s12}px ${spacing27.s8}px`
};
var validator11 = new CompositionValidator11([validateMiddle]);
function Middle(props) {
  const { children } = props;
  validator11.validate(children);
  return /* @__PURE__ */ jsx90("div", { css: styles12, children });
}
__name(Middle, "Middle");

// src/molecules/ItemD/Right.tsx
import { CompositionValidator as CompositionValidator12, spacing as spacing28, responsive as responsive14 } from "@instacart/ids-core";
import { jsx as jsx91 } from "@emotion/react/jsx-runtime";
var styles13 = {
  alignItems: "flex-end",
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  margin: `${spacing28.s12}px ${spacing28.s16}px ${spacing28.s12}px 0`,
  input: {
    marginBottom: spacing28.s4
  },
  [responsive14.up("r")]: {
    marginRight: 0
  }
};
var validator12 = new CompositionValidator12([validateRight2]);
function Right2(props) {
  const { children } = props;
  validator12.validate(children);
  return /* @__PURE__ */ jsx91("div", { css: styles13, children });
}
__name(Right2, "Right");

// src/molecules/ItemD/ItemDValidations.ts
var aLeftElement = createElement(Left2);
var aMiddleElement = createElement(Middle);
var aRightElement = createElement(Right2);
var LeftType = aLeftElement.type;
var MiddleType = aMiddleElement.type;
var RightType = aRightElement.type;
var validateItem4 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind, compareItemByKind } = engine;
  const all = getAll();
  const leftIndex = flatIndexOfByKind(LeftType);
  const middleIndex = flatIndexOfByKind(MiddleType);
  const rightIndex = flatIndexOfByKind(RightType);
  const foundLeft = all.filter((item) => compareItemByKind(item, LeftType));
  try {
    expect(foundLeft).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundLeft.length < 1) {
      throw new CompositionTooFewItemsError5(aLeftElement, addtl);
    } else {
      throw new CompositionTooManyItemsError8(aLeftElement, addtl);
    }
  }
  const foundMiddle = all.filter((item) => compareItemByKind(item, MiddleType));
  try {
    expect(foundMiddle).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundMiddle.length < 1) {
      throw new CompositionTooFewItemsError5(aMiddleElement, addtl);
    } else {
      throw new CompositionTooManyItemsError8(aMiddleElement, addtl);
    }
  }
  const foundRight = all.filter((item) => compareItemByKind(item, RightType));
  try {
    expect(foundRight).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundRight.length < 1) {
      throw new CompositionTooFewItemsError5(aRightElement, addtl);
    } else {
      throw new CompositionTooManyItemsError8(aRightElement, addtl);
    }
  }
  try {
    expect(leftIndex).toBeLessThan(middleIndex);
  } catch (e) {
    throw new CompositionOrderError6(all[leftIndex], all[middleIndex]);
  }
  try {
    expect(middleIndex).toBeLessThan(rightIndex);
  } catch (e) {
    throw new CompositionOrderError6(all[middleIndex], all[rightIndex]);
  }
}, "validateItem");

// src/molecules/ItemD/ItemD.tsx
import { jsx as jsx92 } from "@emotion/react/jsx-runtime";
var validator13 = new CompositionValidator13([validateItem4]);
var ItemD = forwardRef42(/* @__PURE__ */ __name(function ItemD2(props, ref) {
  const { children, styles: containerStyles3 } = props;
  const theme = useTheme42();
  validator13.validate(children);
  const styles25 = {
    container: [
      containerStyles3 == null ? void 0 : containerStyles3.container,
      {
        borderRadius: theme.radius.r12,
        display: "flex",
        flexFlow: "row nowrap",
        width: "100%",
        [responsive15.down("c")]: {
          width: 375
        }
      }
    ]
  };
  return /* @__PURE__ */ jsx92(ItemBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
}, "ItemD"));
ItemD.displayName = "ItemD";

// src/molecules/ItemD/MiddleBottom.tsx
import { CompositionValidator as CompositionValidator14, spacing as spacing29 } from "@instacart/ids-core";
import { jsx as jsx93 } from "@emotion/react/jsx-runtime";
var styles14 = {
  display: "flex",
  flexDirection: "row",
  marginTop: spacing29.s8,
  button: {
    "&:not(:first-of-type)": {
      marginLeft: spacing29.s8
    }
  }
};
var validator14 = new CompositionValidator14([validateMiddleBottom]);
function MiddleBottom(props) {
  const { children } = props;
  validator14.validate(children);
  return /* @__PURE__ */ jsx93("div", { css: styles14, children });
}
__name(MiddleBottom, "MiddleBottom");

// src/molecules/ItemD/MiddleTop.tsx
import { CompositionValidator as CompositionValidator15 } from "@instacart/ids-core";
import { jsx as jsx94 } from "@emotion/react/jsx-runtime";
var validator15 = new CompositionValidator15([validateMiddleTop]);
function MiddleTop(props) {
  const { children } = props;
  validator15.validate(children);
  return /* @__PURE__ */ jsx94("div", { children });
}
__name(MiddleTop, "MiddleTop");

// src/molecules/ItemD/ItemDLink.tsx
import { useTheme as useTheme43 } from "@instacart/ids-core";
import { forwardRef as forwardRef43 } from "react";
import { jsx as jsx95 } from "@emotion/react/jsx-runtime";
var ItemDLink = forwardRef43(
  /* @__PURE__ */ __name(function ItemDLink2(props, ref) {
    const theme = useTheme43();
    const styles25 = {
      a: __spreadProps(__spreadValues({}, props.styles), {
        display: "inherit",
        width: "100%"
      }),
      focusRing: {
        borderRadius: theme.radius.r12
      }
    };
    return /* @__PURE__ */ jsx95(ItemLinkBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
  }, "ItemDLink")
);

// src/atoms/ItemQtyBase/ItemQtyBase.tsx
import { forwardRef as forwardRef44 } from "react";
import { combineStyles as combineStyles23, spacing as spacing30, useTheme as useTheme44 } from "@instacart/ids-core";
import { jsx as jsx96 } from "@emotion/react/jsx-runtime";
var getStyles23 = /* @__PURE__ */ __name(({ theme }) => ({
  input: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
    border: `solid 1px ${theme.colors.systemGrayscale30}`,
    borderRadius: `${spacing30.s8}px`,
    boxSizing: "border-box",
    color: theme.colors.systemGrayscale70,
    height: spacing30.s32,
    padding: `6px ${spacing30.s4}px`,
    position: "relative",
    textAlign: "center",
    width: spacing30.s48,
    // @note: focusRing can't be used with input elements as it is a replaced element,
    // this prevents us from applying a -4px absolute positioning
    "&:focus": {
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      outline: "none"
    },
    "&:hover": {
      border: `1px solid ${theme.colors.systemGrayscale50}`
    }
  })
}), "getStyles");
var ItemQtyBase = forwardRef44(/* @__PURE__ */ __name(function ItemQtyBase2(_a, ref) {
  var _b = _a, { onChange, styles: styles25 } = _b, rest = __objRest(_b, ["onChange", "styles"]);
  const theme = useTheme44();
  const { input } = combineStyles23(getStyles23({ theme }), styles25);
  return /* @__PURE__ */ jsx96("input", __spreadProps(__spreadValues({ onChange: (e) => onChange(e.target.value) }, rest), { css: input, ref, type: "text" }));
}, "ItemQtyBase"));
ItemQtyBase.displayName = "ItemQtyBase";

// src/atoms/ItemQty/ItemQty.tsx
import { jsx as jsx97 } from "@emotion/react/jsx-runtime";
function ItemQty(props) {
  return /* @__PURE__ */ jsx97(ItemQtyBase, __spreadValues({}, props));
}
__name(ItemQty, "ItemQty");

// src/molecules/ItemD/index.ts
var ItemD3 = {
  Item: ItemD,
  ItemImage,
  ItemLink: ItemDLink,
  ItemModifierButton,
  ItemName,
  ItemPrice,
  ItemQty,
  ItemWeight,
  Left: Left2,
  Middle,
  MiddleBottom,
  MiddleTop,
  Right: Right2
};

// src/molecules/ItemXL/ItemXL.tsx
import { useTheme as useTheme45, CompositionValidator as CompositionValidator17 } from "@instacart/ids-core";
import { forwardRef as forwardRef46 } from "react";

// src/molecules/ItemXL/itemXLValidations.ts
import {
  CompositionOrderError as CompositionOrderError7,
  CompositionTooFewItemsError as CompositionTooFewItemsError6,
  CompositionTooManyItemsError as CompositionTooManyItemsError10
} from "@instacart/ids-core";

// src/molecules/ItemXL/Top.tsx
import { spacing as spacing31, CompositionValidator as CompositionValidator16 } from "@instacart/ids-core";

// src/molecules/ItemXL/topBottomValidations.ts
import { CompositionTooManyItemsError as CompositionTooManyItemsError9 } from "@instacart/ids-core";

// src/atoms/ItemImageXL/ItemImageXL.tsx
import { forwardRef as forwardRef45 } from "react";
import { aspectRatio as aspectRatio2 } from "@instacart/ids-core";
import { jsx as jsx98 } from "@emotion/react/jsx-runtime";
var ItemImageXL = forwardRef45(
  /* @__PURE__ */ __name(function ItemImageXL2(props, ref) {
    const XLRatio = aspectRatio2(2, 1);
    return /* @__PURE__ */ jsx98(ItemImageBase, __spreadProps(__spreadValues({ ref }, props), { styles: XLRatio }));
  }, "ItemImageXL")
);

// src/molecules/ItemXL/topBottomValidations.ts
var validateTop2 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, compareItemByKind } = engine;
  const all = getAll();
  expect(all).toHaveLength(1);
  expect(compareItemByKind(all[0], ItemImageXL)).toEqual(true);
}, "validateTop");

// src/molecules/ItemXL/Top.tsx
import { jsx as jsx99 } from "@emotion/react/jsx-runtime";
var styles15 = {
  marginBottom: spacing31.s8
};
var validator16 = new CompositionValidator16([validateTop2]);
function Top2(props) {
  const { children } = props;
  validator16.validate(children);
  return /* @__PURE__ */ jsx99("div", { css: styles15, children });
}
__name(Top2, "Top");

// src/molecules/ItemXL/itemXLValidations.ts
var validateItem5 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind, compareItemByKind } = engine;
  const all = getAll();
  const topIndex = flatIndexOfByKind(Top2);
  const bottomIndex = flatIndexOfByKind(Bottom);
  const foundTops = all.filter((item) => compareItemByKind(item, Top2));
  try {
    expect(foundTops).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundTops.length < 1) {
      throw new CompositionTooFewItemsError6(Top2, addtl);
    } else {
      throw new CompositionTooManyItemsError10(Bottom, addtl);
    }
  }
  const foundBottoms = all.filter((item) => compareItemByKind(item, Bottom));
  expect(foundBottoms).toHaveLength(1);
  try {
    expect(topIndex).toBeLessThan(bottomIndex);
  } catch (e) {
    throw new CompositionOrderError7(all[topIndex], all[bottomIndex]);
  }
  const itemPriceIndex = flatIndexOfByKind(ItemPrice);
  const itemNameIndex = flatIndexOfByKind(ItemName);
  if (itemPriceIndex > -1 && itemNameIndex > -1) {
    try {
      expect(itemPriceIndex).toBeLessThan(itemNameIndex);
    } catch (e) {
      throw new CompositionOrderError7(all[itemPriceIndex], all[itemNameIndex]);
    }
  }
}, "validateItem");

// src/molecules/ItemXL/ItemXL.tsx
import { jsx as jsx100 } from "@emotion/react/jsx-runtime";
var validator17 = new CompositionValidator17([validateItem5]);
var ItemXL = forwardRef46(/* @__PURE__ */ __name(function ItemXL2(props, ref) {
  const { children, styles: containerStyles3 } = props;
  const theme = useTheme45();
  validator17.validate(children);
  const styles25 = {
    container: __spreadProps(__spreadValues({}, containerStyles3), {
      borderRadius: theme.radius.r12,
      border: `1px solid ${theme.colors.systemGrayscale30}`,
      padding: "32px 24px"
    })
  };
  return /* @__PURE__ */ jsx100(ItemBase, __spreadProps(__spreadValues({ ref }, props), { styles: styles25 }));
}, "ItemXL"));

// src/molecules/ItemXL/index.ts
var ItemXL3 = {
  AddItem: ItemBAddItem,
  Bottom,
  CouponClipButton: ItemBCouponClipButton,
  Item: ItemXL,
  ItemAttribute,
  ItemDynamicLabel,
  ItemImageXL,
  ItemLink: ItemBLink,
  ItemName,
  ItemPrice,
  ItemPriceSet,
  ItemRegularPrice,
  ItemWeight,
  Top: Top2
};

// src/molecules/Link/Link.tsx
import { forwardRef as forwardRef47 } from "react";
import { LinkBase, useTheme as useTheme46 } from "@instacart/ids-core";
import { jsx as jsx101 } from "@emotion/react/jsx-runtime";
var getStyles24 = /* @__PURE__ */ __name((theme) => ({
  link: {},
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    content: '""',
    display: "block",
    position: "absolute",
    top: -4,
    bottom: -4,
    left: -4,
    right: -4,
    borderRadius: theme.radius.r4
  },
  hover: {},
  active: {}
}), "getStyles");
var Link = forwardRef47(/* @__PURE__ */ __name(function Link2(props, ref) {
  const theme = useTheme46();
  const styles25 = getStyles24(theme);
  return /* @__PURE__ */ jsx101(LinkBase, __spreadProps(__spreadValues({ styles: styles25 }, props), { ref }));
}, "Link"));

// src/molecules/LinkPill/LinkPill.tsx
import { useTheme as useTheme47, spacing as spacing32, useIsPantryEnabled as useIsPantryEnabled2 } from "@instacart/ids-core";
import { forwardRef as forwardRef48 } from "react";
import { jsx as jsx102 } from "@emotion/react/jsx-runtime";
var BORDER_WIDTH3 = 2;
var getStyles25 = /* @__PURE__ */ __name((theme, isPantryEnabled) => ({
  anchor: __spreadProps(__spreadValues({
    display: "inline-flex",
    alignItems: "center",
    position: "relative"
  }, getSharedPillStyles(theme, isPantryEnabled)), {
    padding: `3px ${spacing32.s12}px`
  }),
  container: { display: "inline-block" }
}), "getStyles");
var getActiveStyles = /* @__PURE__ */ __name((theme, isPantryEnabled) => __spreadValues({
  background: theme.colors.systemGrayscale20,
  border: `${BORDER_WIDTH3}px solid ${theme.colors.systemGrayscale70}`
}, isPantryEnabled && {
  background: theme.colors.systemGrayscale80,
  color: theme.colors.systemGrayscale00,
  "&:hover": {
    backgroundColor: theme.colors.systemGrayscale60,
    borderColor: theme.colors.systemGrayscale60
  },
  "&:active": {
    backgroundColor: theme.colors.systemGrayscale70,
    borderColor: theme.colors.systemGrayscale70
  }
}), "getActiveStyles");
var LinkPill = forwardRef48(/* @__PURE__ */ __name(function LinkPill2(_a, ref) {
  var _b = _a, { href, children, active } = _b, restProps = __objRest(_b, ["href", "children", "active"]);
  const theme = useTheme47();
  const isPantryEnabled = useIsPantryEnabled2();
  const styles25 = getStyles25(theme, isPantryEnabled);
  const activeStyles = active ? getActiveStyles(theme, isPantryEnabled) : {};
  return /* @__PURE__ */ jsx102("span", { css: styles25.container, children: /* @__PURE__ */ jsx102(
    "a",
    __spreadProps(__spreadValues({
      ref,
      href,
      css: [styles25.anchor, activeStyles],
      "aria-current": active,
      className: "ids-link"
    }, restProps), {
      children
    })
  ) });
}, "LinkPill"));

// src/molecules/LockupB/LockupB.tsx
import { Children as Children3, useMemo as useMemo3 } from "react";
import { spacing as spacing33, responsive as responsive16, CompositionValidator as CompositionValidator18 } from "@instacart/ids-core";

// src/molecules/LockupB/validations.ts
var validateLockupB = /* @__PURE__ */ __name((_engine) => {
}, "validateLockupB");

// src/molecules/LockupB/LockupB.tsx
import { jsx as jsx103 } from "@emotion/react/jsx-runtime";
var { s8, s12: s122, s16: s162, s24 } = spacing33;
var { up } = responsive16;
var styles16 = {
  containerStyles: {
    display: "grid",
    gridGap: `${s122}px ${s162}px`,
    // TODO: decide between minmax(172px, 172px) and minmax(172px, 1fr)
    // using 1fr for now until design can sign off
    gridTemplateColumns: "repeat(auto-fill, minmax(172px, 1fr))",
    padding: `${s8}px ${s162}px`,
    [up("r")]: {
      gridGap: `${s162}px`,
      padding: `${s8}px 0`
    },
    [up("xl")]: {
      gridGap: `${s24}px`,
      padding: `${s122}px 0`
    },
    // Hide empty child elements
    "& > *:empty": {
      display: "none"
    },
    listStyle: "none"
  }
};
var validator18 = new CompositionValidator18([validateLockupB]);
function LockupB(props) {
  const { children } = props;
  validator18.validate(children);
  const wrappedChildren = useMemo3(
    () => Children3.map(children, (c) => {
      if (!c) {
        return null;
      }
      if (c.key === null) {
        if (true) {
          throw new Error('Each child in LockupB must have a unique "key" prop.');
        }
      }
      return /* @__PURE__ */ jsx103("li", { children: c });
    }),
    [children]
  );
  return /* @__PURE__ */ jsx103("ul", { css: styles16.containerStyles, children: wrappedChildren });
}
__name(LockupB, "LockupB");

// src/molecules/LockupD/LockupD.tsx
import { Children as Children4, useMemo as useMemo4 } from "react";
import { CompositionValidator as CompositionValidator19 } from "@instacart/ids-core";

// src/molecules/LockupD/LockupDValidations.ts
var validateLockupD = /* @__PURE__ */ __name((_engine) => {
}, "validateLockupD");

// src/molecules/LockupD/LockupD.tsx
import { jsx as jsx104 } from "@emotion/react/jsx-runtime";
var styles17 = {
  containerStyles: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    // Hide empty child elements
    "& > *:empty": {
      display: "none"
    },
    listStyle: "none"
  }
};
var validator19 = new CompositionValidator19([validateLockupD]);
function LockupD(props) {
  const { children } = props;
  validator19.validate(children);
  const wrappedChildren = useMemo4(
    () => Children4.map(children, (c) => {
      if (!c) {
        return null;
      }
      if (c.key === null) {
        if (true) {
          throw new Error('Each child in LockupD must have a unique "key" prop.');
        }
      }
      return /* @__PURE__ */ jsx104("li", { children: c });
    }),
    [children]
  );
  return /* @__PURE__ */ jsx104("ul", { css: styles17.containerStyles, children: wrappedChildren });
}
__name(LockupD, "LockupD");
LockupD.displayName = "LockupD";

// src/molecules/MaxBadge/MaxBadge.tsx
import { useTheme as useTheme48, combineStyles as combineStyles24 } from "@instacart/ids-core";

// src/molecules/MaxBadge/MaxBadgeIcon.tsx
import { internalSVGIcon } from "@instacart/ids-core";
import { jsx as jsx105 } from "@emotion/react/jsx-runtime";
var { SVGIcon } = internalSVGIcon;
function MaxBadgeIcon(props) {
  return /* @__PURE__ */ jsx105(
    SVGIcon,
    __spreadValues({
      component: /* @__PURE__ */ jsx105(
        "svg",
        __spreadProps(__spreadValues({
          width: "1em",
          height: "1em",
          viewBox: "0 0 66 66",
          xmlns: "http://www.w3.org/2000/svg"
        }, props), {
          children: /* @__PURE__ */ jsx105("path", { d: "m25.36 58.016-6.14 4.569-.6-7.687-7.18 2.634 1.566-7.561-7.628.498 3.602-6.803-7.438-1.695 5.355-5.49-6.678-3.762 6.678-3.762-5.359-5.49 7.442-1.695-3.602-6.803 7.628.498-1.567-7.562 7.184 2.634.596-7.686 6.14 4.569L28.092.219l4.628 6.152L37.344.219l2.731 7.203 6.14-4.57.6 7.687L54 7.905l-1.567 7.562 7.625-.498-3.602 6.803 7.442 1.694-5.359 5.491 6.681 3.762-6.68 3.761 5.358 5.491-7.442 1.695 3.602 6.803-7.625-.498 1.564 7.561-7.18-2.634-.6 7.687-6.14-4.57-2.732 7.204-4.625-6.152-4.628 6.152z" })
        })
      )
    }, props)
  );
}
__name(MaxBadgeIcon, "MaxBadgeIcon");
var MaxBadgeIcon_default = MaxBadgeIcon;

// src/molecules/MaxBadge/MaxBadge.tsx
import { jsx as jsx106, jsxs as jsxs14 } from "@emotion/react/jsx-runtime";
var useStyles = /* @__PURE__ */ __name((theme, size, rotateRight = false) => {
  const degrees = 12;
  const transform = `rotate(-${degrees}deg)`;
  const reverseTransform = `rotate(${degrees}deg)`;
  const fontProperties = {
    fontVariationSettings: "'wght' 700, 'opsz' 48",
    fontFamily: "Instacart Sans",
    color: theme.colors.brandMaxDark
  };
  return {
    container: {
      backgroundPosition: "center",
      backgroundSize: "cover",
      height: `${size}px`,
      width: `${size}px`,
      position: "relative",
      flexWrap: "wrap"
    },
    icon: {
      position: "absolute"
    },
    textContainer: {
      position: "relative",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center",
      transform: rotateRight ? reverseTransform : transform
    },
    descriptionTop: {
      lineHeight: "9px"
    },
    maxBadgeLarge: __spreadValues({
      fontSize: 16,
      lineHeight: "18px"
    }, fontProperties),
    maxBadgeSmall: __spreadValues({
      fontSize: 10,
      lineHeight: "10px"
    }, fontProperties)
  };
}, "useStyles");
function MaxBadge({
  size = 56,
  amount,
  description,
  descriptionAbove,
  rotateRight,
  styles: propsStyles
}) {
  const theme = useTheme48();
  const styles25 = combineStyles24(useStyles(theme, size, rotateRight), propsStyles);
  return /* @__PURE__ */ jsxs14("div", { css: styles25.container, children: [
    /* @__PURE__ */ jsx106(MaxBadgeIcon_default, { size, color: "brandMaxLight", css: styles25.icon }),
    /* @__PURE__ */ jsxs14("div", { css: styles25.textContainer, "data-testid": "max-badge-copy", children: [
      descriptionAbove && /* @__PURE__ */ jsx106("span", { css: [styles25.maxBadgeSmall, styles25.descriptionTop], color: "brandMaxDark", children: description }),
      /* @__PURE__ */ jsx106("span", { color: "brandMaxDark", css: styles25.maxBadgeLarge, children: amount }),
      !descriptionAbove && /* @__PURE__ */ jsx106("span", { color: "brandMaxDark", css: styles25.maxBadgeSmall, children: description })
    ] })
  ] });
}
__name(MaxBadge, "MaxBadge");

// src/molecules/PrimaryButton/PrimaryButton.tsx
import { forwardRef as forwardRef49 } from "react";
import { ButtonBase as ButtonBase11, useIdsFeatureFlag as useIdsFeatureFlag7 } from "@instacart/ids-core";
import { jsx as jsx107 } from "@emotion/react/jsx-runtime";
var PrimaryButton = forwardRef49(
  /* @__PURE__ */ __name(function PrimaryButton2(props, ref) {
    const grayscale = useIdsFeatureFlag7("grayscale") === "grayscale";
    const styles25 = useSharedButtonStyles({
      primaryColor: grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
      activeColor: grayscale ? "systemGrayscale90" : "brandPrimaryDark",
      hoverColor: [
        grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
        grayscale ? "systemGrayscale90" : "brandPrimaryDark"
      ],
      textColor: "systemGrayscale00"
    });
    return /* @__PURE__ */ jsx107(ButtonBase11, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "PrimaryButton")
);

// src/molecules/PrimaryButtonCompact/PrimaryButtonCompact.tsx
import { forwardRef as forwardRef50 } from "react";
import { useIdsFeatureFlag as useIdsFeatureFlag8 } from "@instacart/ids-core";
import { jsx as jsx108 } from "@emotion/react/jsx-runtime";
var PrimaryButtonCompact = forwardRef50(
  /* @__PURE__ */ __name(function PrimaryButtonCompact2(props, ref) {
    const grayscale = useIdsFeatureFlag8("grayscale") === "grayscale";
    const styles25 = useSharedButtonStyles({
      primaryColor: grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
      activeColor: grayscale ? "systemGrayscale90" : "brandPrimaryDark",
      hoverColor: [
        grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
        grayscale ? "systemGrayscale90" : "brandPrimaryDark"
      ],
      textColor: "systemGrayscale00",
      size: 2 /* Compact */
    });
    return /* @__PURE__ */ jsx108(ButtonCompactBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "PrimaryButtonCompact")
);

// src/molecules/PrimaryButtonSmall/PrimaryButtonSmall.tsx
import { forwardRef as forwardRef51 } from "react";
import { useIdsFeatureFlag as useIdsFeatureFlag9 } from "@instacart/ids-core";
import { jsx as jsx109 } from "@emotion/react/jsx-runtime";
var PrimaryButtonSmall = forwardRef51(
  /* @__PURE__ */ __name(function PrimaryButtonSmall2(props, ref) {
    const grayscale = useIdsFeatureFlag9("grayscale") === "grayscale";
    const styles25 = useSharedButtonStyles({
      primaryColor: grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
      activeColor: grayscale ? "systemGrayscale90" : "brandPrimaryDark",
      hoverColor: [
        grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
        grayscale ? "systemGrayscale90" : "brandPrimaryDark"
      ],
      textColor: "systemGrayscale00",
      size: 1 /* Small */
    });
    return /* @__PURE__ */ jsx109(ButtonSmallBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "PrimaryButtonSmall")
);

// src/molecules/PrimaryPriceButton/PrimaryPriceButton.tsx
import {
  ButtonBase as ButtonBase14,
  blendColors as blendColors5,
  useTheme as useTheme49,
  spacing as spacing34,
  useIdsFeatureFlag as useIdsFeatureFlag10,
  combineStyles as combineStyles25
} from "@instacart/ids-core";
import { forwardRef as forwardRef52 } from "react";
import { jsx as jsx110, jsxs as jsxs15 } from "@emotion/react/jsx-runtime";
var PRICE_ELEMENT_HEIGHT_PX = 40;
var PrimaryPriceButton = forwardRef52(
  /* @__PURE__ */ __name(function PrimaryPriceButton2(_a, ref) {
    var _b = _a, { children, price } = _b, rest = __objRest(_b, ["children", "price"]);
    const theme = useTheme49();
    const grayscale = useIdsFeatureFlag10("grayscale") === "grayscale";
    const isPantryEnabled = useIdsFeatureFlag10("pantryButtons") === "variant";
    const sharedStyles = useSharedButtonStyles({
      activeColor: grayscale ? "systemGrayscale90" : "brandPrimaryDark",
      hoverColor: grayscale ? ["systemGrayscale80", "systemGrayscale90"] : ["brandPrimaryRegular", "brandPrimaryDark"],
      primaryColor: grayscale ? "systemGrayscale80" : "brandPrimaryRegular",
      textColor: "systemGrayscale00"
    });
    const styles25 = combineStyles25(sharedStyles, {
      button: {
        paddingLeft: 0,
        paddingRight: 0
      },
      content: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    });
    return /* @__PURE__ */ jsxs15(ButtonBase14, __spreadProps(__spreadValues({}, rest), { styles: styles25, ref, children: [
      /* @__PURE__ */ jsx110("div", { css: { width: 70, minWidth: 0, flexShrink: 1 } }),
      /* @__PURE__ */ jsx110("div", { css: { flexShrink: 0 }, children }),
      /* @__PURE__ */ jsx110(
        "div",
        {
          css: __spreadProps(__spreadValues({
            flexShrink: 0,
            borderRadius: isPantryEnabled ? PRICE_ELEMENT_HEIGHT_PX / 2 : theme.radius.r8,
            background: grayscale ? theme.colors.systemGrayscale60 : theme.colors.brandPrimaryDark,
            "button:hover > span > &": {
              backgroundColor: blendColors5(
                grayscale ? theme.colors.systemGrayscale60 : theme.colors.brandPrimaryDark,
                grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryExtraDark,
                51
              )
            },
            "button:active > span > &": {
              backgroundColor: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryExtraDark
            },
            "button:disabled > span > &": {
              backgroundColor: theme.colors.systemGrayscale20,
              color: theme.colors.systemGrayscale50
            },
            height: PRICE_ELEMENT_HEIGHT_PX,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minWidth: 54,
            width: "fit-content",
            padding: `0 ${spacing34.s8}px`,
            boxSizing: "border-box"
          }, theme.typography.bodySmall1), {
            marginLeft: spacing34.s8
          }),
          children: price
        }
      )
    ] }));
  }, "PrimaryPriceButton")
);

// src/molecules/RetailerAvatar/RetailerAvatarSmall.tsx
import { forwardRef as forwardRef54 } from "react";

// src/molecules/RetailerAvatar/RetailerAvatarBase.tsx
import { responsive as responsive17 } from "@instacart/ids-core";
import { forwardRef as forwardRef53 } from "react";
import { jsx as jsx111 } from "@emotion/react/jsx-runtime";
var getStyles26 = /* @__PURE__ */ __name((props) => ({
  container: {
    position: "relative",
    height: props.responsiveSizes.mobile.height,
    width: props.responsiveSizes.mobile.width,
    borderRadius: props.responsiveSizes.mobile.radius,
    display: "flex",
    justifyContent: "center",
    [responsive17.DESKTOP_SIZE]: {
      height: props.responsiveSizes.desktop.height,
      width: props.responsiveSizes.desktop.width,
      borderRadius: props.responsiveSizes.desktop.radius
    }
  },
  image: {
    position: "absolute",
    top: -1 * AVATAR_BORDER_PX,
    width: props.responsiveSizes.mobile.height,
    height: props.responsiveSizes.mobile.height,
    [responsive17.DESKTOP_SIZE]: {
      height: props.responsiveSizes.desktop.height,
      width: props.responsiveSizes.desktop.height
    }
  }
}), "getStyles");
var RetailerAvatarBase = forwardRef53(
  /* @__PURE__ */ __name(function RetailerAvatarBase2(props, ref) {
    const styles25 = getStyles26(props);
    const _a = props, { responsiveSizes: responsiveSizes10, src, srcSet, templateUrl } = _a, rest = __objRest(_a, ["responsiveSizes", "src", "srcSet", "templateUrl"]);
    const imageProps = {
      src,
      srcSet,
      width: responsiveSizes10.desktop.height,
      height: responsiveSizes10.desktop.height,
      templateUrl
    };
    return /* @__PURE__ */ jsx111(AvatarBase, __spreadProps(__spreadValues(__spreadValues({}, rest), imageProps), { styles: styles25, ref }));
  }, "RetailerAvatarBase")
);
RetailerAvatarBase.displayName = "RetailerAvatarBase";

// src/molecules/RetailerAvatar/RetailerAvatarSmall.tsx
import { jsx as jsx112 } from "@emotion/react/jsx-runtime";
var responsiveSizes7 = {
  desktop: {
    width: 48,
    height: 36,
    radius: 8
  },
  mobile: {
    width: 36,
    height: 28,
    radius: 6
  }
};
var RetailerAvatarSmall = forwardRef54(
  /* @__PURE__ */ __name(function RetailerAvatarSmall2(props, ref) {
    return /* @__PURE__ */ jsx112(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), { responsiveSizes: responsiveSizes7, ref }));
  }, "RetailerAvatarSmall")
);
RetailerAvatarSmall.displayName = "RetailerAvatarSmall";

// src/molecules/RetailerAvatar/RetailerAvatarMedium.tsx
import { forwardRef as forwardRef55 } from "react";
import { jsx as jsx113 } from "@emotion/react/jsx-runtime";
var responsiveSizes8 = {
  desktop: {
    width: 72,
    height: 54,
    radius: 8
  },
  mobile: {
    width: 48,
    height: 36,
    radius: 8
  }
};
var RetailerAvatarMedium = forwardRef55(
  /* @__PURE__ */ __name(function RetailerAvatarMedium2(props, ref) {
    return /* @__PURE__ */ jsx113(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), { responsiveSizes: responsiveSizes8, ref }));
  }, "RetailerAvatarMedium")
);
RetailerAvatarMedium.displayName = "RetailerAvatarMedium";

// src/molecules/RetailerAvatar/RetailerAvatarLarge.tsx
import { forwardRef as forwardRef56 } from "react";
import { jsx as jsx114 } from "@emotion/react/jsx-runtime";
var responsiveSizes9 = {
  desktop: {
    width: 96,
    height: 72,
    radius: 8
  },
  mobile: {
    width: 64,
    height: 48,
    radius: 8
  }
};
var RetailerAvatarLarge = forwardRef56(
  /* @__PURE__ */ __name(function RetailerAvatarLarge2(props, ref) {
    return /* @__PURE__ */ jsx114(RetailerAvatarBase, __spreadProps(__spreadValues({}, props), { responsiveSizes: responsiveSizes9, ref }));
  }, "RetailerAvatarLarge")
);
RetailerAvatarLarge.displayName = "RetailerAvatarLarge";

// src/molecules/SearchButtonBase/SearchButtonBase.tsx
import { forwardRef as forwardRef57 } from "react";
import { SearchIcon, combineStyles as combineStyles26, useTheme as useTheme50 } from "@instacart/ids-core";
import { jsx as jsx115, jsxs as jsxs16 } from "@emotion/react/jsx-runtime";
var getStyles27 = /* @__PURE__ */ __name((theme) => ({
  button: {
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    touchAction: "manipulation",
    "&:disabled": {
      cursor: "default"
    },
    "&:active:not(:disabled)": {
      backgroundColor: theme.colors.systemGrayscale20
    }
  },
  text: {},
  icon: {},
  focusRing: {
    display: "block",
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    borderRadius: theme.radius.r8
  },
  hover: {},
  active: {},
  disabled: {
    cursor: "default"
  }
}), "getStyles");
var SearchButtonBase = forwardRef57(
  /* @__PURE__ */ __name(function SearchButtonBase2(_a, ref) {
    var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
    const theme = useTheme50();
    const {
      button: buttonCSS,
      text,
      icon,
      hover,
      active,
      disabled,
      focusRing
    } = combineStyles26(getStyles27(theme), styles25);
    const searchButtonCSS = [
      buttonCSS,
      {
        "&:focus": {
          outline: "none"
        },
        "&.focus-visible::after": focusRing,
        "&:hover": hover,
        "&:active": active,
        "&:disabled": disabled
      }
    ];
    return /* @__PURE__ */ jsxs16("button", __spreadProps(__spreadValues({}, rest), { ref, css: searchButtonCSS, children: [
      /* @__PURE__ */ jsx115("span", { css: text, children }),
      /* @__PURE__ */ jsx115("span", { css: icon, children: /* @__PURE__ */ jsx115(SearchIcon, { size: 18 }) })
    ] }));
  }, "SearchButtonBase")
);

// src/molecules/SecondaryButton/SecondaryButton.tsx
import { forwardRef as forwardRef58 } from "react";
import { ButtonBase as ButtonBase15 } from "@instacart/ids-core";
import { jsx as jsx116 } from "@emotion/react/jsx-runtime";
var SecondaryButton = forwardRef58(
  /* @__PURE__ */ __name(function SecondaryButton2(_a, ref) {
    var rest = __objRest(_a, []);
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale10",
      activeColor: "systemGrayscale20",
      hoverColor: ["systemGrayscale10", "systemGrayscale20"],
      textColor: "systemGrayscale70"
    });
    return /* @__PURE__ */ jsx116(ButtonBase15, __spreadProps(__spreadValues({}, rest), { styles: styles25, ref }));
  }, "SecondaryButton")
);

// src/molecules/SecondaryButtonCompact/SecondaryButtonCompact.tsx
import { forwardRef as forwardRef59 } from "react";
import { jsx as jsx117 } from "@emotion/react/jsx-runtime";
var SecondaryButtonCompact = forwardRef59(
  /* @__PURE__ */ __name(function SecondaryButtonCompact2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale10",
      activeColor: "systemGrayscale20",
      hoverColor: ["systemGrayscale10", "systemGrayscale20"],
      textColor: "systemGrayscale70",
      size: 2 /* Compact */
    });
    return /* @__PURE__ */ jsx117(ButtonCompactBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "SecondaryButtonCompact")
);

// src/molecules/SecondaryButtonSmall/SecondaryButtonSmall.tsx
import { forwardRef as forwardRef60 } from "react";
import { jsx as jsx118 } from "@emotion/react/jsx-runtime";
var SecondaryButtonSmall = forwardRef60(
  /* @__PURE__ */ __name(function SecondaryButtonSmall2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale10",
      activeColor: "systemGrayscale20",
      hoverColor: ["systemGrayscale10", "systemGrayscale20"],
      textColor: "systemGrayscale70",
      size: 1 /* Small */
    });
    return /* @__PURE__ */ jsx118(ButtonSmallBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "SecondaryButtonSmall")
);

// src/molecules/SelectBase/SelectBase.tsx
import { useRef as useRef3, useState as useState2 } from "react";
import { unstable_useId } from "reakit";
import { combineStyles as combineStyles27, useOnClickOutside as useOnClickOutside2 } from "@instacart/ids-core";

// src/molecules/SelectBase/SelectProvider.ts
import { useContext as useContext5, createContext as createContext2 } from "react";
var SelectProvider = createContext2({
  isOpen: false,
  toggleOpen: () => {
  },
  setIsOpen: () => {
  },
  selectedValue: "",
  wrapperId: void 0,
  labelId: void 0,
  selectedId: void 0,
  disabled: false,
  buttonRef: void 0
});
var useSelectContext = /* @__PURE__ */ __name(() => useContext5(SelectProvider), "useSelectContext");

// src/molecules/SelectBase/SelectBase.tsx
import { jsx as jsx119 } from "@emotion/react/jsx-runtime";
var baseStyles11 = {
  select: {}
};
var useSelect = /* @__PURE__ */ __name((disabled) => {
  const selectRef = useRef3(null);
  const [isOpen, setIsOpen] = useState2(false);
  useOnClickOutside2(selectRef, () => setIsOpen(false));
  const toggleOpen = /* @__PURE__ */ __name(() => {
    if (disabled)
      return;
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, "toggleOpen");
  return { selectRef, toggleOpen, isOpen, setIsOpen };
}, "useSelect");
function SelectBase(props) {
  const { styles: styles25, children, selectedValue, disabled } = props;
  const { id: wrapperId } = unstable_useId();
  const { id: labelId } = unstable_useId();
  const { id: selectedId } = unstable_useId();
  const { selectRef, toggleOpen, isOpen, setIsOpen } = useSelect(disabled);
  const { select: selectCss } = combineStyles27(baseStyles11, styles25);
  const buttonRef = useRef3(null);
  return /* @__PURE__ */ jsx119(
    SelectProvider.Provider,
    {
      value: {
        isOpen,
        toggleOpen,
        selectedValue,
        setIsOpen,
        wrapperId,
        labelId,
        selectedId,
        disabled,
        buttonRef
      },
      children: /* @__PURE__ */ jsx119("div", { css: selectCss, ref: selectRef, id: wrapperId, children })
    }
  );
}
__name(SelectBase, "SelectBase");

// src/molecules/SelectBase/SelectOptionBase.tsx
import { combineStyles as combineStyles28 } from "@instacart/ids-core";
import { jsx as jsx120 } from "@emotion/react/jsx-runtime";
var baseStyles12 = {
  option: {
    cursor: "pointer"
  },
  selectedOption: {
    textDecoration: "underline"
  }
};
function SelectOptionBase({
  styles: styles25,
  children,
  value,
  disabled,
  onClick
}) {
  const { selectedValue, toggleOpen, labelId } = useSelectContext();
  const selected = selectedValue === value;
  const { option: optionCss, selectedOption: selectedOptionCss } = combineStyles28(baseStyles12, styles25);
  const handleClick = /* @__PURE__ */ __name(() => {
    if (disabled)
      return;
    onClick();
    toggleOpen();
  }, "handleClick");
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ jsx120(
      "li",
      {
        "aria-disabled": disabled,
        role: "option",
        tabIndex: -1,
        "aria-selected": selected,
        id: `${labelId}-${value}`,
        onClick: handleClick,
        css: [optionCss, selected ? selectedOptionCss : {}],
        children
      }
    )
  );
}
__name(SelectOptionBase, "SelectOptionBase");

// src/molecules/SelectBase/SelectOptionsBase.tsx
import { Children as Children5, useState as useState3, useCallback as useCallback2, useEffect as useEffect3, useMemo as useMemo5 } from "react";
import { combineStyles as combineStyles29 } from "@instacart/ids-core";
import { jsx as jsx121 } from "@emotion/react/jsx-runtime";
var baseStyles13 = {
  options: {
    display: "none",
    position: "absolute"
  },
  optionsActive: {
    display: "block"
  }
};
function useSelectKeypress(options) {
  const { selectedValue, isOpen, setIsOpen, wrapperId, labelId, buttonRef } = useSelectContext();
  const [focusedValue, setFocusedValue] = useState3(selectedValue);
  const enabledOptions = useMemo5(() => options.filter((opt) => !opt.disabled), [options]);
  const handleKeyPress = useCallback2(
    (e) => {
      var _a, _b;
      const currIndex = enabledOptions.findIndex((opt) => opt.value === focusedValue);
      const changeOption = /* @__PURE__ */ __name((indexDifference) => {
        const newOpt = enabledOptions[currIndex + indexDifference];
        const el = document.getElementById(`${labelId}-${newOpt.value}`);
        el == null ? void 0 : el.focus();
        setFocusedValue(newOpt.value);
      }, "changeOption");
      const openOnArrow = /* @__PURE__ */ __name(() => {
        setIsOpen(true);
        const opt = enabledOptions[currIndex];
        const el = document.getElementById(`${labelId}-${opt.value}`);
        el == null ? void 0 : el.focus();
      }, "openOnArrow");
      switch (e.key) {
        case "ArrowUp":
          e.preventDefault();
          if (isOpen) {
            if (currIndex > 0) {
              changeOption(-1);
            }
          } else {
            openOnArrow();
          }
          break;
        case "ArrowDown":
          e.preventDefault();
          if (isOpen) {
            if (currIndex < enabledOptions.length - 1) {
              changeOption(1);
            }
          } else {
            openOnArrow();
          }
          break;
        case "Enter":
          e.preventDefault();
          if (focusedValue) {
            const opt = enabledOptions[currIndex];
            if (opt)
              opt.onClick();
          }
          setIsOpen(false);
          (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.focus();
          break;
        case "Escape":
          setIsOpen(false);
          (_b = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _b.focus();
          break;
        case "Tab":
          setIsOpen(false);
          break;
      }
    },
    [enabledOptions, focusedValue, isOpen, setIsOpen, buttonRef, labelId]
  );
  useEffect3(() => {
    const select = wrapperId ? document.getElementById(wrapperId) : null;
    if (!select)
      return;
    select.addEventListener("keydown", handleKeyPress);
    return () => {
      select.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress, wrapperId]);
}
__name(useSelectKeypress, "useSelectKeypress");
function SelectOptionsBase({ styles: styles25, children }) {
  const { isOpen, labelId } = useSelectContext();
  const { options: optionsCss, optionsActive: optionsActiveCss } = combineStyles29(baseStyles13, styles25);
  const childProps = (Children5.map(children, (child) => {
    if (child && typeof child === "object" && "props" in child) {
      return child.props;
    }
  }) || []).filter(Boolean);
  useSelectKeypress(childProps);
  return /* @__PURE__ */ jsx121("ul", { css: [optionsCss, isOpen ? optionsActiveCss : []], role: "listbox", "aria-labelledby": labelId, children });
}
__name(SelectOptionsBase, "SelectOptionsBase");

// src/molecules/SelectBase/SelectButtonBase.tsx
import { useCallback as useCallback3 } from "react";
import { combineStyles as combineStyles30 } from "@instacart/ids-core";
import { jsx as jsx122 } from "@emotion/react/jsx-runtime";
var baseStyles14 = {
  button: {
    cursor: "pointer"
  },
  buttonActive: {}
};
function SelectButtonBase({ styles: styles25, children, onClick }) {
  const { isOpen, toggleOpen, selectedValue, selectedId, labelId, disabled, buttonRef } = useSelectContext();
  const { button: buttonCss, buttonActive: buttonActiveCss } = combineStyles30(baseStyles14, styles25);
  const onClickHandler = useCallback3(
    (e) => {
      toggleOpen();
      onClick == null ? void 0 : onClick(e);
    },
    [onClick, toggleOpen]
  );
  return /* @__PURE__ */ jsx122(
    "button",
    {
      ref: buttonRef,
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-labelledby": `${selectedId} ${labelId}`,
      "aria-expanded": isOpen,
      "aria-activedescendant": `${labelId}-${selectedValue}`,
      css: [buttonCss, isOpen ? buttonActiveCss : []],
      onClick: onClickHandler,
      "aria-controls": labelId,
      disabled,
      children
    }
  );
}
__name(SelectButtonBase, "SelectButtonBase");

// src/molecules/SelectBase/SelectButtonValueBase.tsx
import { combineStyles as combineStyles31 } from "@instacart/ids-core";
import { jsx as jsx123 } from "@emotion/react/jsx-runtime";
var baseStyles15 = {
  text: {}
};
function SelectButtonValueBase({ styles: styles25, children }) {
  const { selectedId } = useSelectContext();
  const { text: textCss } = combineStyles31(baseStyles15, styles25);
  return /* @__PURE__ */ jsx123("span", { css: textCss, id: selectedId, children });
}
__name(SelectButtonValueBase, "SelectButtonValueBase");

// src/molecules/SelectBase/SelectedButtonLabelBase.tsx
import { combineStyles as combineStyles32 } from "@instacart/ids-core";
import { jsx as jsx124 } from "@emotion/react/jsx-runtime";
var baseStyles16 = {
  text: {}
};
function SelectButtonLabelBase({ styles: styles25, children }) {
  const { labelId } = useSelectContext();
  const { text: textCss } = combineStyles32(baseStyles16, styles25);
  return /* @__PURE__ */ jsx124("span", { css: textCss, id: labelId, children });
}
__name(SelectButtonLabelBase, "SelectButtonLabelBase");

// src/molecules/Select/Select.tsx
import { jsx as jsx125 } from "@emotion/react/jsx-runtime";
var getStyles28 = /* @__PURE__ */ __name(() => ({
  select: {
    position: "relative"
  }
}), "getStyles");
function Select(props) {
  const styles25 = getStyles28();
  return /* @__PURE__ */ jsx125(SelectBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(Select, "Select");

// src/molecules/Select/SelectButton.tsx
import {
  spacing as spacing35,
  useTheme as useTheme51,
  ChevronDownIcon as ChevronDownIcon2,
  ChevronUpIcon
} from "@instacart/ids-core";
import { jsx as jsx126, jsxs as jsxs17 } from "@emotion/react/jsx-runtime";
var getStyles29 = /* @__PURE__ */ __name((theme) => ({
  button: __spreadProps(__spreadValues({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${spacing35.s8}px ${spacing35.s12}px`,
    color: theme.colors.systemGrayscale70,
    backgroundColor: theme.colors.systemGrayscale00,
    border: `1px solid ${theme.colors.systemGrayscale30}`,
    borderRadius: theme.radius.r8,
    boxSizing: "border-box"
  }, theme.typography.bodyMedium1), {
    whiteSpace: "nowrap",
    height: 40,
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale10
    },
    "&:active": {
      borderColor: theme.colors.systemGrayscale70,
      backgroundColor: theme.colors.systemGrayscale20
    },
    "&:focus": {
      outline: 0
    },
    ":focus-visible:": {
      outline: 0
    },
    "&.focus-visible::after": {
      borderRadius: theme.radius.r12,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4
    },
    "&:disabled": {
      backgroundColor: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30,
      cursor: "default",
      border: `1px solid transparent`
    }
  }),
  buttonActive: {
    borderColor: theme.colors.systemGrayscale70,
    backgroundColor: theme.colors.systemGrayscale20
  }
}), "getStyles");
var childWrapperStyles = {
  marginRight: spacing35.s8,
  textAlign: "left"
};
function SelectButton(props) {
  const { children } = props;
  const { isOpen, disabled } = useSelectContext();
  const theme = useTheme51();
  const styles25 = getStyles29(theme);
  const iconColor2 = disabled ? "systemGrayscale30" : "systemGrayscale70";
  return /* @__PURE__ */ jsxs17(SelectButtonBase, __spreadProps(__spreadValues({}, props), { styles: styles25, children: [
    /* @__PURE__ */ jsx126("div", { css: childWrapperStyles, children }),
    isOpen ? /* @__PURE__ */ jsx126(ChevronUpIcon, { color: iconColor2 }) : /* @__PURE__ */ jsx126(ChevronDownIcon2, { color: iconColor2 })
  ] }));
}
__name(SelectButton, "SelectButton");

// src/molecules/Select/SelectButtonLabel.tsx
import { useTheme as useTheme52 } from "@instacart/ids-core";
import { jsx as jsx127 } from "@emotion/react/jsx-runtime";
var getStyles30 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({}, theme.typography.bodyMedium1)
}), "getStyles");
function SelectButtonLabel(props) {
  const theme = useTheme52();
  const styles25 = getStyles30(theme);
  return /* @__PURE__ */ jsx127(SelectButtonLabelBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(SelectButtonLabel, "SelectButtonLabel");

// src/molecules/Select/SelectButtonValue.tsx
import { useTheme as useTheme53 } from "@instacart/ids-core";
import { jsx as jsx128 } from "@emotion/react/jsx-runtime";
var getStyles31 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({}, theme.typography.bodyMedium1)
}), "getStyles");
function SelectButtonValue(props) {
  const theme = useTheme53();
  const styles25 = getStyles31(theme);
  return /* @__PURE__ */ jsx128(SelectButtonValueBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(SelectButtonValue, "SelectButtonValue");

// src/molecules/Select/SelectOption.tsx
import { spacing as spacing36, useTheme as useTheme54, ConfirmIcon } from "@instacart/ids-core";
import { jsx as jsx129, jsxs as jsxs18 } from "@emotion/react/jsx-runtime";
var getStyles32 = /* @__PURE__ */ __name((theme, disabled) => ({
  option: __spreadProps(__spreadValues({
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    textAlign: "left",
    justifyContent: "space-between",
    padding: spacing36.s8,
    backgroundColor: theme.colors.systemGrayscale00,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70,
    borderRadius: theme.radius.r8,
    border: "2px solid transparent"
  }, theme.typography.bodyMedium1), {
    cursor: disabled ? "default" : "pointer",
    ":hover": {
      outline: "none",
      borderRadius: theme.radius.r8,
      backgroundColor: theme.colors.systemGrayscale10
    },
    "&:focus": {
      outline: "none",
      borderColor: theme.colors.systemGrayscale70
    },
    ":disabled": {
      color: theme.colors.systemGrayscale30
    }
  }),
  selectedOption: {
    textDecoration: "none"
  }
}), "getStyles");
var iconStyles = {
  position: "relative",
  width: 24,
  marginLeft: spacing36.s8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
function SelectOption(props) {
  const { value, children, disabled } = props;
  const { selectedValue } = useSelectContext();
  const selected = selectedValue === value;
  const theme = useTheme54();
  const styles25 = getStyles32(theme, disabled);
  return /* @__PURE__ */ jsxs18(SelectOptionBase, __spreadProps(__spreadValues({}, props), { styles: styles25, children: [
    children,
    /* @__PURE__ */ jsx129("div", { css: iconStyles, children: selected && /* @__PURE__ */ jsx129(ConfirmIcon, { size: "17", color: "systemSuccessRegular" }) })
  ] }));
}
__name(SelectOption, "SelectOption");

// src/molecules/Select/SelectOptions.tsx
import { elevation as elevation5, spacing as spacing37, useTheme as useTheme55 } from "@instacart/ids-core";
import { jsx as jsx130 } from "@emotion/react/jsx-runtime";
var getStyles33 = /* @__PURE__ */ __name((theme, leftAligned) => ({
  options: __spreadValues(__spreadProps(__spreadValues({
    display: "none",
    position: "absolute",
    minWidth: `max(calc(100% - 16px), 204px)`,
    padding: spacing37.s8,
    borderRadius: theme.radius.r12,
    backgroundColor: theme.colors.systemGrayscale00
  }, elevation5.low.shadow), {
    zIndex: 500,
    listStyle: "none",
    margin: `${spacing37.s8}px 0px`
  }), leftAligned ? { left: 0 } : { right: 0 }),
  optionsActive: {
    display: "block"
  }
}), "getStyles");
function SelectOptions(props) {
  const _a = props, { alignment } = _a, rest = __objRest(_a, ["alignment"]);
  const theme = useTheme55();
  const styles25 = getStyles33(theme, alignment === "left");
  return /* @__PURE__ */ jsx130(SelectOptionsBase, __spreadProps(__spreadValues({}, rest), { styles: styles25 }));
}
__name(SelectOptions, "SelectOptions");

// src/molecules/TertiaryButton/TertiaryButton.tsx
import { forwardRef as forwardRef61 } from "react";
import { ButtonBase as ButtonBase16 } from "@instacart/ids-core";
import { jsx as jsx131 } from "@emotion/react/jsx-runtime";
var TertiaryButton = forwardRef61(
  /* @__PURE__ */ __name(function TertiaryButton2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale00",
      activeColor: "systemGrayscale30",
      hoverColor: ["systemGrayscale00", "systemGrayscale30"],
      textColor: "systemGrayscale80",
      borderColor: "systemGrayscale20"
    });
    return /* @__PURE__ */ jsx131(ButtonBase16, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "TertiaryButton")
);

// src/molecules/TertiaryButtonCompact/TertiaryButtonCompact.tsx
import { forwardRef as forwardRef62 } from "react";
import { jsx as jsx132 } from "@emotion/react/jsx-runtime";
var TertiaryButtonCompact = forwardRef62(
  /* @__PURE__ */ __name(function TertiaryButtonCompact2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale00",
      activeColor: "systemGrayscale30",
      hoverColor: ["systemGrayscale00", "systemGrayscale30"],
      textColor: "systemGrayscale80",
      borderColor: "systemGrayscale20",
      size: 2 /* Compact */
    });
    return /* @__PURE__ */ jsx132(ButtonCompactBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "TertiaryButtonCompact")
);

// src/molecules/TertiaryButtonSmall/TertiaryButtonSmall.tsx
import { forwardRef as forwardRef63 } from "react";
import { jsx as jsx133 } from "@emotion/react/jsx-runtime";
var TertiaryButtonSmall = forwardRef63(
  /* @__PURE__ */ __name(function TertiaryButtonSmall2(props, ref) {
    const styles25 = useSharedButtonStyles({
      primaryColor: "systemGrayscale00",
      activeColor: "systemGrayscale30",
      hoverColor: ["systemGrayscale00", "systemGrayscale30"],
      textColor: "systemGrayscale80",
      borderColor: "systemGrayscale20",
      size: 1 /* Small */
    });
    return /* @__PURE__ */ jsx133(ButtonSmallBase, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "TertiaryButtonSmall")
);

// src/molecules/TextArea/TextAreaFixed.tsx
import { TextAreaBase } from "@instacart/ids-core";
import { jsx as jsx134 } from "@emotion/react/jsx-runtime";
var styles18 = {
  textarea: {
    resize: "none"
  }
};
function TextAreaFixed(props) {
  return /* @__PURE__ */ jsx134(TextAreaBase, __spreadValues({ styles: styles18 }, props));
}
__name(TextAreaFixed, "TextAreaFixed");

// src/molecules/TextArea/TextAreaDynamic.tsx
import { TextAreaBase as TextAreaBase2 } from "@instacart/ids-core";
import { jsx as jsx135 } from "@emotion/react/jsx-runtime";
var styles19 = {
  textarea: {
    resize: "vertical",
    minHeight: "60px"
  }
};
function TextAreaDynamic(props) {
  return /* @__PURE__ */ jsx135(TextAreaBase2, __spreadValues({ styles: styles19 }, props));
}
__name(TextAreaDynamic, "TextAreaDynamic");

// src/molecules/TextButton/TextButton.tsx
import {
  ButtonBase as ButtonBase17,
  ChevronDownIcon as ChevronDownIcon3,
  ChevronRightIcon as ChevronRightIcon4,
  spacing as spacing38,
  useTheme as useTheme56
} from "@instacart/ids-core";
import { cloneElement as cloneElement4, forwardRef as forwardRef64 } from "react";
import { isElement as isElement3 } from "react-is";
import { jsx as jsx136, jsxs as jsxs19 } from "@emotion/react/jsx-runtime";
var getStyles34 = /* @__PURE__ */ __name((theme, colorStyle) => ({
  button: {
    backgroundColor: "transparent"
  },
  focusRing: {
    borderRadius: 32,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  content: __spreadProps(__spreadValues({
    padding: `10px ${spacing38.s16}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing38.s4
  }, theme.typography.bodyMedium1), {
    color: colorStyle ? theme.colors[colorStyle] : theme.colors.systemGrayscale70,
    minWidth: 92,
    "& > svg": {
      flexShrink: 0
    }
  })
}), "getStyles");
var TextButton = forwardRef64((props, ref) => {
  const theme = useTheme56();
  const _a = props, { leadingIcon: LeadingIcon, children, colorStyle } = _a, rest = __objRest(_a, ["leadingIcon", "children", "colorStyle"]);
  const styles25 = getStyles34(theme, props.colorStyle);
  const TrailingIcon = LeadingIcon ? ChevronDownIcon3 : ChevronRightIcon4;
  return /* @__PURE__ */ jsxs19(ButtonBase17, __spreadProps(__spreadValues({ styles: styles25 }, rest), { ref, children: [
    LeadingIcon && (isElement3(LeadingIcon) ? renderIconElement2(LeadingIcon) : /* @__PURE__ */ jsx136(LeadingIcon, { "aria-hidden": true, size: 16 })),
    /* @__PURE__ */ jsx136("span", { css: { overflow: "hidden", textOverflow: "ellipsis" }, children }),
    /* @__PURE__ */ jsx136(TrailingIcon, { size: 16, "aria-hidden": true })
  ] }));
});
function renderIconElement2(element) {
  return cloneElement4(element, { "aria-hidden": true, size: 16 });
}
__name(renderIconElement2, "renderIconElement");
TextButton.displayName = "TextButton";

// src/molecules/TileBase/TileBase.tsx
import { forwardRef as forwardRef65 } from "react";
import { combineStyles as combineStyles33, useTheme as useTheme57 } from "@instacart/ids-core";
import { jsx as jsx137 } from "@emotion/react/jsx-runtime";
var getStyles35 = /* @__PURE__ */ __name((theme) => ({
  container: {
    backgroundColor: theme.colors.systemGrayscale10,
    borderRadius: theme.radius.r12,
    "&:hover": {
      backgroundColor: theme.colors.systemGrayscale20
    }
  }
}), "getStyles");
var TileBase = forwardRef65(/* @__PURE__ */ __name(function TileBase2(_a, ref) {
  var _b = _a, { styles: stylesProp, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme57();
  const styles25 = combineStyles33(getStyles35(theme), stylesProp);
  return /* @__PURE__ */ jsx137("div", __spreadProps(__spreadValues({ ref, css: styles25.container }, rest), { children }));
}, "TileBase"));

// src/molecules/TileBase/TileAnchor.tsx
import { forwardRef as forwardRef66 } from "react";
import { combineStyles as combineStyles34, useTheme as useTheme58, spacing as spacing39 } from "@instacart/ids-core";
import { jsx as jsx138 } from "@emotion/react/jsx-runtime";
var BORDER_WIDTH4 = 2;
var ACTIVE_BORDER_MARGIN = `-${spacing39.s8}px`;
var getStyles36 = /* @__PURE__ */ __name((theme) => ({
  anchor: {
    position: "relative",
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    touchAction: "manipulation",
    textDecoration: "none",
    "&.focus-visible::after": {
      borderRadius: theme.radius.r12,
      border: `${BORDER_WIDTH4}px solid ${theme.colors.systemGrayscale70}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: ACTIVE_BORDER_MARGIN,
      bottom: ACTIVE_BORDER_MARGIN,
      left: ACTIVE_BORDER_MARGIN,
      right: ACTIVE_BORDER_MARGIN
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    }
  }
}), "getStyles");
var TileAnchor = forwardRef66(/* @__PURE__ */ __name(function TileAnchor2(_a, ref) {
  var _b = _a, { href, styles: styles25, children } = _b, rest = __objRest(_b, ["href", "styles", "children"]);
  const theme = useTheme58();
  const { anchor } = combineStyles34(getStyles36(theme), styles25);
  return /* @__PURE__ */ jsx138("a", __spreadProps(__spreadValues({ ref, href, css: anchor }, rest), { children }));
}, "TileAnchor"));

// src/molecules/TileBase/TileTitle.tsx
import { combineStyles as combineStyles35, useTheme as useTheme59 } from "@instacart/ids-core";
import { jsx as jsx139 } from "@emotion/react/jsx-runtime";
var getStyles37 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.colors.systemGrayscale70
  }, theme.typography.bodyMedium1)
}), "getStyles");
function TileTitle(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme59();
  const { text: textCSS } = combineStyles35(getStyles37(theme), styles25);
  return /* @__PURE__ */ jsx139("span", __spreadProps(__spreadValues({ css: textCSS }, rest), { children }));
}
__name(TileTitle, "TileTitle");

// src/molecules/TileBase/TileImage.tsx
import { combineStyles as combineStyles36, aspectRatio as aspectRatio3, useTheme as useTheme60 } from "@instacart/ids-core";
import { jsx as jsx140 } from "@emotion/react/jsx-runtime";
var getStyles38 = /* @__PURE__ */ __name((theme) => __spreadValues({
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r8
  }
}, aspectRatio3(1, 1)), "getStyles");
function TileImage(props) {
  const _a = props, { styles: styles25, src, alt, children } = _a, rest = __objRest(_a, ["styles", "src", "alt", "children"]);
  const theme = useTheme60();
  const { box, img } = combineStyles36(getStyles38(theme), styles25);
  return /* @__PURE__ */ jsx140("div", { css: box, children: /* @__PURE__ */ jsx140("img", __spreadProps(__spreadValues({}, rest), { css: img, src, alt })) });
}
__name(TileImage, "TileImage");

// src/molecules/StoreCardBase/StoreCardBase.tsx
import { forwardRef as forwardRef67 } from "react";
import { combineStyles as combineStyles37 } from "@instacart/ids-core";
import { jsx as jsx141 } from "@emotion/react/jsx-runtime";
var getStyles39 = /* @__PURE__ */ __name(() => ({
  container: {}
}), "getStyles");
var StoreCardBase = forwardRef67(/* @__PURE__ */ __name(function TileBase3(_a, ref) {
  var _b = _a, { styles: stylesProp, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const styles25 = combineStyles37(getStyles39(), stylesProp);
  return /* @__PURE__ */ jsx141("div", __spreadProps(__spreadValues({ ref, css: styles25.container }, rest), { children }));
}, "TileBase"));

// src/molecules/StoreCardBase/StoreCardAnchor.tsx
import { forwardRef as forwardRef68 } from "react";
import { combineStyles as combineStyles38, useTheme as useTheme61, spacing as spacing40 } from "@instacart/ids-core";
import { jsx as jsx142 } from "@emotion/react/jsx-runtime";
var getStyles40 = /* @__PURE__ */ __name((theme, disabled) => ({
  anchor: {
    height: "100%",
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "min-content 1fr max-content",
    gridTemplateRows: "1fr min-content",
    gridTemplateAreas: '"image center right" "footer footer footer"',
    position: "relative",
    margin: 0,
    cursor: "pointer",
    userSelect: "none",
    touchAction: "manipulation",
    textDecoration: "none",
    padding: spacing40.s12,
    opacity: disabled ? 0.5 : 1,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    },
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: "none"
    }
  }
}), "getStyles");
var StoreCardAnchor = forwardRef68(
  /* @__PURE__ */ __name(function StoreCardAnchor2(_a, ref) {
    var _b = _a, { href, styles: styles25, children, disabled } = _b, rest = __objRest(_b, ["href", "styles", "children", "disabled"]);
    const theme = useTheme61();
    const { anchor } = combineStyles38(getStyles40(theme, disabled), styles25);
    return /* @__PURE__ */ jsx142(
      "a",
      __spreadProps(__spreadValues({
        ref,
        href: !disabled ? href : void 0,
        css: anchor
      }, rest), {
        "aria-disabled": !!disabled,
        role: disabled ? "link" : void 0,
        children
      })
    );
  }, "StoreCardAnchor")
);
StoreCardAnchor.displayName = "StoreCardAnchor";

// src/molecules/StoreCardBase/StoreCardTitle.tsx
import { combineStyles as combineStyles39, useTheme as useTheme62 } from "@instacart/ids-core";
import { jsx as jsx143 } from "@emotion/react/jsx-runtime";
var getStyles41 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({
    display: "block",
    color: theme.colors.systemGrayscale70
  }, theme.typography.bodyMedium1)
}), "getStyles");
function StoreCardTitle(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme62();
  const { text: textCSS } = combineStyles39(getStyles41(theme), styles25);
  return /* @__PURE__ */ jsx143("span", __spreadProps(__spreadValues({ css: textCSS }, rest), { children }));
}
__name(StoreCardTitle, "StoreCardTitle");

// src/molecules/StoreCardBase/StoreCardImage.tsx
import { combineStyles as combineStyles40, useTheme as useTheme63, spacing as spacing41 } from "@instacart/ids-core";
import { jsx as jsx144 } from "@emotion/react/jsx-runtime";
var getStyles42 = /* @__PURE__ */ __name((theme) => ({
  imgWrapper: {
    gridArea: "image",
    display: "flex",
    marginRight: spacing41.s12,
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: theme.radius.r8
  }
}), "getStyles");
function StoreCardImage(props) {
  const { styles: styles25, children } = props;
  const theme = useTheme63();
  const { imgWrapper } = combineStyles40(getStyles42(theme), styles25);
  return /* @__PURE__ */ jsx144("div", { css: imgWrapper, children });
}
__name(StoreCardImage, "StoreCardImage");

// src/molecules/StoreCardBase/StoreCardCenter.tsx
import { combineStyles as combineStyles41 } from "@instacart/ids-core";
import { jsx as jsx145 } from "@emotion/react/jsx-runtime";
var getStyles43 = /* @__PURE__ */ __name(() => ({
  container: {
    gridArea: "center",
    display: "block"
  }
}), "getStyles");
function StoreCardCenter(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { container } = combineStyles41(getStyles43(), styles25);
  return /* @__PURE__ */ jsx145("div", __spreadProps(__spreadValues({ css: container }, rest), { children }));
}
__name(StoreCardCenter, "StoreCardCenter");

// src/molecules/StoreCardBase/StoreCardRight.tsx
import { combineStyles as combineStyles42 } from "@instacart/ids-core";
import { jsx as jsx146 } from "@emotion/react/jsx-runtime";
var getStyles44 = /* @__PURE__ */ __name(() => ({
  container: {
    gridArea: "right",
    display: "flex",
    alignSelf: "center",
    marginLeft: "auto"
  }
}), "getStyles");
function StoreCardRight(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { container } = combineStyles42(getStyles44(), styles25);
  return /* @__PURE__ */ jsx146("div", __spreadProps(__spreadValues({ css: container }, rest), { children }));
}
__name(StoreCardRight, "StoreCardRight");

// src/molecules/StoreCardBase/StoreCardCenterFooter.tsx
import { combineStyles as combineStyles43 } from "@instacart/ids-core";
import { jsx as jsx147 } from "@emotion/react/jsx-runtime";
var getStyles45 = /* @__PURE__ */ __name(() => ({
  container: {}
}), "getStyles");
function StoreCardCenterFooter(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { container } = combineStyles43(getStyles45(), styles25);
  return /* @__PURE__ */ jsx147("div", __spreadProps(__spreadValues({ css: container }, rest), { children }));
}
__name(StoreCardCenterFooter, "StoreCardCenterFooter");

// src/molecules/StoreCardBase/StoreCardFooter.tsx
import { combineStyles as combineStyles44, spacing as spacing42 } from "@instacart/ids-core";
import { jsx as jsx148 } from "@emotion/react/jsx-runtime";
var getStyles46 = /* @__PURE__ */ __name(() => ({
  container: {
    gridArea: "footer",
    marginTop: spacing42.s12,
    /**
     * Fixes an issue in Firefox where children containing a flex node do not properly apply overflow
     * @see https://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
     */
    minWidth: 0
  }
}), "getStyles");
function StoreCardFooter(_a) {
  var _b = _a, { children, styles: propsStyles } = _b, rest = __objRest(_b, ["children", "styles"]);
  const styles25 = combineStyles44(getStyles46(), propsStyles);
  return /* @__PURE__ */ jsx148("div", __spreadProps(__spreadValues({ css: styles25.container }, rest), { children }));
}
__name(StoreCardFooter, "StoreCardFooter");

// src/molecules/SingleLineTextInput/SingleLineTextInput.tsx
import { TextInputBase as TextInputBase2 } from "@instacart/ids-core";
import { forwardRef as forwardRef69 } from "react";
import { jsx as jsx149 } from "@emotion/react/jsx-runtime";
var SingleLineTextInput2 = forwardRef69(
  /* @__PURE__ */ __name(function SingleLineTextInput3(props, ref) {
    return /* @__PURE__ */ jsx149(TextInputBase2, __spreadProps(__spreadValues({}, props), { ref }));
  }, "SingleLineTextInput")
);

// src/molecules/SingleLineTextInputDark/SingleLineTextInputDark.tsx
import { useTheme as useTheme64, TextInputBase as TextInputBase3 } from "@instacart/ids-core";
import { forwardRef as forwardRef70 } from "react";
import { jsx as jsx150 } from "@emotion/react/jsx-runtime";
var getStyles47 = /* @__PURE__ */ __name((theme) => ({
  wrapper: {
    background: theme.colors.kaleDark,
    border: `1px solid ${theme.colors.kaleDark}`
  },
  label: {
    color: theme.colors.tertiaryRegular
  },
  input: {
    color: theme.colors.tertiaryRegular,
    caretColor: theme.colors.tertiaryRegular,
    "&:placeholder-shown:not(:focus) + *": {
      color: theme.colors.tertiaryRegular
    }
  }
}), "getStyles");
var SingleLineTextInputDark = forwardRef70(
  /* @__PURE__ */ __name(function SingleLineTextInputDark2(props, ref) {
    const theme = useTheme64();
    const styles25 = getStyles47(theme);
    return /* @__PURE__ */ jsx150(TextInputBase3, __spreadProps(__spreadValues({}, props), { styles: styles25, ref }));
  }, "SingleLineTextInputDark")
);

// src/molecules/SingleSelect/SingleSelectOption.tsx
import { spacing as spacing43, useTheme as useTheme65, ConfirmIcon as ConfirmIcon2 } from "@instacart/ids-core";

// src/molecules/SelectMenu/utils.ts
var getPreviousItem = /* @__PURE__ */ __name((rowIds, rowId) => {
  const findIndexInArray = rowIds.findIndex((currentRowId) => {
    return currentRowId === rowId;
  });
  return findIndexInArray <= 0 ? rowIds.length - 1 : findIndexInArray - 1;
}, "getPreviousItem");
var getNextItem = /* @__PURE__ */ __name((rowIds, rowId) => {
  if (!rowId)
    return 0;
  const findIndexInArray = rowIds.findIndex((currentRowId) => {
    return currentRowId === rowId;
  });
  return findIndexInArray + 1 >= rowIds.length ? 0 : findIndexInArray + 1;
}, "getNextItem");
var handleArrowNavigation = /* @__PURE__ */ __name((event, rows, row) => {
  let newIndex;
  let newItem;
  if (event.key === "ArrowUp" /* ArrowUp */) {
    event.preventDefault();
    newIndex = getPreviousItem(rows, row);
    newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);
    if ((newItem == null ? void 0 : newItem.disabled) && newIndex === 0) {
      newItem = document.getElementById(rows == null ? void 0 : rows[rows.length - 1]);
    }
    if (!newItem || (newItem == null ? void 0 : newItem.disabled)) {
      newItem = document.getElementById(rows == null ? void 0 : rows[newIndex - 1]);
    }
  }
  if (event.code === "ArrowDown" /* ArrowDown */) {
    event.preventDefault();
    newIndex = getNextItem(rows, row);
    newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);
    if ((newItem == null ? void 0 : newItem.disabled) && newIndex === 0) {
      newItem = document.getElementById(rows == null ? void 0 : rows[1]);
    }
    if (!newItem || newItem.disabled) {
      newIndex = newIndex + 1;
      newItem = document.getElementById(rows == null ? void 0 : rows[newIndex]);
    }
  }
  newItem == null ? void 0 : newItem.focus();
  return newIndex;
}, "handleArrowNavigation");

// src/molecules/SelectMenu/useSelectMenu.ts
import { useContext as useContext6 } from "react";

// src/molecules/SelectMenu/SelectMenuContext.ts
import { createContext as createContext3 } from "react";
var SelectMenuContext = createContext3({
  menuRef: null,
  buttonRef: null,
  dropdownRef: null,
  wrapperId: "",
  labelId: "",
  selectedId: "",
  options: [],
  optionIds: [],
  hasFixedFooter: false,
  selectedValue: "",
  setSelectedValue: () => {
  },
  visible: false,
  handleArrowNavigation,
  setVisible: () => {
  },
  handleSubmit: () => {
  },
  handleMenuKeyDown: () => {
  }
});

// src/molecules/SelectMenu/useSelectMenu.ts
var useSelectMenuContext = /* @__PURE__ */ __name(() => {
  return useContext6(SelectMenuContext);
}, "useSelectMenuContext");

// src/molecules/SingleSelect/SingleSelectOption.tsx
import { jsx as jsx151, jsxs as jsxs20 } from "@emotion/react/jsx-runtime";
var getStyles48 = /* @__PURE__ */ __name((theme) => (disabled, selected) => {
  let optionTextColor = theme.colors.systemGrayscale50;
  if (disabled) {
    optionTextColor = theme.colors.systemGrayscale30;
  }
  if (selected) {
    optionTextColor = theme.colors.systemGrayscale70;
  }
  const cursor = disabled ? "default" : "pointer";
  return {
    option: __spreadProps(__spreadValues({
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      width: "100%",
      marginBottom: spacing43.s4,
      textAlign: "left",
      justifyContent: "space-between",
      backgroundColor: "transparent",
      color: optionTextColor,
      border: "none"
    }, theme.typography.bodyMedium1), {
      ":hover": {
        outline: "none",
        borderRadius: theme.radius.r8,
        backgroundColor: disabled ? "transparent" : theme.colors.systemGrayscale10
      }
    }),
    label: __spreadProps(__spreadValues({
      width: "100%",
      display: "flex",
      padding: spacing43.s8
    }, theme.typography.bodyMedium1), {
      cursor,
      ":hover": {
        cursor
      }
    }),
    input: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      appearance: "none",
      ":hover": {
        cursor
      },
      ":focus": {
        outline: "none"
      },
      ":focus-visible::after": {
        content: '""',
        display: "block",
        position: "absolute",
        left: 0,
        right: 0,
        top: -4,
        bottom: -4,
        outline: "none",
        border: `2px solid ${theme.colors.systemGrayscale70}`,
        borderRadius: theme.radius.r12
      },
      ":disabled": {
        color: theme.colors.systemGrayscale30
      }
    },
    selectedOption: {
      textDecoration: "none"
    },
    icon: {
      position: "relative",
      width: 24,
      marginLeft: "auto"
    }
  };
}, "getStyles");
function SingleSelectOption(props) {
  const _a = props, { index, children, id, keyString, value, disabled } = _a, rest = __objRest(_a, ["index", "children", "id", "keyString", "value", "disabled"]);
  const theme = useTheme65();
  const { selectedValue, setSelectedValue, handleArrowNavigation: handleArrowNavigation2, optionIds, handleMenuKeyDown } = useSelectMenuContext();
  const stringValue = `${keyString}=${value}`;
  const selected = selectedValue === stringValue;
  const styles25 = getStyles48(theme)(disabled, selected);
  return /* @__PURE__ */ jsxs20("li", { css: styles25.option, children: [
    /* @__PURE__ */ jsx151(
      "input",
      __spreadValues({
        id,
        type: "radio",
        css: styles25.input,
        onClick: () => {
          if (setSelectedValue) {
            setSelectedValue(stringValue);
          }
        },
        onKeyDown: (event) => {
          handleMenuKeyDown(event);
          if (event.code === "ArrowUp" /* ArrowUp */ || event.code === "ArrowDown" /* ArrowDown */) {
            handleArrowNavigation2(event, optionIds, id);
          }
          if (event.code === "Enter" /* Enter */ || event.code === "Space" /* Space */) {
            if (setSelectedValue) {
              setSelectedValue(stringValue);
            }
          }
        },
        disabled
      }, rest)
    ),
    /* @__PURE__ */ jsxs20("label", { css: styles25.label, htmlFor: id, children: [
      children,
      /* @__PURE__ */ jsx151("div", { css: styles25.icon, "aria-hidden": true, children: selected && /* @__PURE__ */ jsx151(ConfirmIcon2, { size: "17", color: "systemSuccessRegular" }) })
    ] })
  ] });
}
__name(SingleSelectOption, "SingleSelectOption");

// src/molecules/SingleSelect/SingleSelectSubOption.tsx
import { spacing as spacing44, useTheme as useTheme66, ConfirmIcon as ConfirmIcon3, A11Y as A11Y2 } from "@instacart/ids-core";

// src/molecules/SingleSelect/utils.ts
var createSelectedOption = /* @__PURE__ */ __name((key, value) => {
  const urlParam = new URLSearchParams();
  urlParam.set(key, value);
  return urlParam.toString();
}, "createSelectedOption");

// src/molecules/SingleSelect/SingleSelectSubOption.tsx
import { jsx as jsx152, jsxs as jsxs21 } from "@emotion/react/jsx-runtime";
function SingleSelectSubOption(props) {
  const _a = props, { children, value, id, keyString, optionLabel, disabled } = _a, rest = __objRest(_a, ["children", "value", "id", "keyString", "optionLabel", "disabled"]);
  const theme = useTheme66();
  const { selectedValue, setSelectedValue, optionIds, handleArrowNavigation: handleArrowNavigation2, handleMenuKeyDown } = useSelectMenuContext();
  const selectedString = createSelectedOption(keyString, value);
  const selected = selectedValue === selectedString;
  const styles25 = getStyles48(theme)(disabled, selected);
  const selfStyles = __spreadValues({
    paddingLeft: spacing44.s24
  }, theme.typography.bodyMedium2);
  const labelSelfStyles = __spreadValues({}, theme.typography.bodyMedium2);
  return /* @__PURE__ */ jsxs21("li", { css: [styles25.option, selfStyles], children: [
    /* @__PURE__ */ jsx152(
      "input",
      __spreadProps(__spreadValues({
        id,
        type: "radio",
        css: [styles25.input, selfStyles],
        value,
        onClick: () => {
          if (setSelectedValue) {
            setSelectedValue(selectedString);
          }
        }
      }, rest), {
        onKeyDown: (event) => {
          handleMenuKeyDown(event);
          if (event.code === "ArrowUp" /* ArrowUp */ || event.code === "ArrowDown" /* ArrowDown */) {
            handleArrowNavigation2(event, optionIds, id);
          }
          if (event.key === "Enter" /* Enter */ || event.code === "Space" /* Space */) {
            if (setSelectedValue) {
              setSelectedValue(selectedString);
            }
          }
        }
      })
    ),
    /* @__PURE__ */ jsxs21("label", { css: [styles25.label, labelSelfStyles], htmlFor: id, children: [
      optionLabel && /* @__PURE__ */ jsx152("span", { css: A11Y2.visuallyHidden, children: optionLabel }),
      children,
      selected && /* @__PURE__ */ jsx152("div", { css: styles25.icon, children: /* @__PURE__ */ jsx152(ConfirmIcon3, { size: "17", color: "systemSuccessRegular" }) })
    ] })
  ] });
}
__name(SingleSelectSubOption, "SingleSelectSubOption");

// src/molecules/SingleSelect/SingleSelectViewMoreButton.tsx
import { Fragment as Fragment2, useState as useState4, useRef as useRef4 } from "react";
import { spacing as spacing45, useTheme as useTheme67 } from "@instacart/ids-core";
import { jsx as jsx153 } from "@emotion/react/jsx-runtime";
var getStyles49 = /* @__PURE__ */ __name((theme) => __spreadProps(__spreadValues({
  display: "block",
  position: "relative",
  textAlign: "left",
  width: "100%"
}, theme.typography.bodyMedium1), {
  background: theme.colors.systemGrayscale00,
  color: theme.colors.brandPrimaryRegular,
  marginTop: spacing45.s12,
  marginBottom: spacing45.s12,
  border: "none",
  padding: spacing45.s8,
  paddingRight: spacing45.s8,
  paddingLeft: spacing45.s24,
  borderRadius: theme.radius.r12,
  cursor: "pointer",
  ":hover": {
    backgroundColor: theme.colors.systemGrayscale10
  },
  ":focus-visible": {
    outline: "none"
  },
  ":focus-visible::after": {
    content: '""',
    position: "absolute",
    top: -4,
    left: 0,
    bottom: -4,
    right: 0,
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    borderRadius: theme.radius.r12
  }
}), "getStyles");
function SingleSelectViewMoreButton(props) {
  const _a = props, { children, viewMoreString } = _a, rest = __objRest(_a, ["children", "viewMoreString"]);
  const theme = useTheme67();
  const [visible, setVisible] = useState4(false);
  const ref = useRef4(null);
  const styles25 = getStyles49(theme);
  return /* @__PURE__ */ jsx153(Fragment2, { children: !visible ? /* @__PURE__ */ jsx153("li", { ref, children: /* @__PURE__ */ jsx153(
    "button",
    __spreadProps(__spreadValues({
      css: styles25,
      onClick: () => {
        var _a2, _b;
        setVisible(true);
        const el = (_b = (_a2 = ref == null ? void 0 : ref.current) == null ? void 0 : _a2.previousSibling) == null ? void 0 : _b.firstChild;
        if (el) {
          el.focus();
        }
      }
    }, rest), {
      children: viewMoreString
    })
  ) }) : children });
}
__name(SingleSelectViewMoreButton, "SingleSelectViewMoreButton");

// src/molecules/SelectMenu/SelectMenu.tsx
import {
  useRef as useRef5,
  useState as useState5,
  useEffect as useEffect4
} from "react";
import { spacing as spacing46, useOnClickOutside as useOnClickOutside3 } from "@instacart/ids-core";
import { unstable_useId as unstable_useId2 } from "reakit";
import { jsx as jsx154 } from "@emotion/react/jsx-runtime";
var styles20 = {
  display: "inline-block",
  position: "relative",
  marginRight: spacing46.s8
};
function SelectMenu(props) {
  const _a = props, { children, selectedValue, setSelectedValue, options } = _a, rest = __objRest(_a, ["children", "selectedValue", "setSelectedValue", "options"]);
  const [elToFocus, setElToFocus] = useState5(null);
  const menuRef = useRef5(null);
  const buttonRef = useRef5(null);
  const dropdownRef = useRef5(null);
  const { id: wrapperId } = unstable_useId2();
  const { id: labelId } = unstable_useId2();
  const { id: selectedId } = unstable_useId2();
  const [visible, setVisible] = useState5(false);
  const [hasFixedFooter, setHasFixedFooter] = useState5(false);
  useEffect4(() => {
    if (visible && elToFocus) {
      elToFocus.focus();
      setElToFocus(null);
    }
  }, [visible, elToFocus]);
  useOnClickOutside3(menuRef, () => {
    setVisible(false);
  });
  const handleSubmit = /* @__PURE__ */ __name((event, close = true) => {
    const buttonEl = buttonRef == null ? void 0 : buttonRef.current;
    if (buttonEl && event.key === "Enter") {
      event.preventDefault();
      if (close) {
        setVisible(false);
        buttonEl.focus();
      }
    }
    if (buttonEl && event.code === "Space") {
      if (close) {
        setVisible(false);
        buttonEl.focus();
      }
    }
  }, "handleSubmit");
  const handleMenuKeyDown = /* @__PURE__ */ __name((event) => {
    var _a2;
    if (event.key === "Escape") {
      setVisible(false);
      if ((_a2 = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a2.focus) {
        buttonRef.current.focus();
      }
    }
  }, "handleMenuKeyDown");
  useEffect4(() => {
    var _a2;
    const dropdownHeight = (_a2 = dropdownRef == null ? void 0 : dropdownRef.current) == null ? void 0 : _a2.offsetHeight;
    if (visible && dropdownHeight && dropdownHeight > 350) {
      setHasFixedFooter(true);
    }
  }, [visible, dropdownRef]);
  useEffect4(() => {
    const handleTabOutside = /* @__PURE__ */ __name((event) => {
      if ((menuRef == null ? void 0 : menuRef.current) && !menuRef.current.contains(event.target)) {
        setVisible(false);
      }
    }, "handleTabOutside");
    document.addEventListener("focusin", handleTabOutside);
    return () => {
      document.removeEventListener("focusin", handleTabOutside);
    };
  }, [menuRef]);
  const optionIds = options == null ? void 0 : options.map((option) => option.id);
  return /* @__PURE__ */ jsx154(
    SelectMenuContext.Provider,
    {
      value: {
        visible,
        setVisible,
        wrapperId,
        labelId,
        selectedId,
        menuRef,
        buttonRef,
        dropdownRef,
        hasFixedFooter,
        options: options || [],
        optionIds: optionIds || [],
        selectedValue,
        setSelectedValue,
        handleArrowNavigation,
        handleSubmit,
        handleMenuKeyDown
      },
      children: /* @__PURE__ */ jsx154("div", __spreadProps(__spreadValues({ ref: menuRef, css: styles20, id: wrapperId }, rest), { children }))
    }
  );
}
__name(SelectMenu, "SelectMenu");

// src/molecules/SelectMenu/SelectMenuDropdown.tsx
import { unstable_useId as unstable_useId3 } from "reakit";
import { useTheme as useTheme68, elevation as elevation6 } from "@instacart/ids-core";
import { jsx as jsx155 } from "@emotion/react/jsx-runtime";
var getStyles50 = /* @__PURE__ */ __name((theme, visible) => __spreadValues(__spreadValues({
  position: "absolute",
  top: 48,
  width: 282,
  display: visible ? "block" : "none",
  borderRadius: theme.radius.r12,
  listStyle: "none",
  margin: 0,
  background: theme.colors.systemGrayscale00
}, elevation6.low.depth), elevation6.low.shadow), "getStyles");
function SelectMenuDropdown(props) {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const { id } = unstable_useId3(props);
  const { visible, dropdownRef } = useSelectMenuContext();
  const theme = useTheme68();
  const styles25 = getStyles50(theme, visible);
  return /* @__PURE__ */ jsx155("div", __spreadProps(__spreadValues({ ref: dropdownRef, tabIndex: -1, id, css: styles25 }, rest), { children }));
}
__name(SelectMenuDropdown, "SelectMenuDropdown");

// src/molecules/SelectMenu/SelectMenuList.tsx
import { spacing as spacing47 } from "@instacart/ids-core";
import { jsx as jsx156 } from "@emotion/react/jsx-runtime";
var getStyles51 = /* @__PURE__ */ __name(() => ({
  listStyle: "none",
  padding: spacing47.s8,
  maxHeight: 300,
  overflow: "auto",
  margin: 0
}), "getStyles");
function SelectMenuList(props) {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const { hasFixedFooter } = useSelectMenuContext();
  const styles25 = getStyles51();
  const fixedFooter = hasFixedFooter ? { paddingBottom: 40 } : {};
  return /* @__PURE__ */ jsx156("ul", __spreadProps(__spreadValues({ css: [styles25, fixedFooter] }, rest), { children }));
}
__name(SelectMenuList, "SelectMenuList");

// src/molecules/SelectMenu/SelectMenuButton.tsx
import { useTheme as useTheme69, spacing as spacing48, ChevronDownIcon as ChevronDownIcon4, ChevronUpIcon as ChevronUpIcon2 } from "@instacart/ids-core";
import { jsx as jsx157, jsxs as jsxs22 } from "@emotion/react/jsx-runtime";
var SELECT_BUTTON_HEIGHT = 40;
var getStyles52 = /* @__PURE__ */ __name((theme, visible) => ({
  button: __spreadProps(__spreadValues({
    display: "flex",
    alignItems: "center",
    height: SELECT_BUTTON_HEIGHT,
    borderRadius: theme.radius.r8,
    padding: `${spacing48.s8}px ${spacing48.s12}px`,
    border: `1px solid ${theme.colors.systemGrayscale20}`,
    backgroundColor: visible ? theme.colors.systemGrayscale10 : theme.colors.systemGrayscale00,
    borderColor: theme.colors.systemGrayscale30,
    cursor: "pointer"
  }, theme.typography.bodyMedium1), {
    ":disabled": {
      backgroundColor: theme.colors.systemGrayscale10,
      border: "none",
      color: theme.colors.systemGrayscale30,
      cursor: "default",
      "& svg": {
        fill: theme.colors.systemGrayscale30
      }
    },
    ":hover": {
      backgroundColor: theme.colors.systemGrayscale10,
      borderColor: theme.colors.systemGrayscale30
    },
    "&:focus": {
      outline: 0
    },
    ":focus-visible:": {
      outline: 0
    },
    ":focus-visible::after": {
      display: "block",
      position: "absolute",
      content: '""',
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12,
      top: -4,
      bottom: -4,
      left: -4,
      right: -4
    }
  }),
  icon: {
    position: "relative",
    top: 3,
    paddingLeft: 10
  }
}), "getStyles");
function SelectMenuButton(props) {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const { visible, setVisible, buttonRef, selectedId, wrapperId, handleMenuKeyDown } = useSelectMenuContext();
  const theme = useTheme69();
  const styles25 = getStyles52(theme, visible);
  const Icon = visible ? ChevronUpIcon2 : ChevronDownIcon4;
  return /* @__PURE__ */ jsxs22(
    "button",
    __spreadProps(__spreadValues({
      ref: buttonRef,
      css: styles25.button,
      onClick: () => {
        setVisible(!visible);
      },
      onKeyDown: (event) => {
        handleMenuKeyDown(event);
      },
      "aria-controls": wrapperId,
      "aria-expanded": visible
    }, rest), {
      children: [
        /* @__PURE__ */ jsx157("span", { id: selectedId, children }),
        /* @__PURE__ */ jsx157("div", { css: styles25.icon, children: /* @__PURE__ */ jsx157(Icon, {}) })
      ]
    })
  );
}
__name(SelectMenuButton, "SelectMenuButton");

// src/molecules/SelectMenu/SelectMenuFooter.tsx
import { useTheme as useTheme70, spacing as spacing49, elevation as elevation7 } from "@instacart/ids-core";
import { jsx as jsx158 } from "@emotion/react/jsx-runtime";
var getStyles53 = /* @__PURE__ */ __name((theme, hasFixedFooter) => ({
  display: "flex",
  padding: `${spacing49.s8}px ${spacing49.s12}px`,
  paddingTop: spacing49.s12,
  backgroundColor: theme.colors.systemGrayscale00,
  boxShadow: hasFixedFooter ? elevation7.high.shadow.boxShadow : "none",
  borderBottomRightRadius: theme.radius.r12,
  borderBottomLeftRadius: theme.radius.r12,
  "& button": {
    minWidth: "unset"
  },
  "& button:first-of-type": {
    marginRight: spacing49.s8
  }
}), "getStyles");
function SelectMenuFooter(props) {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const { hasFixedFooter } = useSelectMenuContext();
  const theme = useTheme70();
  const styles25 = getStyles53(theme, hasFixedFooter);
  return /* @__PURE__ */ jsx158("div", __spreadProps(__spreadValues({ css: styles25 }, rest), { children }));
}
__name(SelectMenuFooter, "SelectMenuFooter");

// src/molecules/SelectMenu/SelectMenuFooterButton.tsx
import { useTheme as useTheme71, blendColors as blendColors6 } from "@instacart/ids-core";
import { jsxs as jsxs23 } from "@emotion/react/jsx-runtime";
var getStyles54 = /* @__PURE__ */ __name((theme, isApplyButton) => ({
  active: {
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryDark : theme.colors.systemGrayscale20
  },
  loading: {
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryDark : theme.colors.systemGrayscale20
  },
  button: {
    width: "50%",
    height: 40,
    backgroundColor: isApplyButton ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale10,
    color: isApplyButton ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale70
  },
  content: __spreadValues({}, theme.typography.bodyMedium1),
  disabled: {
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30
  },
  focusRing: {
    borderRadius: theme.radius.r8
  },
  hover: {
    backgroundColor: isApplyButton ? blendColors6(theme.colors.brandPrimaryRegular, theme.colors.brandPrimaryDark, 51) : blendColors6(theme.colors.systemGrayscale10, theme.colors.systemGrayscale20, 51)
  }
}), "getStyles");
function SelectMenuFooterButton(props) {
  const _a = props, { isApplyButton, children, onClick, closeOnClick = true } = _a, rest = __objRest(_a, ["isApplyButton", "children", "onClick", "closeOnClick"]);
  const { selectedValue, setVisible, handleSubmit, handleMenuKeyDown } = useSelectMenuContext();
  const theme = useTheme71();
  const styles25 = getStyles54(theme, isApplyButton);
  const selectedValueNumber = (selectedValue == null ? void 0 : selectedValue.length) ? ` (${1}) ` : "";
  const valueNumber = isApplyButton ? selectedValueNumber : "";
  const ButtonComponent = isApplyButton ? PrimaryButtonSmall : SecondaryButtonSmall;
  return /* @__PURE__ */ jsxs23(
    ButtonComponent,
    __spreadProps(__spreadValues({
      styles: styles25,
      onClick: () => {
        onClick && onClick();
        if (closeOnClick) {
          setVisible(false);
        }
      },
      onKeyDown: (e) => {
        if (onClick && e.key === "Enter")
          onClick();
        handleSubmit(e, closeOnClick);
        handleMenuKeyDown(e);
      }
    }, rest), {
      children: [
        children,
        valueNumber
      ]
    })
  );
}
__name(SelectMenuFooterButton, "SelectMenuFooterButton");

// src/molecules/CountrySelectTextInput/utils.ts
import {
  FlagUSIcon,
  FlagAUIcon,
  FlagBRIcon,
  FlagFRIcon,
  FlagUKIcon,
  FlagJPIcon,
  FlagCAIcon,
  FlagDEIcon
} from "@instacart/ids-core";
var flagIconForCountryIso = /* @__PURE__ */ __name((countryIsoString) => {
  switch (countryIsoString) {
    case "AU":
      return FlagAUIcon;
    case "BR":
      return FlagBRIcon;
    case "CA":
      return FlagCAIcon;
    case "DE":
      return FlagDEIcon;
    case "FR":
      return FlagFRIcon;
    case "JP":
      return FlagJPIcon;
    case "UK":
      return FlagUKIcon;
    case "US":
      return FlagUSIcon;
    default:
      return FlagUSIcon;
  }
}, "flagIconForCountryIso");

// src/molecules/Marker/MarkerBase.tsx
import { combineStyles as combineStyles45, spacing as spacing50, useTheme as useTheme72 } from "@instacart/ids-core";
import { jsx as jsx159 } from "@emotion/react/jsx-runtime";
var getStyles55 = /* @__PURE__ */ __name(({
  theme,
  color: colorKey
}) => ({
  containerStyles: __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
    display: "inline-block",
    padding: `3px ${spacing50.s8}px`,
    borderRadius: theme.radius.r4,
    border: `solid 1px ${colorKey ? theme.colors[colorKey] : theme.colors.systemGrayscale30}`,
    color: colorKey ? theme.colors[colorKey] : theme.colors.systemGrayscale50
  })
}), "getStyles");
function MarkerBase(props) {
  const { children, styles: styles25, color } = props;
  const theme = useTheme72();
  const { containerStyles: containerStyles3 } = combineStyles45(getStyles55({ theme, color }), styles25);
  return /* @__PURE__ */ jsx159("div", { css: containerStyles3, children });
}
__name(MarkerBase, "MarkerBase");

// src/molecules/Marker/Marker.tsx
import { jsx as jsx160 } from "@emotion/react/jsx-runtime";
function Marker(props) {
  return /* @__PURE__ */ jsx160(MarkerBase, __spreadProps(__spreadValues({}, props), { children: props.children }));
}
__name(Marker, "Marker");

// src/molecules/Marker/MarkerIconLeft.tsx
import { spacing as spacing51 } from "@instacart/ids-core";
import { jsx as jsx161, jsxs as jsxs24 } from "@emotion/react/jsx-runtime";
var iconStyles2 = {
  verticalAlign: "top",
  paddingRight: `${spacing51.s4}px`,
  marginTop: "2px"
};
function MarkerIconLeft(_a) {
  var _b = _a, { icon: Icon, children } = _b, rest = __objRest(_b, ["icon", "children"]);
  return /* @__PURE__ */ jsxs24(MarkerBase, __spreadProps(__spreadValues({}, rest), { children: [
    /* @__PURE__ */ jsx161(Icon, { color: rest.color || "systemGrayscale50", size: 14, css: iconStyles2 }),
    children
  ] }));
}
__name(MarkerIconLeft, "MarkerIconLeft");

// src/molecules/Marker/MarkerIconRight.tsx
import { spacing as spacing52 } from "@instacart/ids-core";
import { jsx as jsx162, jsxs as jsxs25 } from "@emotion/react/jsx-runtime";
var iconStyles3 = {
  verticalAlign: "top",
  paddingLeft: `${spacing52.s4}px`,
  marginTop: "2px"
};
function MarkerIconRight(_a) {
  var _b = _a, { icon: Icon, children } = _b, rest = __objRest(_b, ["icon", "children"]);
  return /* @__PURE__ */ jsxs25(MarkerBase, __spreadProps(__spreadValues({}, rest), { children: [
    children,
    /* @__PURE__ */ jsx162(Icon, { color: rest.color || "systemGrayscale50", size: 14, css: iconStyles3 })
  ] }));
}
__name(MarkerIconRight, "MarkerIconRight");

// src/molecules/Marker/MarkerChip.tsx
import { spacing as spacing53, useTheme as useTheme73 } from "@instacart/ids-core";
import { jsx as jsx163 } from "@emotion/react/jsx-runtime";
function MarkerChip(props) {
  const _a = props, { styles: propStyles } = _a, rest = __objRest(_a, ["styles"]);
  const theme = useTheme73();
  const styles25 = {
    containerStyles: __spreadProps(__spreadValues({}, propStyles), {
      background: theme.colors.systemGrayscale20,
      color: theme.colors.systemGrayscale70,
      borderRadius: theme.radius.r12,
      padding: `1px ${spacing53.s8}px`,
      border: "none"
    })
  };
  return /* @__PURE__ */ jsx163(MarkerBase, __spreadProps(__spreadValues({}, rest), { styles: styles25, children: props.children }));
}
__name(MarkerChip, "MarkerChip");

// src/molecules/MultiSelect/MultiSelectListOptionBase.tsx
import {
  useTheme as useTheme74,
  SelectionRow,
  SelectionRowLayoutLeft,
  SelectionRowCheckbox,
  SelectionRowLabel,
  SelectionRowTextPrimary,
  combineStyles as combineStyles46,
  spacing as spacing54
} from "@instacart/ids-core";
import { jsx as jsx164, jsxs as jsxs26 } from "@emotion/react/jsx-runtime";
var getStyles56 = /* @__PURE__ */ __name((theme, disabled) => ({
  container: __spreadProps(__spreadValues({
    padding: "0 11px"
  }, theme.typography.bodyMedium2), {
    ":hover": {
      backgroundColor: disabled ? "transparent" : theme.colors.systemGrayscale10,
      borderRadius: theme.radius.r8
    }
  }),
  checkbox: {
    padding: `${spacing54.s12}px 0`
  }
}), "getStyles");
function MultiSelectListOptionBase(props) {
  const { isSelected, id, value, name, onClick, onKeyDown, disabled, children } = props;
  const { handleMenuKeyDown } = useSelectMenuContext();
  const theme = useTheme74();
  const baseStyles17 = getStyles56(theme, disabled);
  const styles25 = combineStyles46(baseStyles17, props.styles);
  return /* @__PURE__ */ jsx164("li", { css: [styles25.container, { "> div": styles25.checkbox }], children: /* @__PURE__ */ jsx164(SelectionRow, { checked: isSelected, onClick, disabled, children: /* @__PURE__ */ jsxs26(SelectionRowLayoutLeft, { children: [
    /* @__PURE__ */ jsx164(
      SelectionRowCheckbox,
      {
        value,
        id,
        name,
        onKeyDown: (event) => {
          handleMenuKeyDown(event);
          onKeyDown(event);
        }
      }
    ),
    /* @__PURE__ */ jsx164(SelectionRowLabel, { htmlFor: id, children: /* @__PURE__ */ jsx164(SelectionRowTextPrimary, { children }) })
  ] }) }, id) });
}
__name(MultiSelectListOptionBase, "MultiSelectListOptionBase");

// src/molecules/MultiSelect/MultiSelectListOption.tsx
import { jsx as jsx165 } from "@emotion/react/jsx-runtime";
var getStyles57 = /* @__PURE__ */ __name(() => ({
  container: {},
  checkbox: {}
}), "getStyles");
function MultiSelectListOption(props) {
  const styles25 = getStyles57();
  return /* @__PURE__ */ jsx165(MultiSelectListOptionBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(MultiSelectListOption, "MultiSelectListOption");

// src/molecules/ServiceMessageA/index.ts
var ServiceMessageA_exports = {};
__export(ServiceMessageA_exports, {
  ServiceMessageA: () => ServiceMessageA3
});

// src/molecules/ServiceMessageA/Left.tsx
import { CompositionValidator as CompositionValidator20 } from "@instacart/ids-core";

// src/molecules/ServiceMessageA/leftRightValidations.ts
import {
  CompositionTooFewItemsError as CompositionTooFewItemsError7,
  CompositionTooManyItemsError as CompositionTooManyItemsError11,
  CompositionOrderError as CompositionOrderError8,
  CompositionInvalidChildCount as CompositionInvalidChildCount2,
  CompositionInvalidChildError
} from "@instacart/ids-core";
var requiredOneMessage = "one and only one";
var validateLeft3 = /* @__PURE__ */ __name((engine) => {
  const { findAllByKind, flatIndexOfByKind, getAll, compareItemByKind, getAllChildren } = engine;
  const all = getAll();
  const allChildren = getAllChildren();
  const numberOfTitles = findAllByKind(ServiceMessageInfoBase).length;
  const numberOfDescriptions = findAllByKind(ServiceMessageDescriptionBase).length;
  const titleIndex = flatIndexOfByKind(ServiceMessageInfoBase);
  const descriptionIndex = flatIndexOfByKind(ServiceMessageDescriptionBase);
  if (numberOfTitles === 0) {
    throw new CompositionTooFewItemsError7(ServiceMessageInfoBase, requiredOneMessage);
  }
  if (numberOfTitles > 1) {
    throw new CompositionTooManyItemsError11(ServiceMessageInfoBase, requiredOneMessage);
  }
  if (numberOfDescriptions > 1) {
    throw new CompositionTooManyItemsError11(ServiceMessageDescriptionBase, "up to one");
  }
  if (descriptionIndex > -1 && descriptionIndex < titleIndex) {
    throw new CompositionOrderError8(all[titleIndex], all[descriptionIndex]);
  }
  const maybeErrors = allChildren.map(
    (x) => !(compareItemByKind(x, ServiceMessageInfoBase) || compareItemByKind(x, ServiceMessageDescriptionBase))
  );
  if (maybeErrors.some(Boolean)) {
    throw new CompositionInvalidChildError(
      allChildren[maybeErrors.findIndex(Boolean)],
      "child must be either ServiceMessageInfo or ServiceMessageDescription"
    );
  }
}, "validateLeft");
var validateRight3 = /* @__PURE__ */ __name((engine) => {
  const { getAllChildren, compareItemByKind, getAll } = engine;
  const all = getAll();
  const numberOfChildren = getAllChildren().length;
  if (numberOfChildren > 1) {
    throw new CompositionInvalidChildCount2(numberOfChildren, 1);
  }
  if ([
    compareItemByKind(all[0], ServiceMessageCloseButton),
    compareItemByKind(all[0], ServiceMessageMoreButton)
  ].every((x) => !x)) {
    throw new CompositionInvalidChildError(
      all[0],
      "child must be either ServiceMessageCloseButton or ServiceMessageMoreButton"
    );
  }
}, "validateRight");

// src/molecules/ServiceMessageA/Left.tsx
import { jsx as jsx166 } from "@emotion/react/jsx-runtime";
var styles21 = {
  flexGrow: 1
};
var validator20 = new CompositionValidator20([validateLeft3]);
function Left3(props) {
  const { children } = props;
  validator20.validate(children);
  return /* @__PURE__ */ jsx166("div", { style: styles21, children });
}
__name(Left3, "Left");

// src/molecules/ServiceMessageA/Right.tsx
import { CompositionValidator as CompositionValidator21, spacing as spacing55 } from "@instacart/ids-core";
import { jsx as jsx167 } from "@emotion/react/jsx-runtime";
var styles22 = {
  marginTop: 2,
  marginLeft: `${spacing55.s8}px`,
  alignSelf: "baseline"
};
var validator21 = new CompositionValidator21([validateRight3]);
function Right3(props) {
  const { children } = props;
  validator21.validate(children);
  return /* @__PURE__ */ jsx167("div", { css: styles22, children });
}
__name(Right3, "Right");

// src/molecules/ServiceMessageA/ServiceMessageA.tsx
import { forwardRef as forwardRef71 } from "react";
import { CompositionValidator as CompositionValidator22 } from "@instacart/ids-core";

// src/molecules/ServiceMessageA/ServiceMessageAValidations.ts
import { createElement as createElement2 } from "react";
import { CompositionTooFewItemsError as CompositionTooFewItemsError8, CompositionTooManyItemsError as CompositionTooManyItemsError12 } from "@instacart/ids-core";
var aLeftElement2 = createElement2(Left3);
var aRightElement2 = createElement2(Right3);
var LeftType2 = aLeftElement2.type;
var RightType2 = aRightElement2.type;
var validateItem6 = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, compareItemByKind } = engine;
  const all = getAll();
  const foundLeft = all.filter((item) => compareItemByKind(item, LeftType2));
  try {
    expect(foundLeft).toHaveLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundLeft.length < 1) {
      throw new CompositionTooFewItemsError8(aLeftElement2, addtl);
    } else {
      throw new CompositionTooManyItemsError12(aLeftElement2, addtl);
    }
  }
  const foundRight = all.filter((item) => compareItemByKind(item, RightType2));
  try {
    expect(foundRight).toHaveMaxLength(1);
  } catch (e) {
    const addtl = "one and only one";
    if (foundRight.length > 1) {
      throw new CompositionTooManyItemsError12(aRightElement2, addtl);
    }
  }
}, "validateItem");

// src/molecules/ServiceMessageA/ServiceMessageA.tsx
import { jsx as jsx168 } from "@emotion/react/jsx-runtime";
var validator22 = new CompositionValidator22([validateItem6]);
var ServiceMessageA = forwardRef71(
  /* @__PURE__ */ __name(function ServiceMessageA2(props, ref) {
    const { children, styles: styles25 } = props;
    validator22.validate(children);
    return /* @__PURE__ */ jsx168(
      ServiceMessageBase,
      __spreadProps(__spreadValues({
        ref
      }, props), {
        styles: {
          container: [styles25 == null ? void 0 : styles25.container, { minHeight: 40 }]
        }
      })
    );
  }, "ServiceMessageA")
);
ServiceMessageA.displayName = "ServiceMessageA";

// src/molecules/ServiceMessageA/index.ts
var ServiceMessageA3 = {
  Left: Left3,
  Right: Right3,
  ServiceMessage: ServiceMessageA,
  ServiceMessageCloseButton,
  ServiceMessageInfo: ServiceMessageInfoBase,
  ServiceMessageMoreButton,
  ServiceMessageDescription: ServiceMessageDescriptionBase
};

// src/molecules/Tooltip/Tooltip.tsx
import {
  TooltipBase,
  forwardRefWithAs,
  spacing as spacing56,
  useTheme as useTheme75
} from "@instacart/ids-core";
import { jsx as jsx169 } from "@emotion/react/jsx-runtime";
var getStyles58 = /* @__PURE__ */ __name((theme) => ({
  container: __spreadProps(__spreadValues({
    backgroundColor: theme.colors.systemGrayscale80,
    color: theme.colors.systemGrayscale00,
    padding: spacing56.s12,
    borderRadius: theme.radius.r8
  }, theme.typography.bodyMedium1), {
    maxWidth: 256
  }),
  arrow: {
    fill: theme.colors.systemGrayscale80
  }
}), "getStyles");
var Tooltip = forwardRefWithAs(/* @__PURE__ */ __name(function Tooltip2(props, ref) {
  const theme = useTheme75();
  const styles25 = getStyles58(theme);
  return /* @__PURE__ */ jsx169(TooltipBase, __spreadProps(__spreadValues({ styles: styles25 }, props), { ref }));
}, "Tooltip"));
Tooltip.displayName = "Tooltip";

// src/molecules/CriticalServiceMessageA/CriticalServiceMessageA.tsx
import { forwardRef as forwardRef72 } from "react";
import { useTheme as useTheme76, CompositionValidator as CompositionValidator23 } from "@instacart/ids-core";
import { jsx as jsx170 } from "@emotion/react/jsx-runtime";
var validator23 = new CompositionValidator23([validateItem6]);
var CriticalServiceMessageA = forwardRef72(
  /* @__PURE__ */ __name(function CriticalServiceMessage(props, ref) {
    var _a;
    const theme = useTheme76();
    validator23.validate(props.children);
    return /* @__PURE__ */ jsx170(
      ServiceMessageBase,
      __spreadProps(__spreadValues({}, props), {
        styles: {
          container: [
            (_a = props.styles) == null ? void 0 : _a.container,
            {
              backgroundColor: theme.colors.systemDetrimentalLight,
              minHeight: 40,
              "div, p": {
                color: theme.colors.systemDetrimentalDark
              },
              svg: {
                fill: theme.colors.systemDetrimentalDark
              }
            }
          ]
        },
        ref
      })
    );
  }, "CriticalServiceMessage")
);
CriticalServiceMessageA.displayName = "CriticalServiceMessageA";

// src/molecules/CriticalServiceMessageA/index.tsx
var CriticalServiceMessageA2 = {
  Left: Left3,
  Right: Right3,
  CriticalServiceMessage: CriticalServiceMessageA,
  ServiceMessageCloseButton,
  ServiceMessageInfo: ServiceMessageInfoBase,
  ServiceMessageMoreButton,
  ServiceMessageDescription: ServiceMessageDescriptionBase
};

// src/organisms/LoadingLockupLayouts/LoadingLockupIconRowLayout.tsx
import { forwardRef as forwardRef75 } from "react";
import { LoadingLockupIconRow as LoadingLockupIconRow2 } from "@instacart/ids-core";

// src/organisms/LoadingLockupLayouts/internal/LoadingLockupBLayoutWrapper.tsx
import { forwardRef as forwardRef73 } from "react";
import { LoadingLockupLayout } from "@instacart/ids-core";

// src/organisms/LoadingLockupLayouts/internal/utils.ts
function generateDummyArrayForDefaultElements(numElements) {
  return [...Array(numElements)];
}
__name(generateDummyArrayForDefaultElements, "generateDummyArrayForDefaultElements");

// src/organisms/LoadingLockupLayouts/internal/LoadingLockupBLayoutWrapper.tsx
import { jsx as jsx171 } from "@emotion/react/jsx-runtime";
var DEFAULT_NUMBER_ELEMENTS = 12;
var LoadingLockupBLayoutWrapper = forwardRef73(/* @__PURE__ */ __name(function LoadingLockupBLayoutWrapper2(_a, ref) {
  var _b = _a, { elementQuantity = DEFAULT_NUMBER_ELEMENTS, layoutElement } = _b, rest = __objRest(_b, ["elementQuantity", "layoutElement"]);
  return /* @__PURE__ */ jsx171(LoadingLockupLayout, __spreadProps(__spreadValues({ ref, "data-testid": "loading-lockup-b-layout-wrapper" }, rest), { children: /* @__PURE__ */ jsx171(LockupB, __spreadProps(__spreadValues({}, rest), { children: generateDummyArrayForDefaultElements(elementQuantity).map((_val, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ jsx171("div", { children: layoutElement }, i)
  )) })) }));
}, "LoadingLockupBLayoutWrapper"));

// src/organisms/LoadingLockupLayouts/internal/LoadingLockupLayoutWrapper.tsx
import { forwardRef as forwardRef74 } from "react";
import {
  combineStyles as combineStyles47,
  LoadingLockupLayout as LoadingLockupLayout2
} from "@instacart/ids-core";
import { jsx as jsx172 } from "@emotion/react/jsx-runtime";
var DEFAULT_NUMBER_ELEMENTS2 = 4;
var getStyles59 = /* @__PURE__ */ __name(() => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }
}), "getStyles");
var LoadingLockupLayoutWrapper = forwardRef74(/* @__PURE__ */ __name(function LoadingLockupLayoutWrapper2(_a, ref) {
  var _b = _a, { elementQuantity = DEFAULT_NUMBER_ELEMENTS2, layoutElement, styles: styles25 } = _b, rest = __objRest(_b, ["elementQuantity", "layoutElement", "styles"]);
  const { container } = combineStyles47(getStyles59(), styles25);
  return /* @__PURE__ */ jsx172(LoadingLockupLayout2, __spreadProps(__spreadValues({ ref, "data-testid": "loading-lockup-layout-wrapper" }, rest), { children: /* @__PURE__ */ jsx172("div", { css: container, children: generateDummyArrayForDefaultElements(elementQuantity).map((_val, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ jsx172("div", { children: layoutElement }, i)
  )) }) }));
}, "LoadingLockupLayoutWrapper"));

// src/organisms/LoadingLockupLayouts/LoadingLockupIconRowLayout.tsx
import { jsx as jsx173 } from "@emotion/react/jsx-runtime";
var LoadingLockupIconRowLayout = forwardRef75(/* @__PURE__ */ __name(function LoadingLockupIconRowLayout2(props, ref) {
  return /* @__PURE__ */ jsx173(LoadingLockupLayoutWrapper, __spreadValues({ ref, layoutElement: /* @__PURE__ */ jsx173(LoadingLockupIconRow2, {}) }, props));
}, "LoadingLockupIconRowLayout"));

// src/organisms/LoadingLockupLayouts/LoadingLockupImageRowLayout.tsx
import { forwardRef as forwardRef76 } from "react";
import { LoadingLockupImageRow as LoadingLockupImageRow2 } from "@instacart/ids-core";
import { jsx as jsx174 } from "@emotion/react/jsx-runtime";
var LoadingLockupImageRowLayout = forwardRef76(/* @__PURE__ */ __name(function LoadingLockupImageRowLayout2(props, ref) {
  return /* @__PURE__ */ jsx174(LoadingLockupLayoutWrapper, __spreadValues({ ref, layoutElement: /* @__PURE__ */ jsx174(LoadingLockupImageRow2, {}) }, props));
}, "LoadingLockupImageRowLayout"));

// src/organisms/LoadingLockupLayouts/LoadingLockupItemGridLayout.tsx
import { forwardRef as forwardRef77 } from "react";
import { LoadingLockupGridItem as LoadingLockupGridItem3 } from "@instacart/ids-core";
import { jsx as jsx175 } from "@emotion/react/jsx-runtime";
var LoadingLockupItemGridLayout = forwardRef77(/* @__PURE__ */ __name(function LoadingLockupItemGridLayout2(props, ref) {
  return /* @__PURE__ */ jsx175(LoadingLockupBLayoutWrapper, __spreadValues({ ref, layoutElement: /* @__PURE__ */ jsx175(LoadingLockupGridItem3, {}) }, props));
}, "LoadingLockupItemGridLayout"));

// src/organisms/LoadingLockupLayouts/LoadingLockupItemListLayout.tsx
import { forwardRef as forwardRef78 } from "react";
import { LoadingLockupListItem as LoadingLockupListItem2 } from "@instacart/ids-core";
import { jsx as jsx176 } from "@emotion/react/jsx-runtime";
var LoadingLockupItemListLayout = forwardRef78(/* @__PURE__ */ __name(function LoadingLockupItemListLayout2(props, ref) {
  return /* @__PURE__ */ jsx176(LoadingLockupLayoutWrapper, __spreadValues({ ref, layoutElement: /* @__PURE__ */ jsx176(LoadingLockupListItem2, {}) }, props));
}, "LoadingLockupItemListLayout"));

// src/organisms/LoadingLockupLayouts/LoadingLockupTextRowLayout.tsx
import { forwardRef as forwardRef79 } from "react";
import { LoadingLockupTextRow as LoadingLockupTextRow2 } from "@instacart/ids-core";
import { jsx as jsx177 } from "@emotion/react/jsx-runtime";
var LoadingLockupTextRowLayout = forwardRef79(/* @__PURE__ */ __name(function LoadingLockupTextRowLayout2(props, ref) {
  return /* @__PURE__ */ jsx177(LoadingLockupLayoutWrapper, __spreadValues({ ref, layoutElement: /* @__PURE__ */ jsx177(LoadingLockupTextRow2, {}) }, props));
}, "LoadingLockupTextRowLayout"));

// src/organisms/Modal/ModalFixedSize.tsx
import { forwardRef as forwardRef81 } from "react";
import { responsive as responsive20, CompositionValidator as CompositionValidator24 } from "@instacart/ids-core";

// src/organisms/Modal/ModalBase/ModalBase.tsx
import {
  forwardRef as forwardRef80,
  useState as useState6,
  Fragment as Fragment3,
  useEffect as useEffect5
} from "react";
import {
  Dialog,
  useDialogState,
  useDialogDisclosure
} from "reakit";
import {
  elevation as elevation8,
  Backdrop,
  useInitialFocusElem,
  combineStyles as combineStyles48,
  POSITION_X_Y_CENTER,
  useTheme as useTheme77,
  responsive as responsive19,
  useRenderChildrenStatus
} from "@instacart/ids-core";

// src/organisms/Modal/ModalContext/ModalContext.tsx
import { createContext as createContext4, useContext as useContext7 } from "react";
var ModalContext = createContext4({});
var useModalContext = /* @__PURE__ */ __name(() => useContext7(ModalContext), "useModalContext");

// src/organisms/Modal/ModalBase/sharedStyles.ts
import { responsive as responsive18, spacing as spacing57 } from "@instacart/ids-core";
var MODAL_WRAPPER_STYLES = {
  display: "flex",
  flexDirection: "column",
  [responsive18.up("r")]: {
    maxHeight: `calc(100vh - ${spacing57.s48 * 2}px)`
  }
};

// src/organisms/Modal/ModalBase/ModalBase.tsx
import { jsx as jsx178 } from "@emotion/react/jsx-runtime";
var getStyles60 = /* @__PURE__ */ __name((theme) => ({
  modal: __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, MODAL_WRAPPER_STYLES), {
    boxSizing: "border-box",
    borderRadius: theme.radius.r12,
    backgroundColor: theme.colors.systemGrayscale00,
    position: "fixed",
    width: "100%",
    [responsive19.down("c")]: {
      marginTop: 0,
      marginBottom: 0,
      borderRadius: 0,
      paddingTop: 0,
      height: "100%"
    }
  }), POSITION_X_Y_CENTER), elevation8.high.shadow), {
    "&:focus, &:focus-visible": {
      outline: "none"
    },
    "&.focus-visible": {
      outline: `1px solid ${theme.colors.systemGrayscale80}`
    }
  })
}), "getStyles");
var useModalState = /* @__PURE__ */ __name((initialState) => {
  return useDialogState(__spreadProps(__spreadValues({}, initialState), { modal: true }));
}, "useModalState");
var useModalDisclosure = /* @__PURE__ */ __name((...props) => {
  const final = useDialogDisclosure(...props);
  delete final["aria-controls"];
  delete final["aria-expanded"];
  return final;
}, "useModalDisclosure");
var ModalBase = forwardRef80(function({
  backdropStyles,
  children,
  styles: styles25,
  initialFocusElem,
  finalFocusElem,
  modal,
  hideOnClickOutside,
  hideOnEsc,
  "aria-label": ariaLabel,
  onlyRenderWhenVisible,
  unmountChildrenDelay,
  onBlur,
  isMounted
}, ref) {
  const [mounted, setMounted] = useState6(Boolean(isMounted));
  const childrenVisible = useRenderChildrenStatus({
    modalVisible: modal.visible,
    onlyRenderWhenVisible,
    delay: unmountChildrenDelay
  });
  useEffect5(() => {
    setMounted(true);
  }, []);
  const theme = useTheme77();
  const css = combineStyles48(getStyles60(theme), styles25);
  const showChildren = onlyRenderWhenVisible ? childrenVisible : true;
  useInitialFocusElem({ initialFocusElem, checkFocus: modal.visible });
  return /* @__PURE__ */ jsx178(Fragment3, { children: mounted && /* @__PURE__ */ jsx178(ModalContext.Provider, { value: modal, children: /* @__PURE__ */ jsx178(Backdrop, __spreadProps(__spreadValues({}, modal), { styles: backdropStyles, children: /* @__PURE__ */ jsx178(
    Dialog,
    __spreadProps(__spreadValues({
      ref,
      css: css.modal,
      hideOnClickOutside,
      hideOnEsc,
      unstable_finalFocusRef: finalFocusElem,
      preventBodyScroll: false,
      onBlur,
      "aria-label": ariaLabel
    }, modal), {
      children: showChildren ? children : null
    })
  ) })) }) });
});

// src/organisms/Modal/ModalBase/validations.ts
import {
  pointerToString,
  CompositionEngineItemType as CompositionEngineItemType2
} from "@instacart/ids-core";
var validateModalBase = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren } = engine;
  const elementNamesOrdered = getAllChildren().filter(
    (c) => c.type === CompositionEngineItemType2.Element
  ).map((c) => {
    return { name: pointerToString(c.kind) };
  });
  expect(elementNamesOrdered).toBeIn([
    [{ name: "ModalHeader" }, { name: "ModalContent" }, { name: "ModalFooter" }],
    [{ name: "ModalHeader" }, { name: "ModalContent" }, { name: "ModalFooterNoShadow" }],
    [{ name: "ModalContent" }, { name: "ModalFooter" }],
    [{ name: "ModalContent" }, { name: "ModalFooterNoShadow" }],
    [{ name: "ModalHeader" }, { name: "ModalContent" }],
    [{ name: "ModalContent" }]
  ]);
}, "validateModalBase");

// src/organisms/Modal/ModalFixedSize.tsx
import { jsx as jsx179 } from "@emotion/react/jsx-runtime";
var ModalFixedSize = forwardRef81(
  /* @__PURE__ */ __name(function ModalFixedSize2(props, ref) {
    const { children } = props;
    const { validate } = new CompositionValidator24([validateModalBase]);
    validate(children);
    const styles25 = {
      modal: {
        [responsive20.up("r")]: {
          height: "804px",
          width: "552px"
        }
      }
    };
    return /* @__PURE__ */ jsx179(ModalBase, __spreadProps(__spreadValues({}, props), { ref, styles: styles25, children }));
  }, "ModalFixedSize")
);

// src/organisms/Modal/ModalAutosize.tsx
import { forwardRef as forwardRef82 } from "react";
import { responsive as responsive21, CompositionValidator as CompositionValidator25 } from "@instacart/ids-core";
import { jsx as jsx180 } from "@emotion/react/jsx-runtime";
var ModalAutosize = forwardRef82(
  /* @__PURE__ */ __name(function ModalAutosize2(props, ref) {
    const { children } = props;
    const { validate } = new CompositionValidator25([validateModalBase]);
    validate(children);
    const styles25 = {
      modal: {
        [responsive21.up("r")]: {
          width: "552px"
        }
      }
    };
    return /* @__PURE__ */ jsx180(ModalBase, __spreadProps(__spreadValues({}, props), { ref, styles: styles25, children }));
  }, "ModalAutosize")
);

// src/organisms/Modal/ModalHeaderBase/ModalHeaderBase.tsx
import { CloseIcon as CloseIcon2, spacing as spacing58, combineStyles as combineStyles49 } from "@instacart/ids-core";
import { jsx as jsx181, jsxs as jsxs27 } from "@emotion/react/jsx-runtime";
var getStyles61 = /* @__PURE__ */ __name(() => ({
  header: {
    display: "grid",
    gridTemplateColumns: "1fr 8fr 1fr",
    height: `${spacing58.s40 + spacing58.s4}px`,
    marginTop: spacing58.s16
  },
  closeContainer: {
    paddingLeft: spacing58.s16
  },
  closeIcon: {
    marginTop: `${spacing58.s4 / 2}px`
  }
}), "getStyles");
function ModalHeaderBase(_a) {
  var _b = _a, {
    children,
    hide,
    accessibleLabels,
    styles: styles25
  } = _b, rest = __objRest(_b, [
    "children",
    "hide",
    "accessibleLabels",
    "styles"
  ]);
  const { header, closeContainer, closeIcon } = combineStyles49(getStyles61(), styles25);
  return /* @__PURE__ */ jsxs27("div", { css: header, children: [
    /* @__PURE__ */ jsx181("div", { css: closeContainer, children: /* @__PURE__ */ jsx181(
      IconButton,
      __spreadProps(__spreadValues({}, rest), {
        type: "button",
        css: closeIcon,
        onClick: (e) => {
          rest.onClick && rest.onClick(e);
          hide();
        },
        icon: ModalHeaderButton,
        accessibleLabel: accessibleLabels.close
      })
    ) }),
    children
  ] });
}
__name(ModalHeaderBase, "ModalHeaderBase");
function ModalHeaderButton() {
  return /* @__PURE__ */ jsx181(CloseIcon2, { size: spacing58.s24 });
}
__name(ModalHeaderButton, "ModalHeaderButton");

// src/organisms/Modal/ModalHeader/ModalHeader.tsx
import { jsx as jsx182 } from "@emotion/react/jsx-runtime";
function ModalHeader(props) {
  return /* @__PURE__ */ jsx182(ModalHeaderBase, __spreadValues({}, props));
}
__name(ModalHeader, "ModalHeader");

// src/organisms/Modal/ModalTitleBase/ModalTitleBase.tsx
import { useTheme as useTheme78, combineStyles as combineStyles50 } from "@instacart/ids-core";
import { jsx as jsx183 } from "@emotion/react/jsx-runtime";
var getStyles62 = /* @__PURE__ */ __name((theme) => ({
  title: __spreadValues({
    padding: "0",
    margin: "0",
    placeSelf: "center"
  }, theme.typography.subtitle)
}), "getStyles");
function ModalTitleBase({ children, styles: styles25 }) {
  const theme = useTheme78();
  const { title } = combineStyles50(getStyles62(theme), styles25);
  return /* @__PURE__ */ jsx183("h1", { css: title, children });
}
__name(ModalTitleBase, "ModalTitleBase");

// src/organisms/Modal/ModalTitle/ModalTitle.tsx
import { jsx as jsx184 } from "@emotion/react/jsx-runtime";
function ModalTitle(props) {
  return /* @__PURE__ */ jsx184(ModalTitleBase, __spreadValues({}, props));
}
__name(ModalTitle, "ModalTitle");

// src/organisms/Modal/ModalContentBase/ModalContentBase.tsx
import {
  useEffect as useEffect6,
  useRef as useRef6,
  forwardRef as forwardRef83,
  useCallback as useCallback4
} from "react";
import { combineStyles as combineStyles51, spacing as spacing59, bodyScrollLock } from "@instacart/ids-core";
import { jsx as jsx185 } from "@emotion/react/jsx-runtime";
var getStyles63 = /* @__PURE__ */ __name(() => ({
  content: {
    flex: "1",
    overflowY: "auto",
    paddingLeft: `${spacing59.s16}px`,
    paddingRight: `${spacing59.s16}px`,
    paddingBottom: `${spacing59.s32}px`
  }
}), "getStyles");
var ModalContentBase = forwardRef83(
  /* @__PURE__ */ __name(function ModalContentBase2({ children, styles: styles25 }, forwardedRef) {
    const { content } = combineStyles51(getStyles63(), styles25);
    const ref = useRef6(null);
    const modal = useModalContext();
    useEffect6(() => {
      const scrollEl = ref.current;
      if (modal.visible && scrollEl) {
        bodyScrollLock.disableBodyScroll(scrollEl, {
          reserveScrollBarGap: true
        });
      }
      return () => {
        if (!scrollEl)
          return;
        bodyScrollLock.enableBodyScroll(scrollEl);
      };
    }, [modal.visible]);
    const combinedRef = useCallback4(
      (node) => {
        if (forwardedRef) {
          if (typeof forwardedRef === "function") {
            forwardedRef(node);
          } else {
            forwardedRef.current = node;
          }
        }
        ref.current = node;
      },
      [forwardedRef]
    );
    return /* @__PURE__ */ jsx185("div", { ref: combinedRef, css: content, children });
  }, "ModalContentBase")
);

// src/organisms/Modal/ModalContent/ModalContent.tsx
import { forwardRef as forwardRef84 } from "react";
import { jsx as jsx186 } from "@emotion/react/jsx-runtime";
var ModalContent = forwardRef84(
  /* @__PURE__ */ __name(function ModalContent2(props, ref) {
    return /* @__PURE__ */ jsx186(ModalContentBase, __spreadProps(__spreadValues({}, props), { ref }));
  }, "ModalContent")
);

// src/organisms/Modal/ModalFooterBase/ModalFooterBase.tsx
import { spacing as spacing60, elevation as elevation9, combineStyles as combineStyles52 } from "@instacart/ids-core";
import { jsx as jsx187 } from "@emotion/react/jsx-runtime";
var getStyles64 = /* @__PURE__ */ __name(() => ({
  footer: __spreadValues(__spreadValues({
    paddingLeft: `${spacing60.s16}px`,
    paddingRight: `${spacing60.s16}px`,
    paddingTop: `${spacing60.s12}px`,
    paddingBottom: `${spacing60.s12}px`
  }, elevation9.high.shadow), elevation9.high.depth)
}), "getStyles");
function ModalFooterBase(_a) {
  var _b = _a, {
    children,
    styles: styles25
  } = _b, rest = __objRest(_b, [
    "children",
    "styles"
  ]);
  const { footer } = combineStyles52(getStyles64(), styles25);
  return /* @__PURE__ */ jsx187("div", __spreadProps(__spreadValues({ css: footer }, rest), { children }));
}
__name(ModalFooterBase, "ModalFooterBase");

// src/organisms/Modal/ModalFooter/ModalFooter.tsx
import { jsx as jsx188 } from "@emotion/react/jsx-runtime";
function ModalFooter(props) {
  return /* @__PURE__ */ jsx188(ModalFooterBase, __spreadValues({}, props));
}
__name(ModalFooter, "ModalFooter");

// src/organisms/Modal/ModalFooterNoShadow/ModalFooterNoShadow.tsx
import { elevation as elevation10 } from "@instacart/ids-core";
import { jsx as jsx189 } from "@emotion/react/jsx-runtime";
var getStyles65 = /* @__PURE__ */ __name(() => ({
  footer: __spreadValues(__spreadValues({}, elevation10.primary.depth), elevation10.primary.shadow)
}), "getStyles");
function ModalFooterNoShadow(props) {
  const styles25 = getStyles65();
  return /* @__PURE__ */ jsx189(ModalFooterBase, __spreadProps(__spreadValues({}, props), { styles: styles25 }));
}
__name(ModalFooterNoShadow, "ModalFooterNoShadow");

// src/organisms/Modal/ModalInnerWrapper.tsx
import { jsx as jsx190 } from "@emotion/react/jsx-runtime";
var DEFAULT_ELEMENT = "div";
function ModalInnerWrapper(_a) {
  var _b = _a, {
    as,
    children
  } = _b, rest = __objRest(_b, [
    "as",
    "children"
  ]);
  const Element2 = as || DEFAULT_ELEMENT;
  return /* @__PURE__ */ jsx190(Element2, __spreadProps(__spreadValues({ css: [MODAL_WRAPPER_STYLES, { height: "100%" }] }, rest), { children }));
}
__name(ModalInnerWrapper, "ModalInnerWrapper");

// src/organisms/PromotionModal/PromotionModal.tsx
import { forwardRef as forwardRef85 } from "react";
import { responsive as responsive22 } from "@instacart/ids-core";
import { jsx as jsx191 } from "@emotion/react/jsx-runtime";
var PromotionModal = forwardRef85(
  /* @__PURE__ */ __name(function PromotionModal2(props, ref) {
    const { children } = props;
    const styles25 = {
      modal: {
        [responsive22.up("r")]: {
          width: "343px"
        }
      }
    };
    return /* @__PURE__ */ jsx191(ModalBase, __spreadProps(__spreadValues({}, props), { ref, styles: styles25, children }));
  }, "PromotionModal")
);

// src/organisms/PromotionModal/PromotionModalImage/PromotionModalImage.tsx
import { spacing as spacing61 } from "@instacart/ids-core";
import { jsx as jsx192 } from "@emotion/react/jsx-runtime";
var getStyles66 = /* @__PURE__ */ __name(() => ({
  image: {
    height: "175px",
    width: "311px",
    margin: `${spacing61.s16}px`,
    borderRadius: `${spacing61.s12}px`
  }
}), "getStyles");
function PromotionModalImage({ src, alt }) {
  const styles25 = getStyles66();
  return /* @__PURE__ */ jsx192("img", { src, alt, css: styles25.image });
}
__name(PromotionModalImage, "PromotionModalImage");

// src/organisms/PromotionModal/PromotionModalBody/PromotionModalBody.tsx
import { spacing as spacing62 } from "@instacart/ids-core";
import { jsx as jsx193 } from "@emotion/react/jsx-runtime";
function PromotionModalBody(props) {
  const styles25 = {
    content: {
      paddingBottom: spacing62.s24
    }
  };
  return /* @__PURE__ */ jsx193(ModalContentBase, __spreadValues({ styles: styles25 }, props));
}
__name(PromotionModalBody, "PromotionModalBody");

// src/organisms/PromotionModal/PromotionModalSubtitle/PromotionModalSubtitle.tsx
import { useTheme as useTheme79 } from "@instacart/ids-core";
import { jsx as jsx194 } from "@emotion/react/jsx-runtime";
var getStyles67 = /* @__PURE__ */ __name((theme) => __spreadProps(__spreadValues({}, theme.typography.bodySmall1), {
  color: theme.colors.brandPromotionalRegular,
  margin: 0
}), "getStyles");
function PromotionModalSubtitle({ children }) {
  const theme = useTheme79();
  const styles25 = getStyles67(theme);
  return /* @__PURE__ */ jsx194("p", { css: styles25, children });
}
__name(PromotionModalSubtitle, "PromotionModalSubtitle");

// src/organisms/PromotionModal/PromotionModalTitle/PromotionModalTitle.tsx
import { spacing as spacing63, useTheme as useTheme80 } from "@instacart/ids-core";
import { jsx as jsx195 } from "@emotion/react/jsx-runtime";
var getStyles68 = /* @__PURE__ */ __name((theme) => __spreadProps(__spreadValues({}, theme.typography.titleMedium), {
  margin: `0 0 ${spacing63.s4}px 0`
}), "getStyles");
function PromotionModalTitle({ children }) {
  const theme = useTheme80();
  const styles25 = getStyles68(theme);
  return /* @__PURE__ */ jsx195("p", { css: styles25, children });
}
__name(PromotionModalTitle, "PromotionModalTitle");

// src/organisms/PromotionModal/PromotionModalDescription/PromotionModalDescription.tsx
import { useTheme as useTheme81 } from "@instacart/ids-core";
import { jsx as jsx196 } from "@emotion/react/jsx-runtime";
var getStyles69 = /* @__PURE__ */ __name((theme) => __spreadProps(__spreadValues({}, theme.typography.bodyLarge2), {
  margin: 0
}), "getStyles");
function PromotionModalDescription({ children }) {
  const theme = useTheme81();
  const styles25 = getStyles69(theme);
  return /* @__PURE__ */ jsx196("p", { css: styles25, children });
}
__name(PromotionModalDescription, "PromotionModalDescription");

// src/organisms/PromotionModal/PromotionModalButtons/PromotionModalButtons.tsx
import { useTheme as useTheme82, spacing as spacing64 } from "@instacart/ids-core";
import { jsx as jsx197 } from "@emotion/react/jsx-runtime";
var getStyles70 = /* @__PURE__ */ __name((theme) => ({
  footer: {
    boxShadow: "none",
    borderBottomLeftRadius: theme.radius.r12,
    borderbottomRightRadius: theme.radius.r12,
    " > button:first-of-type": {
      marginBottom: spacing64.s12
    }
  }
}), "getStyles");
function PromotionModalButtons(props) {
  const theme = useTheme82();
  const styles25 = getStyles70(theme);
  return /* @__PURE__ */ jsx197(ModalFooterBase, __spreadValues({ styles: styles25 }, props));
}
__name(PromotionModalButtons, "PromotionModalButtons");

// src/organisms/TileC/TileC.tsx
import { forwardRef as forwardRef86 } from "react";
import { spacing as spacing65 } from "@instacart/ids-core";
import { jsx as jsx198 } from "@emotion/react/jsx-runtime";
var TileC = forwardRef86(/* @__PURE__ */ __name(function TileC2({ children }, ref) {
  const styles25 = {
    container: {
      padding: spacing65.s8
    }
  };
  return /* @__PURE__ */ jsx198(TileBase, { ref, styles: styles25, "data-testid": "tile-base", children });
}, "TileC"));

// src/organisms/TileC/Left.tsx
import { spacing as spacing66 } from "@instacart/ids-core";
import { jsx as jsx199 } from "@emotion/react/jsx-runtime";
var styles23 = {
  marginRight: spacing66.s12
};
function Left4(props) {
  const { children } = props;
  return /* @__PURE__ */ jsx199("div", { css: styles23, children });
}
__name(Left4, "Left");

// src/organisms/TileC/Center.tsx
import { jsx as jsx200 } from "@emotion/react/jsx-runtime";
var styles24 = {
  display: "flex",
  alignSelf: "center",
  minWidth: 0
};
function Center(props) {
  const { children } = props;
  return /* @__PURE__ */ jsx200("div", { css: styles24, children });
}
__name(Center, "Center");

// src/organisms/StoreCard/StoreCard.tsx
import { forwardRef as forwardRef87 } from "react";
import { useTheme as useTheme83, elevation as elevation11 } from "@instacart/ids-core";
import { jsx as jsx201 } from "@emotion/react/jsx-runtime";
var getStyles71 = /* @__PURE__ */ __name((theme) => ({
  container: __spreadProps(__spreadValues({}, elevation11.low.shadow), {
    borderRadius: theme.radius.r12
  })
}), "getStyles");
var StoreCard = forwardRef87(/* @__PURE__ */ __name(function TileC3(_a, ref) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  const theme = useTheme83();
  const styles25 = getStyles71(theme);
  return /* @__PURE__ */ jsx201(StoreCardBase, __spreadProps(__spreadValues({ ref, styles: styles25 }, rest), { children }));
}, "TileC"));

// src/organisms/StoreCard/StoreCardAttributes.tsx
import { combineStyles as combineStyles53, useTheme as useTheme84, spacing as spacing67 } from "@instacart/ids-core";
import { jsx as jsx202 } from "@emotion/react/jsx-runtime";
var getStyles72 = /* @__PURE__ */ __name((theme) => ({
  anchor: __spreadProps(__spreadValues({
    display: "inline-block",
    padding: `0 ${spacing67.s4}px`,
    color: theme.colors.systemGrayscale50
  }, theme.typography.bodySmall1), {
    borderRadius: 4,
    border: `1px solid ${theme.colors.systemGrayscale20}`,
    marginRight: spacing67.s4
  })
}), "getStyles");
function StoreCardAttributes(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme84();
  const { anchor } = combineStyles53(getStyles72(theme), styles25);
  return /* @__PURE__ */ jsx202("span", __spreadProps(__spreadValues({ css: anchor }, rest), { children }));
}
__name(StoreCardAttributes, "StoreCardAttributes");

// src/organisms/StoreCard/StoreCardETA.tsx
import {
  combineStyles as combineStyles54,
  useTheme as useTheme85,
  SpeedIcon,
  spacing as spacing68,
  useIdsFeatureFlag as useIdsFeatureFlag11
} from "@instacart/ids-core";
import { jsx as jsx203, jsxs as jsxs28 } from "@emotion/react/jsx-runtime";
var getStyles73 = /* @__PURE__ */ __name((theme, grayscale) => ({
  icon: {
    paddingTop: 2,
    paddingRight: spacing68.s8
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandPrimaryRegular,
    marginBottom: spacing68.s8
  })
}), "getStyles");
function StoreCardETA(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme85();
  const grayscale = useIdsFeatureFlag11("grayscale") === "grayscale";
  const { icon, text } = combineStyles54(getStyles73(theme, grayscale), styles25);
  return /* @__PURE__ */ jsxs28("div", __spreadProps(__spreadValues({ css: text }, rest), { children: [
    /* @__PURE__ */ jsx203("span", { css: icon, children: /* @__PURE__ */ jsx203(SpeedIcon, { size: "12", color: grayscale ? "systemGrayscale80" : "brandPrimaryRegular" }) }),
    children
  ] }));
}
__name(StoreCardETA, "StoreCardETA");

// src/organisms/StoreCard/StoreCardTag.tsx
import { combineStyles as combineStyles55, useTheme as useTheme86, useIdsFeatureFlag as useIdsFeatureFlag12 } from "@instacart/ids-core";
import { jsx as jsx204 } from "@emotion/react/jsx-runtime";
var getStyles74 = /* @__PURE__ */ __name((theme, grayscale) => ({
  text: __spreadProps(__spreadValues({
    display: "block"
  }, theme.typography.bodySmall1), {
    color: grayscale ? theme.colors.systemGrayscale80 : theme.colors.brandHighlightRegular
  })
}), "getStyles");
function StoreCardTag(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme86();
  const grayscale = useIdsFeatureFlag12("grayscale") !== "control";
  const { text } = combineStyles55(getStyles74(theme, grayscale), styles25);
  return /* @__PURE__ */ jsx204("span", __spreadProps(__spreadValues({ css: text }, rest), { children }));
}
__name(StoreCardTag, "StoreCardTag");

// src/organisms/StoreCard/StoreCardImageList.tsx
import { useRef as useRef8, Children as Children6 } from "react";

// ../../node_modules/use-resize-observer/dist/bundle.esm.js
import { useRef as useRef7, useEffect as useEffect7, useCallback as useCallback5, useState as useState7, useMemo as useMemo6 } from "react";
function useResolvedElement(subscriber, refOrElement) {
  var lastReportRef = useRef7(null);
  var refOrElementRef = useRef7(null);
  refOrElementRef.current = refOrElement;
  var cbElementRef = useRef7(null);
  useEffect7(function() {
    evaluateSubscription();
  });
  var evaluateSubscription = useCallback5(function() {
    var cbElement = cbElementRef.current;
    var refOrElement2 = refOrElementRef.current;
    var element = cbElement ? cbElement : refOrElement2 ? refOrElement2 instanceof Element ? refOrElement2 : refOrElement2.current : null;
    if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) {
      return;
    }
    if (lastReportRef.current && lastReportRef.current.cleanup) {
      lastReportRef.current.cleanup();
    }
    lastReportRef.current = {
      element,
      subscriber,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: element ? subscriber(element) : void 0
    };
  }, [subscriber]);
  useEffect7(function() {
    return function() {
      if (lastReportRef.current && lastReportRef.current.cleanup) {
        lastReportRef.current.cleanup();
        lastReportRef.current = null;
      }
    };
  }, []);
  return useCallback5(function(element) {
    cbElementRef.current = element;
    evaluateSubscription();
  }, [evaluateSubscription]);
}
__name(useResolvedElement, "useResolvedElement");
function extractSize(entry, boxProp, sizeType) {
  if (!entry[boxProp]) {
    if (boxProp === "contentBoxSize") {
      return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
    }
    return void 0;
  }
  return entry[boxProp][0] ? entry[boxProp][0][sizeType] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    entry[boxProp][sizeType]
  );
}
__name(extractSize, "extractSize");
function useResizeObserver(opts) {
  if (opts === void 0) {
    opts = {};
  }
  var onResize = opts.onResize;
  var onResizeRef = useRef7(void 0);
  onResizeRef.current = onResize;
  var round = opts.round || Math.round;
  var resizeObserverRef = useRef7();
  var _useState = useState7({
    width: void 0,
    height: void 0
  }), size = _useState[0], setSize = _useState[1];
  var didUnmount = useRef7(false);
  useEffect7(function() {
    didUnmount.current = false;
    return function() {
      didUnmount.current = true;
    };
  }, []);
  var previous = useRef7({
    width: void 0,
    height: void 0
  });
  var refCallback = useResolvedElement(useCallback5(function(element) {
    if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) {
      resizeObserverRef.current = {
        box: opts.box,
        round,
        instance: new ResizeObserver(function(entries) {
          var entry = entries[0];
          var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
          var reportedWidth = extractSize(entry, boxProp, "inlineSize");
          var reportedHeight = extractSize(entry, boxProp, "blockSize");
          var newWidth = reportedWidth ? round(reportedWidth) : void 0;
          var newHeight = reportedHeight ? round(reportedHeight) : void 0;
          if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
            var newSize = {
              width: newWidth,
              height: newHeight
            };
            previous.current.width = newWidth;
            previous.current.height = newHeight;
            if (onResizeRef.current) {
              onResizeRef.current(newSize);
            } else {
              if (!didUnmount.current) {
                setSize(newSize);
              }
            }
          }
        })
      };
    }
    resizeObserverRef.current.instance.observe(element, {
      box: opts.box
    });
    return function() {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.instance.unobserve(element);
      }
    };
  }, [opts.box, round]), opts.ref);
  return useMemo6(function() {
    return {
      ref: refCallback,
      width: size.width,
      height: size.height
    };
  }, [refCallback, size.width, size.height]);
}
__name(useResizeObserver, "useResizeObserver");

// src/organisms/StoreCard/StoreCardImageList.tsx
import { AddIcon as AddIcon3, combineStyles as combineStyles56, useTheme as useTheme87 } from "@instacart/ids-core";
import { jsx as jsx205, jsxs as jsxs29 } from "@emotion/react/jsx-runtime";
var IMAGE_MARGIN = 12;
var getStyles75 = /* @__PURE__ */ __name(({ theme, imageSize }) => ({
  // Necessary for measurement on resize
  container: {
    overflow: "hidden"
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    minHeight: 36
  },
  listItem: {
    display: "inline-block",
    marginLeft: IMAGE_MARGIN,
    "&:first-of-type": {
      marginLeft: 0
    }
  },
  itemCount: __spreadProps(__spreadValues({
    borderRadius: theme.radius.r8,
    background: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale50
  }, theme.typography.bodyMedium1), {
    svg: {
      marginTop: 3,
      fill: theme.colors.systemGrayscale50
    },
    height: imageSize,
    width: imageSize,
    boxSizing: "border-box",
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  })
}), "getStyles");
function StoreCardImageList(_a) {
  var _b = _a, {
    children,
    imageSize,
    styles: propsStyles
  } = _b, rest = __objRest(_b, [
    "children",
    "imageSize",
    "styles"
  ]);
  const theme = useTheme87();
  const styles25 = combineStyles56(getStyles75({ theme, imageSize }), propsStyles);
  const childrenArray = Children6.toArray(children);
  const ref = useRef8(null);
  const { width } = useResizeObserver({ ref });
  const maxImages = width ? Math.floor((width + IMAGE_MARGIN) / (imageSize + IMAGE_MARGIN)) : childrenArray.length;
  return /* @__PURE__ */ jsx205("div", __spreadProps(__spreadValues({ ref, css: styles25.container }, rest), { children: /* @__PURE__ */ jsx205("ul", { css: styles25.list, children: childrenArray.map((child, i) => {
    const isWithinWidth = i < maxImages;
    if (!isWithinWidth)
      return null;
    const isNotLastImage = i !== childrenArray.length - 1;
    const isNextWithinWidth = i + 1 < maxImages && isNotLastImage;
    return /* @__PURE__ */ jsx205("li", { css: styles25.listItem, children: isWithinWidth && !isNextWithinWidth && isNotLastImage ? /* @__PURE__ */ jsxs29("div", { css: styles25.itemCount, role: "note", children: [
      /* @__PURE__ */ jsx205(AddIcon3, { size: 12 }),
      childrenArray.length - (maxImages - 1)
    ] }) : child }, String(`store-card-image-list-image-${i}`));
  }) }) }));
}
__name(StoreCardImageList, "StoreCardImageList");

// src/organisms/StoreCardCompact/StoreCardCompact.tsx
import { forwardRef as forwardRef88 } from "react";
import { useTheme as useTheme88, elevation as elevation12 } from "@instacart/ids-core";
import { jsx as jsx206 } from "@emotion/react/jsx-runtime";
var getStyles76 = /* @__PURE__ */ __name((theme) => ({
  container: __spreadProps(__spreadValues({}, elevation12.low.shadow), {
    borderRadius: theme.radius.r12
  })
}), "getStyles");
var StoreCardCompact = forwardRef88(
  /* @__PURE__ */ __name(function StoreCardCompact2({ children }, ref) {
    const theme = useTheme88();
    const styles25 = getStyles76(theme);
    return /* @__PURE__ */ jsx206(StoreCardBase, { ref, styles: styles25, children });
  }, "StoreCardCompact")
);

// src/organisms/StoreCardCompact/StoreCardCompactAnchor.tsx
import { forwardRef as forwardRef89 } from "react";
import { spacing as spacing69 } from "@instacart/ids-core";
import { jsx as jsx207 } from "@emotion/react/jsx-runtime";
var getStyles77 = /* @__PURE__ */ __name(() => ({
  anchor: {
    padding: spacing69.s8
  }
}), "getStyles");
var StoreCardCompactAnchor = forwardRef89(
  /* @__PURE__ */ __name(function StoreCardCompactAnchor2(_a, ref) {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    const { anchor } = getStyles77();
    return /* @__PURE__ */ jsx207(StoreCardAnchor, __spreadProps(__spreadValues({ ref, css: anchor }, rest), { children }));
  }, "StoreCardCompactAnchor")
);
StoreCardCompactAnchor.displayName = "StoreCardCompactAnchor";

// src/organisms/StoreRow/StoreRow.tsx
import { forwardRef as forwardRef90 } from "react";
import { jsx as jsx208 } from "@emotion/react/jsx-runtime";
var StoreRow = forwardRef90(/* @__PURE__ */ __name(function TileC4({ children }, ref) {
  const styles25 = {
    container: {}
  };
  return /* @__PURE__ */ jsx208(StoreCardBase, { ref, styles: styles25, children });
}, "TileC"));

// src/organisms/StoreRow/StoreRowETA.tsx
import { combineStyles as combineStyles57, useTheme as useTheme89 } from "@instacart/ids-core";
import { jsx as jsx209 } from "@emotion/react/jsx-runtime";
var getStyles78 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.systemGrayscale70
  })
}), "getStyles");
function StoreRowETA(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme89();
  const { text } = combineStyles57(getStyles78(theme), styles25);
  return /* @__PURE__ */ jsx209("span", __spreadProps(__spreadValues({ css: text }, rest), { children }));
}
__name(StoreRowETA, "StoreRowETA");

// src/organisms/StoreRow/StoreRowChevron.tsx
import {
  combineStyles as combineStyles58,
  useTheme as useTheme90,
  ChevronRightIcon as ChevronRightIcon5,
  spacing as spacing70
} from "@instacart/ids-core";
import { jsx as jsx210 } from "@emotion/react/jsx-runtime";
var getStyles79 = /* @__PURE__ */ __name((theme) => ({
  icon: {
    paddingTop: 2,
    paddingRight: spacing70.s4
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.brandPrimaryRegular
  })
}), "getStyles");
function StoreRowChevron(_a) {
  var _b = _a, { styles: styles25, children, color } = _b, rest = __objRest(_b, ["styles", "children", "color"]);
  const theme = useTheme90();
  const { icon } = combineStyles58(getStyles79(theme), styles25);
  return /* @__PURE__ */ jsx210("span", __spreadProps(__spreadValues({ css: icon }, rest), { children: /* @__PURE__ */ jsx210(ChevronRightIcon5, { size: "20", color: color || "systemGrayscale30" }) }));
}
__name(StoreRowChevron, "StoreRowChevron");

// src/organisms/StoreRow/StoreRowAnchor.tsx
import { forwardRef as forwardRef91 } from "react";
import { spacing as spacing71, useTheme as useTheme91 } from "@instacart/ids-core";
import { jsx as jsx211 } from "@emotion/react/jsx-runtime";
var getStyles80 = /* @__PURE__ */ __name((theme) => ({
  anchor: {
    position: "relative",
    padding: `${spacing71.s12}px ${spacing71.s16}px`,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    }
  }
}), "getStyles");
var StoreRowAnchor = forwardRef91(
  /* @__PURE__ */ __name(function StoreRowAnchor2(_a, ref) {
    var _b = _a, { href, children } = _b, rest = __objRest(_b, ["href", "children"]);
    const theme = useTheme91();
    const { anchor } = getStyles80(theme);
    return /* @__PURE__ */ jsx211(StoreCardAnchor, __spreadProps(__spreadValues({ ref, href, css: anchor }, rest), { children }));
  }, "StoreRowAnchor")
);
StoreRowAnchor.displayName = "StoreRowAnchor";

// src/organisms/StoreRowCompact/StoreRowCompact.tsx
import { forwardRef as forwardRef92 } from "react";
import { jsx as jsx212 } from "@emotion/react/jsx-runtime";
var StoreRowCompact = forwardRef92(/* @__PURE__ */ __name(function TileC5({ children }, ref) {
  const styles25 = {
    container: {}
  };
  return /* @__PURE__ */ jsx212(StoreCardBase, { ref, styles: styles25, children });
}, "TileC"));

// src/organisms/StoreRowCompact/StoreRowCompactETA.tsx
import { combineStyles as combineStyles59, useTheme as useTheme92, spacing as spacing72 } from "@instacart/ids-core";
import { jsx as jsx213 } from "@emotion/react/jsx-runtime";
var getStyles81 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.systemGrayscale70,
    marginBottom: spacing72.s8
  })
}), "getStyles");
function StoreRowCompactETA(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme92();
  const { text } = combineStyles59(getStyles81(theme), styles25);
  return /* @__PURE__ */ jsx213("span", __spreadProps(__spreadValues({ css: text }, rest), { children }));
}
__name(StoreRowCompactETA, "StoreRowCompactETA");

// src/organisms/StoreRowCompact/StoreRowCompactChevron.tsx
import { combineStyles as combineStyles60, useTheme as useTheme93, ChevronRightIcon as ChevronRightIcon6 } from "@instacart/ids-core";
import { jsx as jsx214 } from "@emotion/react/jsx-runtime";
var getStyles82 = /* @__PURE__ */ __name((theme) => ({
  icon: {
    paddingTop: 2
  },
  text: __spreadProps(__spreadValues({
    display: "flex"
  }, theme.typography.bodySmall1), {
    color: theme.colors.brandPrimaryRegular
  })
}), "getStyles");
function StoreRowCompactChevron(_a) {
  var _b = _a, { styles: styles25, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const theme = useTheme93();
  const { icon } = combineStyles60(getStyles82(theme), styles25);
  return /* @__PURE__ */ jsx214("span", __spreadProps(__spreadValues({ css: icon }, rest), { children: /* @__PURE__ */ jsx214(ChevronRightIcon6, { color: "systemGrayscale30", size: "20" }) }));
}
__name(StoreRowCompactChevron, "StoreRowCompactChevron");

// src/organisms/StoreRowCompact/StoreRowCompactAnchor.tsx
import { forwardRef as forwardRef93 } from "react";
import { spacing as spacing73, useTheme as useTheme94 } from "@instacart/ids-core";
import { jsx as jsx215 } from "@emotion/react/jsx-runtime";
var getStyles83 = /* @__PURE__ */ __name((theme) => ({
  anchor: {
    position: "relative",
    padding: `${spacing73.s12}px ${spacing73.s16}px`,
    "&.focus-visible::after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: -4,
      bottom: -4,
      left: -4,
      right: -4,
      border: `2px solid ${theme.colors.systemGrayscale70}`,
      borderRadius: theme.radius.r12
    }
  }
}), "getStyles");
var StoreRowCompactAnchor = forwardRef93(
  /* @__PURE__ */ __name(function StoreRowCompactAnchor2(_a, ref) {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    const theme = useTheme94();
    const { anchor } = getStyles83(theme);
    return /* @__PURE__ */ jsx215(StoreCardAnchor, __spreadProps(__spreadValues({ ref, css: anchor }, rest), { children }));
  }, "StoreRowCompactAnchor")
);
StoreRowCompactAnchor.displayName = "StoreRowCompactAnchor";

// src/organisms/SearchButton/SearchButton.tsx
import { forwardRef as forwardRef94 } from "react";
import { useTheme as useTheme95, spacing as spacing74 } from "@instacart/ids-core";
import { jsx as jsx216 } from "@emotion/react/jsx-runtime";
var getStyles84 = /* @__PURE__ */ __name((theme) => ({
  button: {
    position: "relative",
    width: "100%",
    height: 40,
    border: "none",
    backgroundColor: theme.colors.systemGrayscale10,
    borderRadius: theme.radius.r8,
    alignItems: "center"
  },
  icon: {
    display: "flex",
    marginLeft: "auto",
    marginRight: spacing74.s12
  },
  text: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
    color: theme.colors.systemGrayscale70,
    marginLeft: spacing74.s12,
    // To avoid zoom in to input in iOS Safari
    fontSize: 16
  })
}), "getStyles");
var SearchButton = forwardRef94(/* @__PURE__ */ __name(function SearchButton2(_a, ref) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  const theme = useTheme95();
  const styles25 = getStyles84(theme);
  return /* @__PURE__ */ jsx216(SearchButtonBase, __spreadProps(__spreadValues({ ref, styles: styles25 }, rest), { children }));
}, "SearchButton"));

// src/molecules/CountrySelectTextInput/CountrySelectTextInput.tsx
var CountrySelectTextInput_exports = {};
__export(CountrySelectTextInput_exports, {
  CountrySelectTextInput: () => CountrySelectTextInput
});
import {
  ActionSheetDropdown,
  SheetDropdown,
  SheetDropdownDisclosureBase,
  TextInputBase as TextInputBase4,
  useTheme as useTheme99,
  ChevronDownIcon as ChevronDownIcon5,
  spacing as spacing77,
  ChevronUpIcon as ChevronUpIcon3,
  combineStyles as combineStyles62,
  useAriaLabel
} from "@instacart/ids-core";
import { useState as useState9, Fragment as Fragment4 } from "react";

// src/molecules/CountrySelectTextInput/components/SupportedCountryDropdownItem.tsx
import {
  ActionSheetDropdownItem,
  ActionSheetItemIcon,
  useTheme as useTheme96,
  combineStyles as combineStyles61,
  spacing as spacing75
} from "@instacart/ids-core";
import { forwardRef as forwardRef95 } from "react";
import { jsx as jsx217, jsxs as jsxs30 } from "@emotion/react/jsx-runtime";
var getStyles85 = /* @__PURE__ */ __name((theme) => ({
  countryCallingCodeText: {
    color: theme.colors.systemGrayscale50,
    marginLeft: spacing75.s8
  }
}), "getStyles");
var SupportedCountryDropdownItem = forwardRef95(/* @__PURE__ */ __name(function SupportedCountryDropdownItem2(_a, ref) {
  var _b = _a, { supportedCountry, styles: propStyles } = _b, actionSheetDropdownItemProps = __objRest(_b, ["supportedCountry", "styles"]);
  const theme = useTheme96();
  const { countryCallingCodeText } = combineStyles61(getStyles85(theme), propStyles);
  const { countryCallingCodeString, countryIsoString, countryNameString } = supportedCountry;
  const dropdownItemText = `${countryNameString} ${countryCallingCodeString}`;
  return /* @__PURE__ */ jsxs30(ActionSheetDropdownItem, __spreadProps(__spreadValues({ ref, title: dropdownItemText }, actionSheetDropdownItemProps), { children: [
    /* @__PURE__ */ jsx217(
      ActionSheetItemIcon,
      {
        color: "systemGrayscale50",
        icon: flagIconForCountryIso(countryIsoString)
      }
    ),
    countryNameString,
    /* @__PURE__ */ jsx217("span", { css: countryCallingCodeText, children: countryCallingCodeString })
  ] }));
}, "SupportedCountryDropdownItem"));
SupportedCountryDropdownItem.displayName = "ActionSheetDropdownItem";
var SupportedCountryDropdownItem_default = SupportedCountryDropdownItem;

// src/molecules/CountrySelectTextInput/components/InvalidInputText.tsx
import { useTheme as useTheme97, spacing as spacing76 } from "@instacart/ids-core";
import { jsx as jsx218 } from "@emotion/react/jsx-runtime";
function InvalidInputText({ children, id }) {
  const theme = useTheme97();
  return /* @__PURE__ */ jsx218(
    "p",
    {
      id,
      css: __spreadProps(__spreadValues({
        margin: `0 0 0 ${spacing76.s8}px`
      }, theme.typography.bodySmall2), {
        color: theme.colors.systemDetrimentalRegular
      }),
      children
    }
  );
}
__name(InvalidInputText, "InvalidInputText");
var InvalidInputText_default = InvalidInputText;

// src/molecules/CountrySelectTextInput/hooks/useFocusAndHoverStyles.ts
import { useTheme as useTheme98 } from "@instacart/ids-core";
import { useState as useState8 } from "react";
function useFocusAndHoverStyles({
  invalid,
  hasValue
}) {
  const theme = useTheme98();
  const [dropdownVisible, setDropdownVisible] = useState8(false);
  const [elementIsHovered, setElementIsHovered] = useState8(false);
  const [elementIsFocused, setElementIsFocused] = useState8(false);
  const wholeElementDarkFocus = dropdownVisible || elementIsFocused;
  const wholeElementMediumFocus = elementIsHovered || hasValue;
  const focusStyles = {
    border: "none",
    transition: "box-shadow ease-out 100ms",
    boxShadow: wholeElementDarkFocus ? `0 0 0 2px ${invalid ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale70} !important` : wholeElementMediumFocus ? `0 0 0 1px ${invalid ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale50}` : `0 0 0 1px ${invalid ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale30}`
  };
  const sharedFocusProps = {
    onMouseEnter: () => setElementIsHovered(true),
    onMouseLeave: () => setElementIsHovered(false),
    onFocus: () => setElementIsFocused(true),
    onBlur: () => setElementIsFocused(false)
  };
  const dropdownFocusProps = {
    onDropdownVisible: () => setDropdownVisible(true),
    onDropdownNotVisible: () => setDropdownVisible(false)
  };
  return {
    focusStyles,
    sharedFocusProps,
    dropdownFocusProps,
    dropdownVisible
  };
}
__name(useFocusAndHoverStyles, "useFocusAndHoverStyles");

// src/molecules/CountrySelectTextInput/CountrySelectTextInput.tsx
import { jsx as jsx219, jsxs as jsxs31 } from "@emotion/react/jsx-runtime";
var getStyles86 = /* @__PURE__ */ __name(({ theme, focusStyles, invalid, inheritWidth }) => ({
  countrySelectTextInput: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center"
  },
  button: __spreadProps(__spreadValues({
    padding: `${spacing77.s8}px 6px ${spacing77.s8}px ${spacing77.s12}px`,
    backgroundColor: invalid ? theme.colors.systemDetrimentalLight : theme.colors.systemGrayscale00,
    color: theme.colors.systemGrayscale70,
    borderRadius: `${theme.radius.r12}px 0px 0px ${theme.radius.r12}px`,
    height: 55,
    display: "flex",
    alignItems: "center"
  }, focusStyles), {
    "&:focus": {
      background: theme.colors.systemGrayscale20
    }
  }),
  content: {
    height: "100%",
    display: "flex",
    alignItems: "center"
  },
  focusRing: {
    border: "none"
  },
  wrapper: __spreadProps(__spreadValues({
    borderRadius: `0 ${theme.radius.r12}px ${theme.radius.r12}px 0`
  }, focusStyles), {
    width: inheritWidth ? "inherit" : "unset"
  }),
  dropdown: {
    zIndex: 10
  }
}), "getStyles");
var ERROR_TEXT_ID = "country-select-text-input-invalid-text";
function CountrySelectTextInput({
  inputLabel,
  phoneValue,
  countryCodeValue,
  onPhoneNumberChange,
  onCountryCodeChange,
  supportedCountryList,
  countrySelectLabel,
  invalidText,
  countrySelectDropdownDescription,
  invalid,
  inheritWidth,
  autoComplete,
  onClickSelect,
  describedBy,
  styles: propStyles
}) {
  const theme = useTheme99();
  const { focusStyles, sharedFocusProps, dropdownFocusProps, dropdownVisible } = useFocusAndHoverStyles({
    invalid,
    hasValue: Boolean(phoneValue)
  });
  const styles25 = getStyles86({ theme, focusStyles, invalid, inheritWidth });
  const { countrySelectTextInput: countrySelectTextInputStyles, dropdown } = combineStyles62(
    styles25,
    propStyles
  );
  const [selectedCountry, setSelectedCountry] = useState9(
    supportedCountryList.find((country) => country.countryCallingCodeString === countryCodeValue) || supportedCountryList[0]
  );
  const ariaDescribedBy = useAriaLabel({
    describedByIds: describedBy ? [ERROR_TEXT_ID, describedBy] : [ERROR_TEXT_ID]
  });
  return /* @__PURE__ */ jsxs31(Fragment4, { children: [
    /* @__PURE__ */ jsxs31("div", { css: countrySelectTextInputStyles, children: [
      /* @__PURE__ */ jsxs31(SheetDropdown, { children: [
        /* @__PURE__ */ jsxs31(
          SheetDropdownDisclosureBase,
          __spreadProps(__spreadValues(__spreadValues({
            "aria-label": countrySelectLabel,
            "aria-haspopup": "true",
            role: "combobox",
            "aria-expanded": dropdownVisible,
            styles: { button: styles25.button, content: styles25.content, focusRing: styles25.focusRing }
          }, dropdownFocusProps), sharedFocusProps), {
            onClick: () => onClickSelect == null ? void 0 : onClickSelect(),
            children: [
              /* @__PURE__ */ jsx219("span", { css: __spreadValues({ marginRight: spacing77.s8 }, theme.typography.bodyLarge1), children: selectedCountry.countryCallingCodeString }),
              dropdownVisible ? /* @__PURE__ */ jsx219(ChevronUpIcon3, {}) : /* @__PURE__ */ jsx219(ChevronDownIcon5, {})
            ]
          })
        ),
        /* @__PURE__ */ jsx219(ActionSheetDropdown, { css: dropdown, description: countrySelectDropdownDescription, children: supportedCountryList.map((supportedCountry) => {
          const onSupportedCountryClick = /* @__PURE__ */ __name(() => {
            if (selectedCountry !== supportedCountry) {
              setSelectedCountry(supportedCountry);
              onCountryCodeChange == null ? void 0 : onCountryCodeChange(supportedCountry.countryCallingCodeString);
            }
          }, "onSupportedCountryClick");
          return /* @__PURE__ */ jsx219(
            SupportedCountryDropdownItem_default,
            {
              supportedCountry,
              onClick: onSupportedCountryClick
            },
            `${supportedCountry.countryNameString}`
          );
        }) })
      ] }),
      /* @__PURE__ */ jsx219(
        TextInputBase4,
        __spreadValues(__spreadProps(__spreadValues({
          styles: { wrapper: styles25.wrapper }
        }, sharedFocusProps), {
          value: phoneValue,
          label: inputLabel,
          invalid,
          type: "tel",
          onChange: onPhoneNumberChange,
          autoComplete
        }), ariaDescribedBy)
      )
    ] }),
    invalid && /* @__PURE__ */ jsx219(InvalidInputText_default, { id: ERROR_TEXT_ID, children: invalidText })
  ] });
}
__name(CountrySelectTextInput, "CountrySelectTextInput");
export {
  AVATAR_BORDER_PX,
  AddItem,
  AddItemButton,
  AddItemButtonBase,
  AddItemExpanded,
  AddItemExpandedDisclaimer,
  AddItemExpandedUnit,
  AddItemStepperBase,
  AdvertiserAvatarLarge,
  AdvertiserAvatarMedium,
  AdvertiserAvatarSmall,
  AuthorAvatarLarge,
  AuthorAvatarMedium,
  AuthorAvatarSmall,
  AvatarBase,
  BORDER_WIDTH2 as BORDER_WIDTH,
  BasicIconInput,
  ButtonCompactBase,
  ButtonPill2 as ButtonPill,
  ButtonPillBase,
  ButtonSmallBase,
  CartButton,
  CartButtonBase,
  CategoryTab,
  CategoryTabList,
  CategoryTabPanel,
  CategoryTabs,
  Center,
  CouponClipButton,
  CriticalServiceMessageA2 as CriticalServiceMessageA,
  DetrimentalButton,
  DetrimentalButtonCompact,
  DetrimentalButtonSmall,
  Divider,
  GroupCartButton,
  GroupCartButtonBase,
  IconButton,
  InlineTextButton,
  InstacartPlusButton,
  InstacartPlusButtonCompact,
  InstacartPlusButtonSmall,
  ItemA,
  ItemAttribute,
  ItemAttributeBase,
  ItemB3 as ItemB,
  ItemBase,
  ItemC3 as ItemC,
  ItemD3 as ItemD,
  ItemDynamicLabel,
  ItemDynamicLabelBase,
  ItemImage,
  ItemImageBase,
  ItemLink,
  ItemLinkBase,
  ItemName,
  ItemNameBase,
  ItemPrice,
  ItemPriceBase,
  ItemPriceSet,
  ItemPriceSetBase,
  ItemRegularPrice,
  ItemRegularPriceBase,
  ItemSalePrice,
  ItemWeight,
  ItemWeightBase,
  ItemXL3 as ItemXL,
  Left4 as Left,
  Link,
  LinkPill,
  LoadingLockupIconRowLayout,
  LoadingLockupImageRowLayout,
  LoadingLockupItemGridLayout,
  LoadingLockupItemListLayout,
  LoadingLockupTextRowLayout,
  LockupB,
  LockupD,
  Marker,
  MarkerBase,
  MarkerChip,
  MarkerIconLeft,
  MarkerIconRight,
  MaxBadge,
  ModalAutosize,
  ModalBase,
  ModalContent,
  ModalContentBase,
  ModalFixedSize,
  ModalFooter,
  ModalFooterBase,
  ModalFooterNoShadow,
  ModalHeader,
  ModalHeaderBase,
  ModalInnerWrapper,
  ModalTitle,
  ModalTitleBase,
  MultiSelectListOption,
  MultiSelectListOptionBase,
  PrimaryButton,
  PrimaryButtonCompact,
  PrimaryButtonSmall,
  PrimaryPriceButton,
  PromotionModal,
  PromotionModalBody,
  PromotionModalButtons,
  PromotionModalDescription,
  PromotionModalImage,
  PromotionModalSubtitle,
  PromotionModalTitle,
  RadioButtonGroup,
  RadioButtonGroupBase,
  RadioButtonGroupWrap,
  RadioPill,
  RadioPillBase,
  RetailerAvatarLarge,
  RetailerAvatarMedium,
  RetailerAvatarSmall,
  RetailerLogoIcon,
  SearchButton,
  SearchButtonBase,
  SecondaryButton,
  SecondaryButtonCompact,
  SecondaryButtonSmall,
  Select,
  SelectBase,
  SelectButton,
  SelectButtonBase,
  SelectButtonLabel,
  SelectButtonLabelBase,
  SelectButtonValue,
  SelectButtonValueBase,
  SelectMenu,
  SelectMenuButton,
  SelectMenuContext,
  SelectMenuDropdown,
  SelectMenuFooter,
  SelectMenuFooterButton,
  SelectMenuList,
  SelectOption,
  SelectOptionBase,
  SelectOptions,
  SelectOptionsBase,
  ServiceMessageA3 as ServiceMessageA,
  ServiceMessageBase,
  ServiceMessageButtonBase,
  ServiceMessageCloseButton,
  ServiceMessageDescriptionBase,
  ServiceMessageInfoBase,
  ServiceMessageMoreButton,
  SingleLineTextInput2 as SingleLineTextInput,
  SingleLineTextInputDark,
  SingleSelectOption,
  SingleSelectSubOption,
  SingleSelectViewMoreButton,
  Size,
  StepperBase,
  StoreCard,
  StoreCardAnchor,
  StoreCardAttributes,
  StoreCardBase,
  StoreCardCenter,
  StoreCardCenterFooter,
  StoreCardCompact,
  StoreCardCompactAnchor,
  StoreCardETA,
  StoreCardFooter,
  StoreCardImage,
  StoreCardImageList,
  StoreCardRight,
  StoreCardTag,
  StoreCardTitle,
  StoreRow,
  StoreRowAnchor,
  StoreRowChevron,
  StoreRowCompact,
  StoreRowCompactAnchor,
  StoreRowCompactChevron,
  StoreRowCompactETA,
  StoreRowETA,
  TertiaryButton,
  TertiaryButtonCompact,
  TertiaryButtonSmall,
  TextAreaDynamic,
  TextAreaFixed,
  TextButton,
  TileAnchor,
  TileBase,
  TileC,
  TileImage,
  TileTitle,
  Tooltip,
  buttonSizeStyles,
  flagIconForCountryIso,
  getStyles48 as getStyles,
  CountrySelectTextInput_exports as unstableCountrySelectTextInput,
  ServiceMessageA_exports as unstableServiceMessageA,
  useModalDisclosure,
  useModalState,
  useSelect,
  useSelectMenuContext,
  useSharedButtonStyles,
  useTabState
};
